var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// ReSharper disable InconsistentNaming
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var Constants = /** @class */ (function () {
            function Constants() {
            }
            Constants.FULL_CALENDAR_PREMIUM_LICENSE = '0194430006-fcs-1560406752';
            Constants.DEFAULT_PAGINATION_SIZE = 30;
            Constants.GUID_EMPTY = "00000000-0000-0000-0000-000000000000";
            Constants.DEFAULT_NAV_ID = "be5944c2-2a62-4aef-b747-d298971505e8";
            Constants.OBJECTTYPE_CLIENT = 140000;
            Constants.OBJECTTYPE_EMPLOYEE = 120000;
            Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID = "2c4be6f5-2c40-4c1e-abb0-08334e5178f4";
            Constants.SHOW_ALL_EMPLOYEES_PREDEFINED_SEARCH_ID = "1655659a-5e10-4a1f-b6c6-e69cb74b64c7";
            Constants.DEFAULT_ACTIVITY_ID = "bcafd3ce-f25c-410a-a623-75c77eb15d5c";
            Constants.MESSAGE_INBOX_FOLDER_ID = "fc52cc92-ee6e-48da-b42d-a8111af27686";
            Constants.MESSAGE_SENT_FOLDER_ID = "09aa8d37-065f-444a-a9fa-94d59dc2c125";
            Constants.MESSAGE_RECYCLEBIN_FOLDER_ID = "5f6720c1-ff53-48aa-bda9-a82c10781fe3";
            Constants.DEFAULT_CLIENT_PREDEFINED_SEARCH_ID = "27a653ff-299e-41a4-bc31-973b36ab373e"; // "Meine Betreuten"
            Constants.DEFAULT_COUNTRY_ID = "e8dfa43c-c3d4-408d-87d8-7bf9ccdb0ab7"; // Germany
            Constants.DEFAULT_DISEASE_CODE_SCHEMA = "37783beb-d174-4be4-9394-1ded6328faa4";
            Constants.DEMAND_MEDICATION = "0f11f2ef-8d2b-452f-ac2e-632143fec211";
            Constants.IS_MOBILE = $('body').hasClass('mobile');
            Constants.DELETE_REASON_ID = "4905ca15-8437-40bf-8875-4c2f2572057c";
            Constants.EXECUTION_TYPE_SINGLE_ID = "a1ac6cb3-56a7-454a-a7eb-d9adabf8989d";
            Constants.EXECUTION_TYPE_MULTIPLE_ID = "dd8d8de1-b0f3-4fd6-abf0-1cd1cbd2716a";
            Constants.APPROVAL_PENDING_ID = "efd58886-58e4-4562-adcb-27e677167767"; // steht aus
            Constants.APPROVAL_APRROVED_ID = "a8d072b9-8cdb-4e91-810b-df609c6946c3"; // genehmigt
            Constants.JOURNAL_COMMENTTYPE_NORMAL = 'b22fa7fc-8d14-4ae1-8483-729c5df12c07';
            Constants.JOURNAL_COMMENTTYPE_WARNING = '7d1d5043-fe48-4b93-be38-c2bfd8e41d08';
            Constants.SIGNATURE_SIGNING_PERSON_CLIENT = 'd69838db-7965-4df9-9723-b6032ab6f2e8';
            Constants.WV_DOCUMENT_RUBRIC = "02fed28c-33c0-42fe-9b45-d815eb1acccc";
            Constants.WV_YES = "6b1eeda2-f346-4366-b5b4-6d3576e35991";
            Constants.WV_NO = "a1219cb4-18bb-4232-93ee-44a335d39d9a";
            Constants.SMARTACTIONCACHE = 'SmartActionCache';
            Constants.FLS_NO_MISCONTACT = 'e7f1e265-8950-4c2a-9a27-4c4d59bd3f35';
            return Constants;
        }());
        Common.Constants = Constants;
        var UserSettingConstantsAndDefaults = /** @class */ (function () {
            function UserSettingConstantsAndDefaults() {
            }
            UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL = false;
            UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA_KEY = 'GLOBAL.SHOULDLOADTABLEDATA';
            UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA = true;
            // AZN
            UserSettingConstantsAndDefaults.SHOWDATETOAZN = false;
            //FLS
            UserSettingConstantsAndDefaults.ALLOWEMPTYREPORTS = false;
            UserSettingConstantsAndDefaults.PLANEDRAWDAYS = 30;
            UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE = 14;
            UserSettingConstantsAndDefaults.SHOWDATETOFLS = false;
            UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS = true;
            UserSettingConstantsAndDefaults.SIGNATUREHIDEREPORTS = false;
            UserSettingConstantsAndDefaults.SIGNATUREDIRECTSIGN = false;
            UserSettingConstantsAndDefaults.FLSMINUTESTOSIGN = -1;
            UserSettingConstantsAndDefaults.FLSWEEKPLANNERSHOWHOLIDAY = false;
            UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN = true;
            UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX = false;
            UserSettingConstantsAndDefaults.GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG = true;
            UserSettingConstantsAndDefaults.DEFAULTFLSCARETYPE = Constants.GUID_EMPTY;
            UserSettingConstantsAndDefaults.DEFAULTFLSCONTACTTYPE = Constants.GUID_EMPTY;
            UserSettingConstantsAndDefaults.DEFAULTSIGNINGPERSON = 'd69838db-7965-4df9-9723-b6032ab6f2e8';
            UserSettingConstantsAndDefaults.DEFAULTSIGNINGREASON = Constants.GUID_EMPTY;
            UserSettingConstantsAndDefaults.FLS_WEEKPLANNER_INCLUDE_FUTURE_CASES = false;
            UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY = 'FLS.CASELIST.FILTER';
            UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS = { carerTypeFilterId: Constants.GUID_EMPTY, onlyCurrentCases: true };
            // SECURITY
            UserSettingConstantsAndDefaults.INACTIVITYTIMEOUT = 30;
            // TASK
            UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS = 30;
            UserSettingConstantsAndDefaults.LANDINGPAGE = "dashboard";
            UserSettingConstantsAndDefaults.NAVIGATION_DEFAULT_ID = 'be5944c2-2a62-4aef-b747-d298971505e8';
            // ROSTER
            UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE = true;
            //TIME CLOCK
            UserSettingConstantsAndDefaults.INQUIRE_STAMPIN_ON_LOGIN = false;
            UserSettingConstantsAndDefaults.INQUIRE_STAMPOUT_ON_LOGOUT = false;
            //REPORTING
            UserSettingConstantsAndDefaults.DAYSINPAST = 7;
            UserSettingConstantsAndDefaults.SHOWONLYUNFETCHED = false;
            UserSettingConstantsAndDefaults.SERVERJOBTIMERINTERVALLINSEC = 120;
            return UserSettingConstantsAndDefaults;
        }());
        Common.UserSettingConstantsAndDefaults = UserSettingConstantsAndDefaults;
        var LocalStorageConstants = /** @class */ (function () {
            function LocalStorageConstants() {
            }
            // General
            LocalStorageConstants.LAST_LANGUAGE_SELECTION = "LastLanguageSelection";
            LocalStorageConstants.USER_MODULE_PERMISSIONS = "UserModulePermissions";
            // Fls Documentation
            LocalStorageConstants.FLS_DOCU_LIST_FILTER_DATE_FROM = "FlsDocuFilterDateFrom";
            LocalStorageConstants.FLS_DOCU_LIST_FILTER_DATE_TO = "FlsDocuFilterDateTo";
            LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE = "FlsDocuHideSignature";
            LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED = "FlsDocuShowOnlyOwnCreated";
            LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES = "FlsDocuShowOnlyOwnCases";
            LocalStorageConstants.FLS_PREVIOUS_STATE = "FlsPreviousState";
            // Fls Summary
            LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING = "FlsSummaryOrderAscending";
            LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH = "FlsSummaryLastSearch";
            // Internal messages
            LocalStorageConstants.MSG_LIST_FILTER_DATE_FROM = "MsgFilterDateFrom";
            LocalStorageConstants.MSG_LIST_FILTER_DATE_TO = "MsgFilterDateTo";
            // Journal
            LocalStorageConstants.JOURNAL_FILTER_DISPLAY_DATE = "JournalFilterDisplayDate";
            LocalStorageConstants.JOURNAL_LAST_SELECTED_ID = "JournalLastSelectedId";
            LocalStorageConstants.JOURNAL_FILTER_PRIORITY_WV_ID = "JournalFilterPriorityWvId";
            LocalStorageConstants.JOURNAL_FILTER_LIVING_AREA_WV_ID = "JournalFilterLivingAreaWvId";
            LocalStorageConstants.JOURNAL_FILTER_COMMENT = "JournalfFilterComment";
            LocalStorageConstants.JOURNAL_FILTER_AUTHOR = "JournalfFilterAuthor";
            LocalStorageConstants.JOURNAL_FILTER_MARKINGS = "JournalfFilterMarking";
            LocalStorageConstants.JOURNAL_FILTER_PARTICIPANT = "JournalfFilterParticipant";
            LocalStorageConstants.JOURNAL_FILTER_COMMENTS = "JournalfFilterCommentsDescending";
            LocalStorageConstants.JOURNAL_USE_CURRENT_DATE = "False";
            // Task
            LocalStorageConstants.TASK_LIST_HIDE_FINISHED = "TaskListHideFinished";
            // Appointment
            LocalStorageConstants.APPOINTMENT_TYPES_TO_SHOW = "AppointmentTypesToShow";
            // Organisation
            LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID = "OrganisationLastSelectedId";
            //Client Cover Pake
            LocalStorageConstants.CLIENT_COVER = "ClientCover";
            //AZN
            LocalStorageConstants.AZN_PREVIOUS_STATE = "AznPreviousState";
            //Weekplanner
            LocalStorageConstants.WEEKPLANNER_SCROLLPOSITION = "WeekplannerScrollPosition";
            return LocalStorageConstants;
        }());
        Common.LocalStorageConstants = LocalStorageConstants;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
// ReSharper restore InconsistentNaming
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        ;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var HttpBaseProvider = /** @class */ (function () {
            function HttpBaseProvider() {
            }
            HttpBaseProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpBaseProvider;
        }());
        Common.HttpBaseProvider = HttpBaseProvider;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var Resolve = /** @class */ (function () {
            function Resolve() {
                console.log('RESOLVE');
                return;
            }
            return Resolve;
        }());
        Common.Resolve = Resolve;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var BaseService = /** @class */ (function () {
            /**
             * Creates an instance of BaseService.
             * @param {ng.IHttpService} $http
             * @param {ng.IQService} $q
             *
             * @memberOf BaseService
             */
            function BaseService($http, $q) {
                var _a, _b;
                this.$http = $http;
                this.$q = $q;
                this.MAX_RETRIES = (_b = (_a = $('#session').data()) === null || _a === void 0 ? void 0 : _a.retries) !== null && _b !== void 0 ? _b : 5;
                this.loggingOut = false;
                this.isLoggedIn = false;
                this.isRefreshing = false;
                var data = $('#session').data();
                this.apiData = { url: data.api, key: data.apiKey, refresh: data.apiRefreshKey };
                if (!sessionStorage.getItem("started")) {
                    sessionStorage.clear();
                    this.setApiData(this.apiData.key, this.apiData.refresh);
                    sessionStorage.setItem("started", "true");
                }
                this.webClientBasePath = data.baseUrl;
                this.loggingOut = false;
            }
            /**
             *
             *
             * @private
             * @param {any} response
             * @param {any} status
             * @returns
             *
             * @memberOf BaseService
             */
            BaseService.prototype.notification = function (response, status) {
                if (!this.isLoggedIn || this.loggingOut)
                    return;
                console.warn("Error", response);
                if (response.data == null && status !== 401) {
                    this.displayNotifications(["Ein Kommunikationsfehler ist aufgetreten"], "Fehler", "warning", "qm-icon-error");
                }
                var data = response.data;
                if (data == (null || undefined))
                    return;
                if (data.hasOwnProperty("globalErrors")) {
                    this.displayNotifications(this.formatErrors(response, data.globalErrors), "Fehler", "warning", "qm-icon-error");
                }
                if (data.hasOwnProperty("fieldErrors")) {
                    this.displayNotifications(this.formatErrors(response, data.fieldErrors), "Hinweis", "warning", "qm-icon-information");
                }
                if (data.hasOwnProperty("GlobalErrors")) {
                    this.displayNotifications(this.formatErrors(response, data.GlobalErrors), "Fehler", "warning", "qm-icon-error");
                }
                if (data.hasOwnProperty("FieldErrors")) {
                    this.displayNotifications(this.formatErrors(response, data.FieldErrors), "Hinweis", "warning", "qm-icon-information");
                }
            };
            BaseService.prototype.formatErrors = function (response, errorList) {
                var result = [];
                if (!response || !errorList)
                    return [];
                for (var pro in errorList) {
                    if (typeof errorList[pro] === 'object') {
                        result = result.concat(errorList[pro]);
                    }
                }
                for (var _i = 0, errorList_1 = errorList; _i < errorList_1.length; _i++) {
                    var element = errorList_1[_i];
                    result.push(response.statusText + ": " + element);
                }
                return result;
            };
            /**
             * displayNotifications
             *
             * @private
             * @param {any} arr
             * @param {any} title
             * @param {any} type
             * @param {any} icon
             *
             * @memberOf BaseService
             */
            BaseService.prototype.displayNotifications = function (arr, title, type, icon) {
                var $qui = new qmwcUI();
                if (arr !== null) {
                    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                        var element = arr_1[_i];
                        console.log(element);
                        var message = element.replace('Bad Request: ', '');
                        var errorNote = {
                            message: message,
                            title: title,
                            icon: icon,
                            status: type,
                            timer: 10000
                        };
                        $qui.notify(errorNote);
                    }
                }
            };
            BaseService.prototype.api = function () {
                return this.apiData;
            };
            BaseService.prototype.logout = function (noReturn) {
                if (noReturn === void 0) { noReturn = false; }
                if (this.loggingOut)
                    return;
                var hash = "";
                if (location.hash.length > 1 && !noReturn)
                    hash = location.hash.substr(2);
                this.loggingOut = true;
                var url = this.webClientBasePath + "Logout?returnUrl=" + hash;
                var dbConnection = $('#session').data().dbConnection;
                if (url.indexOf('dbConnectionString') < 0 && dbConnection)
                    url = url + (url.indexOf('?') ? '&' : '?') + 'dbConnectionString=' + dbConnection;
                sessionStorage.clear();
                location.href = url;
                document.getElementById("load-placeholder").removeAttribute("style");
                document.getElementById("wrapper").setAttribute("style", "display: none;");
            };
            BaseService.prototype.get = function (path, params, successDataManipulation) {
                if (params === void 0) { params = {}; }
                return this.performGetRequest(false, path, params, successDataManipulation);
            };
            BaseService.prototype.getPagination = function (path, params, successDataManipulation) {
                if (params === void 0) { params = {}; }
                return this.performGetRequest(false, path, params, successDataManipulation);
            };
            BaseService.prototype.getItem = function (path, params, successDataManipulation) {
                if (params === void 0) { params = {}; }
                return this.performGetRequest(false, path, params, successDataManipulation);
            };
            BaseService.prototype.cachedGetItem = function (path, params, successDataManipulation) {
                if (params === void 0) { params = {}; }
                return this.performGetRequest(true, path, params, successDataManipulation);
            };
            ;
            BaseService.prototype.uncachedGet = function (path, params, successDataManipulation) {
                if (params === void 0) { params = {}; }
                return this.performGetRequest(false, path, params, successDataManipulation);
            };
            BaseService.prototype.cachedGet = function (path, params, successDataManipulation) {
                if (params === void 0) { params = {}; }
                return this.performGetRequest(true, path, params, successDataManipulation);
            };
            BaseService.prototype.performGetRequest = function (cached, path, params, successDataManipulation, retries, deferred) {
                var _this = this;
                if (params === void 0) { params = {}; }
                if (retries === void 0) { retries = 1; }
                if (deferred === void 0) { deferred = this.$q.defer(); }
                var token = this.getAccessToken();
                if (this.loggingOut) {
                    deferred.reject("logging out");
                    return deferred.promise;
                }
                if (this.isRefreshing) {
                    setTimeout(function () {
                        deferred.promise = _this.performGetRequest(cached, path, params, successDataManipulation);
                    }, this.getMissedCallCounter() * 250);
                }
                else {
                    this.$http({
                        url: this.apiData.url + path,
                        method: 'GET',
                        cache: cached,
                        headers: { 'Authorization': "Bearer " + token },
                        params: params
                    }).then(function (response) {
                        if (response.status === 944) {
                            _this.setMissedCallCounter(999);
                            _this.logout();
                            return;
                        }
                        if (response.status === 401) {
                            _this.tryRefresh();
                            deferred.promise = _this.performGetRequest(cached, path, params, successDataManipulation);
                            return;
                        }
                        if (successDataManipulation)
                            response.data = successDataManipulation(response.data);
                        deferred.resolve(response.data);
                        _this.isLoggedIn = true;
                        if (path.indexOf('languages') === -1 && !_this.loggingOut) {
                            document.getElementById("wrapper").removeAttribute("style");
                            document.getElementById("load-placeholder").setAttribute("style", "display: none;");
                            if (window.location.hash.includes('hideNav=true')) {
                                $('#qmw-top-nav').hide();
                                $('#qmc-side-nav').hide();
                                $('#version-footer').hide();
                                $('body').addClass('hideNav');
                            }
                        }
                    }).catch(function (response) {
                        console.log("error in base service:", response);
                        if (response.status === 944) {
                            _this.setMissedCallCounter(999);
                            _this.logout();
                            return;
                        }
                        if (response.status === 401) {
                            _this.tryRefresh();
                            deferred.promise = _this.performGetRequest(cached, path, params, successDataManipulation);
                        }
                        if (retries < _this.MAX_RETRIES)
                            _this.performGetRequest(cached, path, params, successDataManipulation, retries + 1, deferred);
                        else {
                            _this.notification(response, response.status);
                            deferred.reject(response.data == (null || undefined || "") ? response.status : response.data);
                        }
                    });
                }
                return deferred.promise;
            };
            BaseService.prototype.post = function (path, object, retries, deferred) {
                var _this = this;
                if (retries === void 0) { retries = 1; }
                if (deferred === void 0) { deferred = this.$q.defer(); }
                var token = this.getAccessToken();
                if (this.loggingOut) {
                    deferred.reject("logging out");
                    return deferred.promise;
                }
                if (this.isRefreshing) {
                    setTimeout(function () {
                        deferred.promise = _this.post(path, object);
                    }, this.getMissedCallCounter() * 250);
                }
                else {
                    this.$http({
                        url: this.apiData.url + path,
                        method: 'POST',
                        headers: { 'Authorization': "Bearer " + token },
                        data: object
                    }).then(function (response) {
                        if (response.status === 201 || response.status === 200) {
                            deferred.resolve(response.data);
                        }
                        else {
                            console.log("status code:", response.status);
                            if (response.status === 401) {
                                _this.tryRefresh();
                                deferred.promise = _this.post(path, object);
                                return;
                            }
                            if (response.status === 944) {
                                _this.setMissedCallCounter(999);
                                _this.logout();
                            }
                            deferred.reject(response.data);
                        }
                    }).catch(function (response) {
                        if (response.status === 401) {
                            _this.tryRefresh();
                            deferred.promise = _this.delete(path);
                            return;
                        }
                        if (response.status === 944) {
                            _this.setMissedCallCounter(999);
                            _this.logout();
                        }
                        if (retries < _this.MAX_RETRIES)
                            _this.post(path, object, retries + 1, deferred);
                        else {
                            _this.notification(response, response.status);
                            deferred.reject(response.data);
                        }
                    });
                }
                return deferred.promise;
            };
            BaseService.prototype.put = function (path, object) {
                return this.putParameter(path, null, object);
            };
            BaseService.prototype.putParameter = function (path, params, object, retries, deferred) {
                var _this = this;
                if (params === void 0) { params = {}; }
                if (retries === void 0) { retries = 1; }
                if (deferred === void 0) { deferred = this.$q.defer(); }
                var token = this.getAccessToken();
                if (this.loggingOut) {
                    deferred.reject("logging out");
                    return deferred.promise;
                }
                if (this.isRefreshing) {
                    setTimeout(function () {
                        deferred.promise = _this.putParameter(path, params, object);
                    }, this.getMissedCallCounter() * 250);
                }
                else {
                    this.$http({
                        url: this.apiData.url + path,
                        method: 'PUT',
                        headers: { 'Authorization': "Bearer " + token },
                        data: object,
                        params: params
                    }).then(function (response) {
                        if (response.status === 200) {
                            deferred.resolve(response.data);
                        }
                        else {
                            if (response.status === 401) {
                                _this.tryRefresh();
                                deferred.promise = _this.put(path, params);
                                return;
                            }
                            if (response.status === 944) {
                                _this.setMissedCallCounter(999);
                                _this.logout();
                            }
                            deferred.reject(response.data);
                        }
                    }).catch(function (response) {
                        if (response.status === 401) {
                            _this.tryRefresh();
                            deferred.promise = _this.delete(path);
                            return;
                        }
                        if (response.status === 944) {
                            _this.setMissedCallCounter(999);
                            _this.logout();
                        }
                        if (retries < _this.MAX_RETRIES)
                            _this.putParameter(path, params, object, retries + 1, deferred);
                        else {
                            _this.notification(response, response.status);
                            deferred.reject(response.data);
                        }
                    });
                }
                return deferred.promise;
            };
            BaseService.prototype.delete = function (path, retries, deferred) {
                var _this = this;
                if (retries === void 0) { retries = 1; }
                if (deferred === void 0) { deferred = this.$q.defer(); }
                if (this.loggingOut) {
                    deferred.reject("logging out");
                    return deferred.promise;
                }
                if (this.isRefreshing) {
                    setTimeout(function () {
                        deferred.promise = _this.delete(path);
                    }, this.getMissedCallCounter() * 250);
                }
                else {
                    var token = this.getAccessToken();
                    this.$http({
                        url: this.apiData.url + path,
                        method: 'DELETE',
                        headers: { 'Authorization': "Bearer " + token }
                    }).then(function (response) {
                        if (response.status === 200) {
                            deferred.resolve(response.data);
                        }
                        else {
                            if (response.status === 401) {
                                _this.tryRefresh();
                                deferred.promise = _this.delete(path);
                                return;
                            }
                            if (response.status === 944) {
                                _this.setMissedCallCounter(999);
                                _this.logout();
                            }
                            deferred.reject(response.data);
                        }
                    }).catch(function (response) {
                        if (response.status === 401) {
                            _this.tryRefresh();
                            deferred.promise = _this.delete(path);
                            return;
                        }
                        if (response.status === 944) {
                            _this.setMissedCallCounter(999);
                            _this.logout();
                        }
                        if (retries < _this.MAX_RETRIES)
                            _this.delete(path, retries + 1, deferred);
                        else {
                            _this.notification(response, response.status);
                            deferred.reject(response.data);
                        }
                    });
                }
                return deferred.promise;
            };
            BaseService.prototype.renewToken = function () {
                var _this = this;
                var deferred = this.$q.defer();
                var token = this.getRefreshToken();
                if (!(token === null || token === void 0 ? void 0 : token.length))
                    deferred.reject();
                if (this.isRefreshing) {
                    deferred.resolve("");
                    return deferred.promise;
                }
                this.isRefreshing = true;
                this.$http({
                    url: this.apiData.url + "/session",
                    method: 'PUT',
                    data: '{refreshToken: "' + token + '"}'
                }).then(function (response) {
                    if (response.status === 200 && response.data.accessToken && response.data.refreshToken) {
                        _this.setApiData(response.data.accessToken, response.data.refreshToken);
                        deferred.resolve({ accessKey: response.data.accessToken, refreshKey: response.data.refreshToken });
                    }
                    else {
                        deferred.resolve("ERROR");
                        sessionStorage.clear();
                        _this.logout();
                    }
                    _this.isRefreshing = false;
                }).catch(function () {
                    sessionStorage.clear();
                    deferred.resolve("ERROR");
                    _this.isRefreshing = false;
                    _this.logout();
                });
                return deferred.promise;
            };
            BaseService.prototype.setApiData = function (accessToken, refreshToken) {
                sessionStorage.setItem('accessToken', accessToken);
                sessionStorage.setItem('refreshToken', refreshToken);
                document.getElementById("session").setAttribute("data-api-key", accessToken);
                document.getElementById("session").setAttribute("data-api-refresh-key", refreshToken);
                this.apiData.refresh = refreshToken;
                this.apiData.key = accessToken;
            };
            BaseService.prototype.getRefreshToken = function () {
                var result = sessionStorage.getItem("refreshToken");
                if (result == null || result.trim() === "" || result.trim() === 'error="invalid_token"') {
                    result = $('#session').data().apiKey;
                }
                return result;
            };
            BaseService.prototype.getAccessToken = function () {
                var result = sessionStorage.getItem("accessToken");
                if (result == null || result.trim() === "" || result.trim() === 'error="invalid_token"') {
                    result = $('#session').data().apiRefreshKey;
                }
                return result;
            };
            BaseService.prototype.getResourceList = function (searchString, onlyActive) {
                if (searchString === void 0) { searchString = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                return this.get('/Resource', { searchString: searchString, onlyActive: onlyActive }, function (data) {
                    return data;
                });
            };
            BaseService.prototype.getInstituteList = function (searchString, onlyActive) {
                if (searchString === void 0) { searchString = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                return this.get('/Institute', { searchString: searchString, onlyActive: onlyActive }, function (data) {
                    return data;
                });
            };
            BaseService.prototype.tryRefresh = function () {
                var _this = this;
                this.setMissedCallCounter(this.getMissedCallCounter() + 1);
                if (this.getMissedCallCounter() >= 20) {
                    this.setMissedCallCounter(0);
                    this.logout();
                }
                if (!this.isRefreshing) {
                    this.renewToken().then(function (response) {
                        _this.setMissedCallCounter(0);
                        if (response === "ERROR") {
                            _this.logout();
                        }
                    });
                }
            };
            BaseService.prototype.getMissedCallCounter = function () {
                var value = sessionStorage.getItem("missedCallCounter");
                if (value === undefined || value === null)
                    value = "0";
                return parseInt(value);
            };
            BaseService.prototype.setMissedCallCounter = function (value) {
                sessionStorage.setItem("missedCallCounter", value.toString());
            };
            BaseService.prototype.getVehicleList = function (searchString) {
                if (searchString === void 0) { searchString = ""; }
                return this.get('/Resource/Vehicle', { listSearch: searchString }, function (data) {
                    return data;
                });
            };
            BaseService.$inject = ['$http', '$q'];
            return BaseService;
        }());
        Common.BaseService = BaseService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var UserInterface = /** @class */ (function () {
            /**
             * Creates an instance of UserInterface.
             *
             * @memberOf UserInterface
             */
            function UserInterface() {
                this.successNote = {
                    message: "Eintrag wurde gespeichert!",
                    title: "Erfolgreich",
                    icon: "qm-icon-information",
                    status: "default",
                    timer: 3500
                };
                this.deleteNote = {
                    message: "Eintrag wurde gelöscht!",
                    title: "Erfolgreich",
                    icon: "qm-icon-delete",
                    status: "warning",
                    timer: 3500
                };
                this.deleteNotes = {
                    message: "Einträge wurden gelöscht!",
                    title: "Erfolgreich",
                    icon: "qm-icon-delete",
                    status: "warning",
                    timer: 3500
                };
                this.downloadNote = {
                    message: "Download wird vorbereitet!",
                    title: "Bitte warten",
                    icon: "qm-icon-information",
                    status: "default",
                    timer: 3500
                };
                this.promptOptions = {
                    delete: {
                        title: "Termine",
                        icon: "qm-icon-calendar_7",
                        text: 'Wollen Sie den Eintrag wirklich löschen?'
                    },
                    updateCalendar: {
                        title: "Serientermin",
                        icon: "qm-icon-calendar_7",
                        text: 'Serientermin bearbeiten',
                        fields: [{ select: ["a", "b"] }]
                    }
                };
            }
            /**
             *
             *
             * @protected
             * @returns {boolean}
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.isMobile = function () { return QMC.Common.Constants.IS_MOBILE; };
            ;
            /**
                             * Returns a qmc calendar event which can be shown in the calendar
                             * @param appointment The appointment object
                             */
            UserInterface.prototype.createCalendarEvent = function (appointment, randomId, typeDefaults) {
                if (randomId === void 0) { randomId = null; }
                if (typeDefaults === void 0) { typeDefaults = []; }
                var event = {};
                event.id = appointment.objectId;
                event.objectId = appointment.objectId;
                event.dateFrom = moment(appointment.dateFrom).format('YYYY-MM-DD');
                event.mid = appointment.mainAppointmentId;
                event.title = appointment.title;
                event.description = appointment.description;
                event.start = moment(appointment.dateFrom);
                event.end = moment(appointment.dateTo);
                event.participantObjectId = appointment.participantObjectId;
                event.allDay = appointment.isAllDay;
                event.isFinished = appointment.isFinished;
                event.isPrivate = appointment.isPrivate;
                event.isRecurring = appointment.isRecurring;
                event.recurrenceSettings = appointment.recurrenceSettings;
                event.isTypeAppointment = appointment.isTypeAppointment;
                event.isTypeFlsDocumentation = appointment.isTypeFlsDocumentation;
                event.appointmentType = appointment.appointmentTypeId;
                event.mainAppointmentId = appointment.mainAppointmentId;
                event.isTypeTask = appointment.isTypeTask;
                event.editable = false;
                event.color = appointment.colorHtml;
                event.className = "col-" + appointment.colorHtml.replace('#', '');
                event.iconCode = "";
                event.textColor = this.getTextColor(appointment.colorHtml);
                event.permissions = appointment.permissions;
                event.permFlag = appointment.permFlag;
                if (event.isFinished)
                    event.iconCode += "<i class='qm-icon-check'></i> ";
                if (event.isPrivate)
                    event.iconCode += "<i class='qm-icon-lock'></i> ";
                if (event.isRecurring)
                    event.iconCode += "<i class='fa fa-refresh'></i> ";
                if (event.isDeleted)
                    event.iconCode += "<i class='qm-icon-garbage_can'></i> ";
                if (appointment.appointmentTypeId === 401000)
                    event.editable = true;
                if (appointment.appointmentTypeId === 401008)
                    event.iconCode += "<i class='qm-icon-earth'></i> ";
                if (randomId)
                    event.id = randomId;
                if (typeDefaults.length > 0) {
                    var defaultColor = typeDefaults.filter(function (x) { return x.typeId == appointment.appointmentTypeId; })[0];
                    if (defaultColor) {
                        event.borderColor = defaultColor.colorHtml;
                        event.backgroundColor = appointment.colorHtml;
                    }
                }
                return event;
            };
            UserInterface.prototype.getTextColor = function (color) {
                var r = parseInt('0x' + color.substr(1, 2));
                var g = parseInt('0x' + color.substr(3, 2));
                var b = parseInt('0x' + color.substr(5, 2));
                var hsp = (r * 299 + g * 587 + b * 114) / 1000;
                // Using the HSP value, determine whether the color is light or dark
                if (hsp > 123) {
                    //light color, return black
                    return '#000000';
                }
                else {
                    //dark color return white
                    return '#FFFFFF';
                }
            };
            /**
             * Select value text pair from a dataSet
             *
             * @param {*} dataSet
             * @param {*} filters
             * @returns {Common.ISelectListItem[]}
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.select = function (dataSet, filters) {
                var filterChache = filters.text.split(',');
                var options = dataSet.map(function (obj) {
                    if (filterChache.length > 1)
                        return {
                            text: obj[filterChache[0]] + ', ' + obj[filterChache[0]],
                            value: obj[filters.value]
                        };
                    return {
                        text: obj[filters.text],
                        value: obj[filters.value]
                    };
                });
                return options;
            };
            /**
             * Notification
             *
             * @param {any} note
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.notify = function (note, message) {
                var timestamp = new Date().getTime();
                var randomNum = timestamp + Math.floor((Math.random() * 1000) + 1);
                var _timer = 1500, _overlay = 0;
                if (note.hasOwnProperty("timer"))
                    _timer = note.timer;
                if (note.hasOwnProperty("overlay"))
                    _overlay = note.overlay;
                setTimeout(showNotify, _overlay);
                setTimeout(hideNotify, _timer);
                function showNotify() {
                    $("#qm-notification")
                        .prepend("<div id='notify-" + randomNum + "' class='animated slideInDown qm-msg " + note.status + "'><i class='" + note.icon + "'></i><span class='title'>" + note.title + "</span><span class='text'>" + note.message + "</span></div>");
                    setTimeout(function () {
                        if (QMC.Common.Constants.IS_MOBILE)
                            $("#notify-" + randomNum).css("margin-left", "220px");
                    }, 200);
                    $("#notify-" + randomNum).click(function () {
                        $(this).addClass("slideOutUp");
                        var modal = this;
                        setTimeout(function () {
                            $(modal).remove();
                        }, 800);
                    });
                }
                function hideNotify() {
                    $("#notify-" + randomNum).addClass("slideOutUp");
                    setTimeout(function () {
                        $("#notify-" + randomNum).remove();
                    }, 800);
                }
            };
            /**
             * Add time to date
             *
             * @param {Date} date
             * @param {Date} time
             * @returns {Date}
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.addTimeToDate = function (date, time) {
                date = moment(date).toDate();
                time = moment(time).toDate();
                date.setHours(time.getHours());
                date.setMinutes(time.getMinutes());
                return moment(date).toDate();
            };
            /**
             * get the duration between two dates in hours
             *
             * @param {Date} start
             * @param {Date} end
             * @returns {number}
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.getDurationInHours = function (start, end) {
                /**
                 * Updated Version
                 */
                //  var duration = moment.duration(moment(end).diff(moment(start)));
                //  return duration.asHours();
                var a = moment(start).year(1).month(1).day(1);
                var b = moment(end).year(1).month(1).day(1);
                var duration = moment.duration(b.diff(a));
                return duration.asHours();
            };
            /**
             * get the duration between two dates in days
             *
             * @param {Date} start
             * @param {Date} end
             * @returns {number}
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.getDurationInDays = function (start, end) {
                var a = moment(start).hours(0).minute(0).seconds(0);
                var b = moment(end).hours(0).minute(0).seconds(0);
                var duration = moment.duration(b.diff(a));
                return duration.asDays();
            };
            /**
             * round time by a given part
             *
             * @param {Date} time
             * @param {number} part
             * @returns {Date}
             *
             * @memberOf UserInterface
             */
            UserInterface.prototype.roundTime = function (time, part) {
                var rounded = Math.round(moment(time).minute() / part) * part;
                var d = new Date(time);
                d.setMinutes(rounded);
                d.setSeconds(0);
                return d;
            };
            UserInterface.prototype.getDisplayedPropertiesFromSchema = function (schema) {
                var result = [];
                for (var prop in schema.table) {
                    result.push(schema.table[prop].label);
                }
                return result.filter(function (x) { return x; }); //Get rid of invalid values (just to be sure)
            };
            return UserInterface;
        }());
        Common.UserInterface = UserInterface;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var Filter = /** @class */ (function () {
            function Filter() {
            }
            Filter.Humanize = function (userService) {
                var settingName = 'HUMANIZETIME';
                var getNavigatorLanguage = function () { var _a; return ((_a = navigator.languages) === null || _a === void 0 ? void 0 : _a.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'de'; };
                console.log("LANG", getNavigatorLanguage());
                moment.locale(getNavigatorLanguage());
                function createString(date, setting) {
                    if (setting < 0)
                        return moment(date).format('DD.MM.YYYY HH:mm');
                    else if (setting === 0)
                        return moment(date).fromNow();
                    else {
                        if (moment(date).isBefore(moment().add(-setting, 'h')))
                            return moment(date).format('DD.MM.YYYY HH:mm');
                        return moment(date).fromNow();
                    }
                }
                filterStub.$stateful = true;
                function filterStub(date) {
                    var fromStorage = sessionStorage.getItem(settingName);
                    if (!fromStorage) {
                        sessionStorage.setItem(settingName, 'loading');
                        userService.getUserSettings([settingName]).then(function (data) {
                            var value = parseInt(data[0].value && data[0].value.length > 0 ? data[0].value : '24');
                            sessionStorage.setItem(settingName, value + '');
                            return '';
                        });
                        return '';
                    }
                    else if (fromStorage === 'loading') {
                        return '';
                    }
                    return createString(date, parseInt(fromStorage));
                }
                return filterStub;
            };
            Filter.NotEmpty = function () {
                return function (string) {
                    if (string == null)
                        return;
                    return string.length === 0 ? "-" : string;
                };
            };
            Filter.FullNameFormat = function () {
                return function (string) {
                    if (typeof string != 'string')
                        return string;
                    if (string.indexOf(',') > 1)
                        return string.split(',')[1] + " " + string.split(',')[0];
                    return string;
                };
            };
            Filter.Shortner = function () {
                return function (string) {
                    if (string.length > 20)
                        return string.substring(0, 8) + "..." + string.substring(string.length - 8, string.length);
                    else
                        return string;
                };
            };
            Filter.Html = function ($sce) {
                return function (val) {
                    return $sce.trustAsHtml(val);
                };
            };
            Filter.DisplayFormat = function ($sce) {
                return function (item, format) {
                    if (item == undefined)
                        return;
                    switch (format) {
                        case 'heading': return item;
                        case 'boolean': return item ? "Ja" : "Nein"; // ICONS
                        case 'number': return item.toString(); // try it
                        case 'string': return item;
                        case 'date': return moment(item).format('DD.MM.YYYY');
                        case 'multiple':
                            var html = "<ul>";
                            for (var i in item)
                                html += '<li>' + item[i] + '</li>';
                            return $sce.trustAsHtml(html + "</ul>");
                        case 'description': return $sce.trustAsHtml(item);
                        default: return item;
                    }
                };
            };
            Filter.StartFrom = function () {
                return function (input, start) {
                    if (input == (null || undefined) || start == (null || undefined))
                        return [];
                    start = +start; //parse to int
                    return input.slice(start);
                };
            };
            return Filter;
        }());
        Common.Filter = Filter;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Registers an angular controller
     * @param moduleName The name of the angular module
     * @param controllerName The name of the controller
     */
    function Controller(moduleName, controllerName) {
        return function decoratorFactory(target, decoratedPropertyName) {
            angular
                .module(moduleName)
                .controller(controllerName, target);
        };
    }
    QMC.Controller = Controller;
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Creates the directive factory function and sets the dependencies of the directive and registers the directive
     * @param moduleName The name of the angular module
     * @param directiveName The name of the service
     * @param dependencies The dependencies of the directive
     */
    function Directive(moduleName, directiveName, dependencies) {
        if (dependencies === void 0) { dependencies = []; }
        return function decoratorFactory(target, decoratedPropertyName) {
            // Create directive
            var directive = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (function (classConstructor, args, ctor) {
                    ctor.prototype = classConstructor.prototype;
                    var child = new ctor;
                    var result = classConstructor.apply(child, args);
                    return typeof result === "object" ? result : child;
                })(target, args, function () {
                    return null;
                });
            };
            // Dependency injection
            directive.$inject = dependencies;
            // Angular registration
            angular
                .module(moduleName)
                .directive(directiveName, directive);
        };
    }
    QMC.Directive = Directive;
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Injects this class with the given dependencies
     * @param dependencies The dependencies of this class
     */
    function Inject() {
        var dependencies = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            dependencies[_i] = arguments[_i];
        }
        return function decoratorFactory(target, decoratedPropertyName) {
            var $inject = target.$inject = [];
            $inject = $inject.concat(dependencies);
            target.prototype.$inject = $inject;
            target.$inject = $inject;
        };
    }
    QMC.Inject = Inject;
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    /**
     * Registers an angular service
     * @param moduleName The name of the angular module
     * @param serviceName The name of the service
     */
    function Service(moduleName, serviceName) {
        return function decoratorFactory(target, decoratedPropertyName) {
            angular
                .module(moduleName)
                .service(serviceName, target);
        };
    }
    QMC.Service = Service;
})(QMC || (QMC = {}));
(function () {
    sessionStorage.clear();
    angular.element(document).ready(function () {
        angular.bootstrap(document, ['QMC']);
    });
    function config($locationProvider, $stateProvider, $urlRouterProvider, qmcBase, $httpProvider, $sceDelegateProvider, $qProvider) {
        $httpProvider.defaults.cache = true;
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/ambulant', '/');
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'http://service.daarwin.de/**',
            'https://service.daarwin.de/**',
            'http://localhost:4200/*'
        ]);
        //$qProvider.errorOnUnhandledRejections(false);
        // $compileProvider.debugInfoEnabled(false);
        $stateProvider
            .state('dashboard', {
            url: '/',
            templateUrl: qmcBase + '/Dashboard',
            controller: 'HomeController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Dashboard');
                    }]
            }
        }).state('changelog', {
            url: '/changelog',
            templateUrl: qmcBase + '/Changelog/Index',
            controller: 'ChangelogController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Changelog');
                    }]
            }
        }).state('license', {
            url: '/license',
            templateUrl: qmcBase + '/License/Index',
            controller: 'HomeController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: License');
                    }]
            }
        });
        $stateProvider
            .state('404', {
            url: '/404',
            templateUrl: qmcBase + '/error/404',
            controller: 'HomeController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.warn('Current State: Page not Found');
                    }]
            }
        });
        $stateProvider
            .state('changePassword', {
            url: '/user/changepassword',
            templateUrl: qmcBase + '/ChangePassword',
            controller: 'ChangePasswordController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.warn('Current State: change password');
                    }]
            }
        }).state('settings', {
            url: '/user/settings',
            templateUrl: qmcBase + '/Settings',
            controller: 'UserSettingsController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.warn('Current State: User Settings');
                    }]
            }
        }).state('globalsettings', {
            url: '/user/globalsettings',
            templateUrl: qmcBase + '/GlobalSettings',
            controller: 'UserGlobalSettingsController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.warn('Current State: User Global Settings');
                    }]
            }
        }).state('navconfiguration', {
            url: '/navconfiguration',
            templateUrl: qmcBase + '/NavConfiguration',
            controller: 'NavConfigurationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.warn('Current State: User Global Settings');
                    }]
            }
        });
    }
    // Init Empty Modules
    var baseUrl = $('#session').data().baseUrl;
    angular
        .module('QMC.Common', [])
        .constant('qmcBase', baseUrl.substring(0, baseUrl.length - 1))
        .run(['QmcLanguageService', function (qmcLanguageService) {
            qmcLanguageService.loadLanguageTags();
        }]);
    angular.module('QMC.Documents', []);
    angular.module('QMC.Directives', []);
    angular.module('QMC.Input', []);
    angular.module('QMC.Udf', []);
    angular.module('QMC.Aufgaben', []);
    angular.module('QMC.Arbeitszeitnachweis', ['ui.router']);
    angular.module('QMC.Klient', ['ui.router']);
    angular.module('QMC.Medikamente', ['ui.router']);
    angular.module('QMC.Fachleistung', ['ui.router', 'QMC.Klient', 'QMC.Home']);
    angular.module('QMC', ['ui.router', 'ui.router.state.events', 'ngMessages', 'ui.select', 'ngSanitize', 'qmc-ui', 'QMC.Common', 'QMC.Home', 'QMC.Documents', 'QMC.Directives', 'QMC.Input', 'QMC.Udf', 'QMC.Arbeitszeitnachweis',
        'QMC.Aufgaben', 'QMC.ClientInformation', 'QMC.Fachleistung', 'QMC.Holiday', 'QMC.Klient', 'QMC.Medikamente', 'QMC.Nachrichten', 'QMC.Reporting', 'QMC.Stammdaten', 'QMC.Tagebuch',
        'QMC.Termin', 'QMC.Roster', 'QMC.Employee'])
        .filter("humanize", ['UserService', QMC.Common.Filter.Humanize])
        .filter("displayFormat", ['$sce', QMC.Common.Filter.DisplayFormat])
        .filter("notEmpty", QMC.Common.Filter.NotEmpty)
        .filter("shortner", QMC.Common.Filter.Shortner)
        .filter("unsafeHtml", ['$sce', QMC.Common.Filter.Html])
        .filter("fullNameFormat", QMC.Common.Filter.FullNameFormat)
        .filter("startFrom", QMC.Common.Filter.StartFrom)
        .config(config)
        .run(['$rootScope', '$state', 'UserService', function ($rootScope, $state, userService) {
            var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
            jQuery.htmlPrefilter = function (html) {
                return html.replace(rxhtmlTag, "<$1></$2>");
            };
            document.getElementById('wrapper').style.display = 'none';
            document.getElementById('load-placeholder').style.display = 'block';
            userService.updateSession();
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                if (!$state.history)
                    $state.history = [];
                if (fromState.name && fromState.name.length > 0)
                    $state.history.unshift({
                        name: fromState.name,
                        url: fromState.url,
                        params: fromParams
                    });
                $state.history = $state.history.slice(0, 5); // limit to last 5 entries
            });
        }]);
    config.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase', '$httpProvider', '$sceDelegateProvider', '$qProvider'];
    angular.module('QMC.Common')
        .config(['$httpProvider', QMC.Common.HttpBaseProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcLanguageService = /** @class */ (function (_super) {
            __extends(QmcLanguageService, _super);
            function QmcLanguageService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.isDebug = false;
                _this.languageTags = [];
                var ele = angular.element('#session');
                _this.languageId = ele.data('user-language-id');
                try {
                    _this.isDebug = ele.data('debug').toLowerCase() === 'true';
                }
                catch (e) {
                    _this.isDebug = false;
                    console.log(e);
                }
                ;
                _this.loadLanguageTags();
                return _this;
            }
            QmcLanguageService.prototype.loadLanguageTags = function () {
                var _this = this;
                var ele = angular.element('#session');
                this.languageId = ele.data('user-language-id');
                this.isDebug = ele.data('debug');
                if (!this.languageId || this.isLoading)
                    return;
                this.isLoading = true;
                _super.prototype.getItem.call(this, "/languages/" + this.languageId + "/tags", { fromTag: 20000000, toTag: 29999999, asDict: true, dbConnectionString: ele.data('db-connection') })
                    .then(function (data) {
                    _this.languageTags = data.languageTags;
                }).finally(function () {
                    _this.isLoading = false;
                    if (_this.timeout)
                        clearTimeout(_this.timeout);
                    _this.timeout = setTimeout(function () { _this.loadLanguageTags(); }, _this.languageTags && Object.keys(_this.languageTags).length === 0 ? 1200000 : 60000 * 15);
                });
            };
            QmcLanguageService.prototype.translate = function (tag, defaultValue) {
                if (defaultValue === void 0) { defaultValue = ''; }
                if (!this.languageTags) {
                    this.loadLanguageTags();
                }
                var value = this.languageTags[tag];
                if (value && value.length > 0) {
                    return value;
                }
                return defaultValue;
                //return this.isDebug ? `*JD* ${defaultValue}` : defaultValue;
            };
            QmcLanguageService.prototype.getLanguages = function () {
                return this.get('/Languages', {}, function (data) {
                    return data;
                });
            };
            QmcLanguageService.prototype.getCurrentLanguageId = function () {
                return this.languageId;
            };
            QmcLanguageService.prototype.setLanguageTag = function (tag, data) {
                if (tag === void 0) { tag = 0; }
                return this.putParameter('/Languages/' + tag, { languageId: this.languageId }, '"' + data + '"').then(function (data) {
                    return data;
                });
            };
            QmcLanguageService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcLanguageService')
            ], QmcLanguageService);
            return QmcLanguageService;
        }(Common.BaseService));
        Common.QmcLanguageService = QmcLanguageService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcMediaService = /** @class */ (function (_super) {
            __extends(QmcMediaService, _super);
            function QmcMediaService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            QmcMediaService.prototype.convertToHtml = function (base64, sourceType) {
                return this.post('/Media/Converter/ToHtml', { base64: base64, sourceType: sourceType }).then(function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.convertToPdf = function (base64, sourceType) {
                return this.post('/Media/Converter/ToPdf', { base64: base64, sourceType: sourceType }).then(function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.getTextBlocks = function () {
                return _super.prototype.get.call(this, "/TextBlock", {}, function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.getTextTemplates = function () {
                return _super.prototype.get.call(this, "/TextTemplate", {}, function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.getTextTemplateContent = function (id) {
                return _super.prototype.getItem.call(this, "/TextTemplate/" + id, {}, function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.getMediaFile = function (id, mediaType) {
                return _super.prototype.getItem.call(this, "/Document/Media/" + id, { mediaType: mediaType }, function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.getMediaThumbnail = function (id, mediaType, maxSize) {
                if (maxSize === void 0) { maxSize = 50; }
                return _super.prototype.getItem.call(this, "/Document/Media/" + id, { mediaType: mediaType, maxSize: maxSize }, function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.getMediaAttachement = function (documentId, attachmentId) {
                return _super.prototype.getItem.call(this, "/Document/Media/" + documentId + "/" + attachmentId, {}, function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.postMediaAttachement = function (data) {
                return _super.prototype.post.call(this, "/Document/Media", data).then(function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.deleteMediaAttachementDirect = function (attachmentId) {
                return _super.prototype.delete.call(this, "/Document/Media/" + attachmentId).then(function (data) {
                    return data;
                });
            };
            QmcMediaService.prototype.deleteMediaAttachement = function (documentId, attachmentId) {
                return _super.prototype.delete.call(this, "/Document/Media/" + documentId + "/" + attachmentId).then(function (data) {
                    return data;
                });
            };
            QmcMediaService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcMediaService')
            ], QmcMediaService);
            return QmcMediaService;
        }(Common.BaseService));
        Common.QmcMediaService = QmcMediaService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcPermissionService = /** @class */ (function (_super) {
            __extends(QmcPermissionService, _super);
            function QmcPermissionService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            /**
             * Gets the permissions by object type.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            QmcPermissionService.prototype.getPermissionsByObjectType = function (objectType) {
                return this.get('/Permission', { objectType: objectType }, function (data) {
                    return data;
                });
            };
            /**
             * Gets the permissions by object types.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            QmcPermissionService.prototype.getPermissionsByObjectTypes = function (objectTypes) {
                return this.get('/Permission/Multiple', { objectTypes: objectTypes }, function (data) {
                    return data;
                });
            };
            /** Gets the permissions for Media / Documents.
             * @param objectTypeBase The object type to get the permissions OBJEKTTYPE_DOCUMENT.
             * @param wvTypeId The wv subtyp.
             * @param folderCategoryId The Document Category for which we get the permission
             */
            QmcPermissionService.prototype.getMediaPermissions = function (objectTypeBase, wvTypeId, folderCategoryId) {
                return this.get('/Permission/Media', { objectTypeBase: objectTypeBase, wvTypeId: wvTypeId, folderCategoryId: folderCategoryId }, function (data) {
                    return data;
                });
            };
            /**
             * Gets the permissions for a dataset.
             * @param objectId The objectId of the dataset to get the permissions for.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            QmcPermissionService.prototype.getPermissionsForDataset = function (objectId, objectType) {
                return this.get('/Permission/DataSet', { objectId: objectId, objectType: objectType }, function (data) {
                    return data;
                });
            };
            /**
             * Gets the permissions for a specific user related to a specific type.
             * @param userId The userId to get the permissions for.
             * @param objectType The object type to get the permissions for (e.g. 140000 for client).
             */
            QmcPermissionService.prototype.getPermissionsForGivenUserAndObjectType = function (userId, objectType) {
                return this.get('/Permission/ObjectInAllowedNewPermsList', { userId: userId, objectType: objectType }, function (data) {
                    return data;
                });
            };
            QmcPermissionService.prototype.getLicense = function () {
                return _super.prototype.get.call(this, '/Navigation/License', {}).then(function (data) {
                    return data;
                });
            };
            QmcPermissionService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcPermissionService')
            ], QmcPermissionService);
            return QmcPermissionService;
        }(Common.BaseService));
        Common.QmcPermissionService = QmcPermissionService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcMarkItemService = /** @class */ (function (_super) {
            __extends(QmcMarkItemService, _super);
            function QmcMarkItemService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            QmcMarkItemService.prototype.getMarkItems = function () {
                return this.getItem('/MarkItem/', {}, function (data) {
                    return data;
                });
            };
            QmcMarkItemService.prototype.getSelectedMarkItems = function (parentObjectId, parentObjectType) {
                return this.getItem('/SelectedMarkItem/' + parentObjectId + '/' + parentObjectType, {}, function (data) {
                    return data;
                });
            };
            QmcMarkItemService.prototype.checkIfItemsAreMarked = function (parentObjectIds, parentObjectType) {
                return this.getItem('/SelectedMarkItem/CheckIfMarked/' + parentObjectType, { parentObjectIds: parentObjectIds }, function (data) {
                    return data;
                });
            };
            QmcMarkItemService.prototype.putSelectedMarkItems = function (data) {
                return this.put('/SelectedMarkItem/', data).then(function (data) {
                    return data;
                });
            };
            QmcMarkItemService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcMarkItemService')
            ], QmcMarkItemService);
            return QmcMarkItemService;
        }(Common.BaseService));
        Common.QmcMarkItemService = QmcMarkItemService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcIdentityService = /** @class */ (function (_super) {
            __extends(QmcIdentityService, _super);
            function QmcIdentityService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            /**
             * Gets the claims of the currently logged in user.
             */
            QmcIdentityService.prototype.getIdentity = function () {
                return this.getItem('/Identity', {}, function (data) {
                    return data;
                });
            };
            QmcIdentityService.prototype.setSecretToken = function () {
                var deferred = this.$q.defer();
                this.$http({
                    url: this.apiData.url + '/TokenExchange',
                    method: 'POST',
                    data: { access: this.getAccessToken(), refresh: this.getRefreshToken() }
                }).then(function (response) {
                    if (response.status === 201 || response.status === 200)
                        deferred.resolve(response.data);
                    else
                        deferred.reject(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise.then(function (data) { return data; });
            };
            QmcIdentityService.prototype.getSecretToken = function (id) {
                var deferred = this.$q.defer();
                this.$http({
                    url: this.apiData.url + '/TokenExchange/' + id,
                    method: 'GET'
                }).then(function (response) {
                    if (response.status === 200)
                        deferred.resolve(response.data);
                    else
                        deferred.reject(response.data);
                }).catch(function (response) {
                    deferred.reject(response.data);
                });
                return deferred.promise.then(function (data) { return data; });
            };
            QmcIdentityService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcIdentityService')
            ], QmcIdentityService);
            return QmcIdentityService;
        }(Common.BaseService));
        Common.QmcIdentityService = QmcIdentityService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        angular.module('QMC.Common').directive('qmLicense', ['QmcPermissionService', '$qui', function (permissionService, $qui) {
                return {
                    restrict: 'E',
                    templateUrl: './License/Directive',
                    transclude: true,
                    scope: {
                        granted: '=?',
                        key: '@?',
                        route: '@?',
                        loading: '=?'
                    },
                    link: function (scope) {
                        function checkLicenseByRoute(route) {
                            var _a, _b;
                            var license = getLicense();
                            return (_b = (_a = license.filter(function (x) { return x.url.toLowerCase() === route.toLowerCase(); })[0]) === null || _a === void 0 ? void 0 : _a.granted) !== null && _b !== void 0 ? _b : false;
                        }
                        function checkLicenseByKey(key) {
                            var _a, _b;
                            var license = getLicense();
                            return (_b = (_a = license.filter(function (x) { return x.license.toLowerCase() === key.toLowerCase(); })[0]) === null || _a === void 0 ? void 0 : _a.granted) !== null && _b !== void 0 ? _b : false;
                        }
                        function getLicense() {
                            var license = window.license;
                            if (license === 'loading')
                                return [];
                            if (!license || !Array.isArray(license)) {
                                window.license = 'loading';
                                permissionService.getLicense().then(function (data) {
                                    window.license = data;
                                    scope.loading = false;
                                });
                                return [];
                            }
                            scope.loading = false;
                            return license;
                        }
                        function checkLicense() {
                            if (!scope.key && !scope.route) {
                                scope.loading = false;
                                scope.granted = false;
                            }
                            scope.granted = scope.key ? checkLicenseByKey(scope.key) : scope.route ? checkLicenseByRoute(scope.route) : false;
                            $qui.scopeApply(scope);
                            if (scope.loading) {
                                setTimeout(function () { checkLicense(); }, 200);
                            }
                        }
                        scope.loading = true;
                        checkLicense();
                    }
                };
            }
        ]);
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcPrivateContentService = /** @class */ (function (_super) {
            __extends(QmcPrivateContentService, _super);
            function QmcPrivateContentService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            /**
             * Gets a single private content.
             * @param objectType The parent object to get the content for (e.g. fls-docu).
             * @param referenceObjectId The reference to get the content for (e.g. client).
             */
            QmcPrivateContentService.prototype.getPrivateContent = function (parentId, referenceObjectId) {
                return this.getItem('/PrivateContent/' + parentId + '/' + referenceObjectId, {}, function (data) {
                    return data;
                });
            };
            QmcPrivateContentService.prototype.putPrivateContent = function (parentId, referenceObjectId, data) {
                return this.put('/PrivateContent/' + parentId + '/' + referenceObjectId, data).then(function (data) {
                    return data;
                });
            };
            QmcPrivateContentService.prototype.postPrivateContent = function (data) {
                return this.post('/PrivateContent/', data).then(function (data) {
                    return data;
                });
            };
            QmcPrivateContentService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcPrivateContentService')
            ], QmcPrivateContentService);
            return QmcPrivateContentService;
        }(Common.BaseService));
        Common.QmcPrivateContentService = QmcPrivateContentService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var Utilities = /** @class */ (function () {
            function Utilities() {
            }
            Utilities.confirm = function (obj, cb, prompt, staticBD) {
                if (prompt === void 0) { prompt = '#prompt'; }
                if (staticBD === void 0) { staticBD = false; }
                $(prompt).modal({ backdrop: staticBD ? 'static' : true, keyboard: false });
                obj.callback = function (bool) {
                    cb(bool);
                };
            };
            Utilities.arraysEqual = function (_arr1, _arr2) {
                if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length)
                    return false;
                var arr1 = _arr1.concat().sort();
                var arr2 = _arr2.concat().sort();
                for (var i = 0; i < arr1.length; i++) {
                    if (arr1[i] !== arr2[i])
                        return false;
                }
                return true;
            };
            return Utilities;
        }());
        Common.Utilities = Utilities;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        /**
         * Smart action keyword check class
         *
         * @export
         * @class SmartAction
         */
        var SmartAction = /** @class */ (function () {
            function SmartAction(permissionService, userService, clientService, lng, $scope) {
                var _this = this;
                this.clientService = clientService;
                this.lng = lng;
                this.$scope = $scope;
                this.keyWords = [];
                this.keyWordGroups = ["impfung", "arzt", "krankheit", "termin", "abwesenheit", "nachricht", "aufgabe", "dokument", "kassenbuch", "kontaktperson"];
                this.activeKeys = {};
                this.ignoredKeys = [];
                this.loading = true;
                if (!permissionService || !clientService || !lng)
                    return;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                this.cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                // nothing cached and not already loading, completely rebuild
                if (!this.cacheObject.permissions) {
                    this.cacheObject.permissions = { loading: true };
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                    if (!window.license || window.license === 'loading')
                        permissionService.getLicense().then(function (license) {
                            window.license = license !== null && license !== void 0 ? license : []; //since we already got it, might as well set it in windowstore. might reduce waittime later
                            _this.createKeyWords(permissionService, userService);
                        });
                    else
                        this.createKeyWords(permissionService, userService);
                }
                // data is already beeing loaded, wait for it
                else if (this.cacheObject.permissions && this.cacheObject.permissions.loading) {
                    this.waitForPermissionCache();
                }
                // data is already present, use it
                else {
                    this.keyWords = this.cacheObject.keyWords;
                    this.loading = false;
                }
                // init person lists needed by several SAs
                // loading int
                this.cacheObject.clientList = { loading: true };
                this.cacheObject.employeeList = { loading: true };
                sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(this.cacheObject));
                // clientlist
                this.clientService.getClientPersonList("", true).then(function (data) {
                    _this.cacheObject.clientList = data.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(_this.cacheObject));
                });
                // employeelist
                this.clientService.getEmployeeList().then(function (data) {
                    _this.cacheObject.employeeList = data.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(_this.cacheObject));
                });
                // personlists
                this.clientService.getAllPersonLists().then(function (data) {
                    _this.cacheObject.personLists = data.map(function (x) { return ({ value: x.objectId, text: x.name + ' (' + _this.lng.translate(20000292, 'Verteiler') + ')' }); });
                    sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(_this.cacheObject));
                });
                this.resetSmartAction();
            }
            SmartAction.prototype.resetSmartAction = function () {
                this.ignoredKeys = [];
                for (var _i = 0, _a = this.keyWordGroups; _i < _a.length; _i++) {
                    var keyword = _a[_i];
                    this.activeKeys[keyword] = [];
                }
                if (this.$scope && !this.$scope.$$phase)
                    this.$scope.$apply();
            };
            SmartAction.prototype.checkKeyWord = function (searchContent) {
                var _this = this;
                if (this.loading) {
                    setTimeout(function () {
                        _this.checkKeyWord(searchContent);
                    }, 500);
                    return;
                }
                searchContent = searchContent.toLowerCase();
                for (var i = 0; i < this.keyWordGroups.length; i++) {
                    if (!this.keyWords[i])
                        continue;
                    for (var j = 0; j < this.keyWords[i].length; j++) {
                        if (searchContent.search(this.keyWords[i][j]) !== -1 && this.keyWords[i][j] !== '' && this.ignoredKeys.indexOf(this.keyWords[i][j]) === -1) {
                            if (!this.activeKeys[this.keyWordGroups[i]].includes(this.keyWords[i][j])) {
                                this.activeKeys[this.keyWordGroups[i]].push(this.keyWords[i][j]);
                                if (this.$scope && !this.$scope.$$phase)
                                    this.$scope.$apply();
                                // do this second scope apply to make absolutly sure changes get triggered 'immediatly'
                                setTimeout(function () {
                                    if (_this.$scope && !_this.$scope.$$phase)
                                        _this.$scope.$apply();
                                }, 250);
                            }
                        }
                    }
                }
            };
            SmartAction.prototype.createKeyWords = function (permissionService, userService) {
                var _this = this;
                var keyWords = [];
                permissionService.getPermissionsByObjectTypes([140005, 140003, 140002, 400000, 140033, 750001, 840501, 140032, 330003, 140006]).then(function (perms) {
                    if (perms[0].new)
                        keyWords[0] = ["impfung", "impfen"];
                    if (perms[1].new)
                        keyWords[1] = ["arzt", "doktor"];
                    if (perms[2].new)
                        keyWords[2] = ["krank", "krankheit", "grippe", "fieber"];
                    if (perms[3].new)
                        keyWords[3] = ["termin", "verabredung", "meeting"];
                    if (perms[4].new)
                        keyWords[4] = ["abwesend", "abwesenheit"];
                    if (perms[5].new)
                        keyWords[5] = ["nachricht", "mail", "meldung"];
                    if (perms[6].new)
                        keyWords[6] = ["aufgabe", "task"];
                    if (perms[7].new)
                        keyWords[7] = ["dokument", "datei"];
                    if (perms[8].new && window.license.some(function (x) { return x.license === 'KASSENBUCH' && x.granted; }))
                        keyWords[8] = ["kassenbuch"];
                    if (perms[9].new)
                        keyWords[9] = ["kontakt", "kontaktperson"];
                    if (userService) {
                        userService.getUserSettings([
                            "SMARTACTIONS.VACCINATION",
                            "SMARTACTIONS.DOCVISIT",
                            "SMARTACTIONS.DISEASE",
                            "SMARTACTIONS.APPOINTMENT",
                            "SMARTACTIONS.ABSENTEEISM",
                            "SMARTACTIONS.INTERNALMESSAGE",
                            "SMARTACTIONS.TASK",
                            "SMARTACTIONS.DOCUMENT",
                            "SMARTACTIONS.ACCOUNTINGBOOK",
                            "SMARTACTIONS.CONTACTPERSON",
                        ]).then(function (data) {
                            for (var i = 0; i < keyWords.length; i++) {
                                _this.addKeywords(i, keyWords, data);
                            }
                            _this.keyWords = keyWords;
                            _this.loading = false;
                            _this.savePermissionCache({
                                140005: perms[0],
                                140003: perms[1],
                                140002: perms[2],
                                400000: perms[3],
                                140033: perms[4],
                                750001: perms[5],
                                840501: perms[6],
                                140032: perms[7],
                                330003: perms[8],
                                140006: perms[9]
                            }, keyWords);
                        });
                    }
                    else {
                        _this.keyWords = keyWords;
                        _this.loading = false;
                        _this.savePermissionCache({
                            140005: perms[0],
                            140003: perms[1],
                            140002: perms[2],
                            400000: perms[3],
                            140033: perms[4],
                            750001: perms[5],
                            840501: perms[6],
                            140032: perms[7],
                            330003: perms[8],
                            140006: perms[9]
                        }, keyWords);
                    }
                });
            };
            SmartAction.prototype.addKeywords = function (index, keyWords, data) {
                if (!data[index] || !keyWords[index])
                    return;
                if (data[index].value === "")
                    keyWords[index] = undefined;
                else {
                    keyWords[index] = [];
                    data[index].value.split(";").forEach(function (item) { return keyWords[index].push(item.toLowerCase().trim()); });
                }
            };
            SmartAction.prototype.savePermissionCache = function (permissions, keyWords) {
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                cacheObject.permissions = permissions;
                cacheObject.keyWords = keyWords;
                sessionStorage.setItem(Common.Constants.SMARTACTIONCACHE, JSON.stringify(cacheObject));
            };
            SmartAction.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cacheObject = JSON.parse(sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE));
                if (cacheObject.permissions.loading) {
                    setTimeout(function () { _this.waitForPermissionCache(); }, 250);
                    return;
                }
                this.keyWords = cacheObject.keyWords;
                this.loading = false;
            };
            return SmartAction;
        }());
        Common.SmartAction = SmartAction;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var QmcWvService = /** @class */ (function (_super) {
            __extends(QmcWvService, _super);
            function QmcWvService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                return _this;
            }
            QmcWvService.prototype.getWvList = function (wvId) {
                return this.get("/WV/" + wvId, {}, function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.getWv = function (wvId, itemId) {
                return this.getItem("/WV/" + wvId + "/" + itemId, {}, function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.putWv = function (wvId, itemId, data) {
                return this.put("/WV/" + wvId + "/" + itemId, data).then(function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.postWv = function (wvId, data) {
                return this.post("/WV/" + wvId, data).then(function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.deleteWv = function (wvId, itemId) {
                return this.delete("/WV/" + wvId + "/" + itemId).then(function (data) {
                    return data;
                });
            };
            /************** SUB WV **************/
            QmcWvService.prototype.getSubWvList = function (subWvId, wvId) {
                return this.get("/SubWV/" + subWvId + "/" + wvId, {}, function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.getSubWv = function (subWvId, wvId, itemId) {
                return this.getItem("/SubWV/" + subWvId + "/" + wvId + "/" + itemId, {}, function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.putSubWv = function (subWvId, wvId, itemId, data) {
                return this.put("/SubWV/" + subWvId + "/" + wvId + "/" + itemId, data).then(function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.postSubWv = function (subWvId, wvId, data) {
                return this.post("/SubWV/" + subWvId + "/" + wvId, data).then(function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.deleteSubWv = function (subWvId, wvId, itemId) {
                return this.delete("/SubWV/" + subWvId + "/" + wvId + "/" + itemId).then(function (data) {
                    return data;
                });
            };
            QmcWvService.prototype.getSubWvListForParent = function (subWvId, wvId) {
                return this.get("/SubWV/ForParent/" + wvId + "/" + subWvId, {}, function (data) {
                    return data;
                });
            };
            QmcWvService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Common', 'QmcWvService')
            ], QmcWvService);
            return QmcWvService;
        }(Common.BaseService));
        Common.QmcWvService = QmcWvService;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        var DetailUI = /** @class */ (function (_super) {
            __extends(DetailUI, _super);
            function DetailUI() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.smartAufgabeForm = {
                    form: [
                        {
                            label: "Aufgabe",
                            placeholder: "",
                            type: "String",
                            lngTag: "20014007",
                            required: true,
                            model: "taskName",
                            validate: {
                                message: "Bitte die Aufgabe angeben.",
                                messageTag: 20014008
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Kategorie",
                            placeholder: "Kategorie auswählen",
                            type: "Select",
                            lngTag: "20000137",
                            dataSource: "getCategoryList",
                            model: "categoryId",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Priorität",
                            placeholder: "Priorität auswählen",
                            type: "Select",
                            lngTag: "20014013",
                            dataSource: "getPriorityList",
                            model: "priorityId",
                            id: "priorityList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            placeholder: "Erledigungstyp auswählen ...",
                            label: "Erledigungstyp",
                            type: "Select",
                            lngTag: "20014014",
                            dataSource: "getExecutionTypeList",
                            model: "executionTypeId",
                            id: "executionTypeList",
                            required: true,
                            validate: {
                                message: "Bitte Erledigungstyp angeben.",
                                messageTag: 20014021
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigungsfrist",
                            placeholder: "zu erledigen bis",
                            type: "Date",
                            model: "dateToFinishTill",
                            startDate: new Date(),
                            lngTag: "20014005",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Termin(e) verwenden",
                            type: "Checkbox",
                            model: "isAppointment",
                            id: "isAppointment",
                            lngTag: "20014030",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            placeholder: "Mitarbeiter auswählen",
                            type: "Select2",
                            lngTag: "20014010",
                            dataSource: "getParticipantsList",
                            multiple: true,
                            id: "participantsTypeList",
                            model: "participants",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Beschreibung",
                            placeholder: "Beschreibung eingeben ...",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: "20014019",
                            model: "taskDescription",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        }
                    ],
                    actions: {
                        put: "putAufgabe",
                        post: "addAufgabe",
                    }
                };
                _this.smartContactpersonForm = {
                    form: [
                        {
                            placeholder: "Klient auswählen",
                            label: "Klient",
                            type: "Select",
                            lngTag: 20017049,
                            required: true,
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "parentObjectId",
                            style: {
                                class: "col-xs-12",
                            },
                            validate: {
                                message: "Bitte einen Klienten angeben.",
                                messageTag: 21003000
                            }
                        },
                        {
                            placeholder: "Kontaktpersonart auswählen",
                            label: "Kontaktpersonart",
                            type: "Select",
                            lngTag: 20004003,
                            required: true,
                            dataSource: "getContactPersonTypeList",
                            model: "contactPersonTypeId",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Art auswählen!"
                            }
                        }, {
                            placeholder: "Anrede auswählen",
                            label: "Anrede",
                            type: "Select",
                            lngTag: 20004005,
                            dataSource: "getSalutationList",
                            model: "salutationId",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Anrede auswählen!"
                            }
                        }, {
                            placeholder: "Titel auswählen",
                            label: "Titel",
                            type: "Select",
                            lngTag: 21002024,
                            dataSource: "getTitleList",
                            model: "titleId",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Vorname",
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Nachname",
                            label: "Nachname",
                            type: "String",
                            lngTag: 20000058,
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Nachnamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21003020,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12"
                            }
                        }, {
                            label: "Kontaktsperre",
                            type: "Checkbox",
                            model: "isContactBan",
                            lngTag: 20004512,
                            id: "isContactBan",
                            style: {
                                class: "medium"
                            }
                        }
                    ],
                    actions: {
                        post: "addContactperson",
                        put: "putContactperson"
                    }
                };
                _this.smartAppointmentForm = {
                    form: [{
                            label: "Betreff",
                            placeholder: "Betreff",
                            type: "String",
                            model: "title",
                            required: true,
                            validate: {
                                message: "Bitte den Betreff angeben.",
                                messageTag: 20018024
                            },
                            style: {
                                class: "col-xs-12",
                                icon: "fa fa-font"
                            }
                        },
                        {
                            type: "Select2",
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klient auswählen",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            placeholder: "Mitarbeiter auswählen",
                            type: "Select2",
                            id: "selectedEmployeeIds",
                            dataSource: "getEmployeeList",
                            model: "selectedEmployeeIds",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: "20000130",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                displayDateTo: true,
                                disableTime: "isAllDay"
                            }
                        },
                        {
                            placeholder: "Ort",
                            label: "Ort",
                            type: "String",
                            model: "location",
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-fa fa-map-marker"
                            }
                        },
                        {
                            label: "Bemerkung",
                            placeholder: "Bemerkung eingeben ...",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: "20000049",
                            model: "description",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Privat",
                            type: "Checkbox",
                            lngTag: 20018014,
                            model: "isPrivate",
                            id: "isPrivate",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Erledigt",
                            type: "Checkbox",
                            lngTag: 20000120,
                            model: "isFinished",
                            id: "isFinished",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Ganztägig",
                            type: "Checkbox",
                            lngTag: 20018016,
                            model: "isAllDay",
                            id: "isAllDay",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },],
                    actions: {
                        put: "putAppointment",
                        post: "addAppointment"
                    }
                };
                _this.smartAbsenteeismForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Abwesenheitsgrund",
                            label: "Abwesenheitsgrund",
                            type: "Select",
                            lngTag: 21008001,
                            dataSource: "getWvList",
                            model: "absenteeismReasonId",
                            required: true,
                            validate: {
                                message: "Bitte einen Grund auswählen.",
                                messageTag: 21008002
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putAbsenteeism",
                        post: "addAbsenteeism"
                    }
                };
                _this.smartDiseaseForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: 20000130,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Codeschema",
                            label: "Codeschema",
                            type: "Select2",
                            dataSource: "getDiseaseWvList",
                            model: "diseaseCodeSchemaId",
                            lngTag: 20007002,
                            required: true,
                            validate: {
                                message: "Bitte das Codeschema angeben.",
                                messageTag: 21003005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit",
                            label: "Krankheit",
                            type: "Autocomplete",
                            model: "diseaseName",
                            lngTag: 20001049,
                            required: true,
                            id: "liveDiseases",
                            validate: {
                                message: "Bitte die Krankheit angeben."
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putDisease",
                        post: "addDisease",
                    }
                };
                _this.smartDocVisitForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            multiple: true,
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            lngTag: 20000045,
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Uhrzeit",
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "time",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt/Med. Organisation",
                            label: "Arzt/Med. Organisation",
                            type: "Select2",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            model: "treaterId",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }, {
                            placeholder: "Diagnose",
                            label: "Diagnose",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20010503,
                            model: "diagnose",
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "fa fa-user-md"
                            },
                        },],
                    actions: {
                        put: "putDocVisit",
                        post: "addDocVisit"
                    }
                };
                _this.smartVaccinationForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            placeholder: "Klienten auswählen",
                            type: "Select2",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            model: "participants",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            label: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            type: "DateRange",
                            lngTag: 20000130,
                            model: {
                                dateFrom: "date",
                                dateTo: "dateFollowupAppointment"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt auswählen",
                            label: "Arzt",
                            type: "Select2",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            model: "doctorId",
                            required: true,
                            validate: {
                                message: "Bitte den Arzt angeben.",
                                messageTag: 21003014
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit auswählen",
                            label: "Krankheit",
                            type: "Select2",
                            dataSource: "getDiseases",
                            model: "diseaseId",
                            lngTag: 20001049,
                            required: true,
                            id: "disease",
                            validate: {
                                message: "Bitte eine Krankheit angeben",
                                messageTag: 21003006
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Impfstoff Handelsname",
                            label: "Impfstoff",
                            type: "String",
                            lngTag: 20009512,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-stethoscope"
                            },
                        }, {
                            placeholder: "Chargen-Nr",
                            label: "Chargen-Nr",
                            type: "String",
                            model: "batchNumber",
                            lngTag: 20009507,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putVaccination",
                        post: "addVaccination"
                    }
                };
                return _this;
            }
            return DetailUI;
        }(Common.UserInterface));
        Common.DetailUI = DetailUI;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var DokumentDirectiveController = /** @class */ (function () {
            function DokumentDirectiveController(scope, $qui, $state, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.$state = $state;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.participants = [];
                this.fileObject = {
                    id: null,
                    objectId: null,
                    base64String: null,
                    date: null,
                    documentId: null,
                    fileName: null
                };
                this.files = [];
                this.formState = 'new';
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                //right now the smartFormAktion for Documents is working only for clients
                this.objectType = 140032;
                this.parentObjectType = 140000;
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    _this.participants = [];
                    if (val.length > 1) {
                        for (var i = 0; i < val.length; i++) {
                            if (val[i].objType) {
                                if (val[i].objType === 140000) {
                                    clientsList.push(val[i].value);
                                }
                            }
                        }
                        _this.participants = clientsList;
                    }
                    else {
                        _this.participants = val;
                    }
                    _this.clientID = _this.participants.length === 1 ? _this.participants[_this.participants.length - 1] : null;
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.client) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            DokumentDirectiveController.prototype.showStructure = function (id) {
                return id && id !== Common.Constants.GUID_EMPTY;
            };
            DokumentDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140032]) {
                    this.new = cacheObject.permissions[140032].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            DokumentDirectiveController.prototype.getData = function () {
                this.waitForClientListCache();
            };
            DokumentDirectiveController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            };
            DokumentDirectiveController.prototype.getClientList = function () {
                return this.clientList;
            };
            DokumentDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'DokumentDirectiveController'),
                QMC.Inject('$scope', '$qui', '$state', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], DokumentDirectiveController);
            return DokumentDirectiveController;
        }());
        var DokumentDirective = /** @class */ (function () {
            function DokumentDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Dokument";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'DokumentDirectiveController';
                this.bindToController = true;
            }
            DokumentDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickDokument', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], DokumentDirective);
            return DokumentDirective;
        }());
        Common.DokumentDirective = DokumentDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var KassenbuchController = /** @class */ (function () {
            function KassenbuchController(scope, $qui, userService, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.userService = userService;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.accountingBookList = [];
                this.depositList = [];
                this.voucherTypeList = [];
                this.depositTypeList = [];
                this.formState = 'new';
                this.waitForPermissionCache();
                this.initForm();
                this.stammdatenService.getAccountingBookReferences().then(function (data) {
                    var values = data.map(function (x) { return ({ value: x.objectId, text: x.displayTitle, group: x.objectTypeCaption }); });
                    values.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                    values.sort(function (a, b) { return (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0); });
                    _this.references = values;
                });
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    if (val.length > 1) {
                        for (var i = 0; i < val.length; i++) {
                            if (val[i].objType) {
                                if (val[i].objType === 140000) {
                                    clientsList.push(val[i].value);
                                }
                            }
                        }
                        _this.form.participants = clientsList;
                    }
                    else {
                        _this.form.participants = val;
                    }
                    _this.form.clientId = _this.form.participants[_this.form.participants.length - 1];
                }, true);
                this.scope.$watch('vm.form.clientId', function (newValue, oldValue) {
                    if (newValue === oldValue || !newValue)
                        return;
                    if (newValue.value)
                        _this.form.clientId = newValue.value;
                    if (!_this.clientList.some(function (x) { return x.value === _this.form.clientId; }))
                        _this.form.clientId = oldValue;
                    if (_this.form.clientId !== null && _this.form.clientId !== undefined)
                        _this.getAccountingBookList();
                });
                this.scope.$watch('vm.form.accountingBookId', function () {
                    if (_this.form.accountingBookId !== null && _this.form.accountingBookId !== undefined) {
                        for (var i = 0; i <= _this.accountingBookList.length; i++) {
                            if (_this.accountingBookList[i].value === _this.form.accountingBookId) {
                                _this.form.currency = _this.accountingBookList[i].currency;
                                break;
                            }
                        }
                    }
                });
            }
            KassenbuchController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[330003]) {
                    this.new = cacheObject.permissions[330003].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            KassenbuchController.prototype.getData = function () {
                var _this = this;
                this.waitForClientListCache();
                this.stammdatenService.getAccountingBookWv().then(function (datawvList) {
                    _this.form.clientId = _this.form.participants[0];
                    _this.wvList = datawvList;
                    _this.userService.getUserSettings(["KLIENT.BELEGNUMMER_BUCHUNGSKREIS", "KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT", "KASSENBUCH.ShowFiBuDataInSearchDialog"], false).then(function (data) {
                        _this.generateVoucherNrPossible = (data[0].value.toLowerCase() !== "" && data[0].value.toLowerCase() !== Common.Constants.GUID_EMPTY);
                        _this.generateVoucherNrPreselection = data[1].value.toLowerCase() === "true";
                        _this.form.createVoucherNr = _this.generateVoucherNrPreselection;
                        _this.form.generateVoucherNrPossible = _this.generateVoucherNrPossible;
                        _this.getDepositList();
                        _this.getDepositTypeList();
                        _this.getVoucherTypeList();
                    });
                });
            };
            KassenbuchController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                }
            };
            KassenbuchController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    clientId: null,
                    accountingBookId: null,
                    parentObjectId: null,
                    isDeposit: false,
                    voucherTypeId: null,
                    createVoucherNr: false,
                    generateVoucherNrPossible: false,
                    voucherNr: null,
                    voucherText: null,
                    amount: null,
                    currency: null,
                    comment: null,
                    date: new Date(),
                    participants: [],
                    version: null
                };
            };
            KassenbuchController.prototype.checkCanSave = function () {
                var canSave = (this.form.client !== null) && (this.form.accountingBookId !== null) &&
                    (this.form.isDeposit !== null) && (this.form.voucherTypeId !== null) && (this.form.date !== null) &&
                    (this.form.voucherText !== null) && (this.form.amount !== null);
                return canSave;
            };
            KassenbuchController.prototype.getClientList = function () {
                return this.clientList;
            };
            KassenbuchController.prototype.getAccountingBookList = function () {
                var _this = this;
                if (this.form.clientId !== '') {
                    this.stammdatenService.getAccountingBookList(this.form.clientId).then(function (dataAccountingBookList) {
                        _this.accountingBookList = dataAccountingBookList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.caption,
                                currency: obj.currency
                            };
                        });
                    });
                }
                return this.accountingBookList;
            };
            KassenbuchController.prototype.getDepositList = function () {
                this.depositList = [{
                        value: true,
                        text: "Einnahme"
                    }, {
                        value: false,
                        text: "Ausgabe"
                    }];
            };
            KassenbuchController.prototype.getVoucherTypeList = function () {
                this.voucherTypeList = this.wvList.paymentVoucherTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            };
            KassenbuchController.prototype.getDepositTypeList = function () {
                this.depositTypeList = this.wvList.depositVoucherTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            };
            KassenbuchController.prototype.addAccountingBookEntry = function () {
                var _this = this;
                this.form.amount = parseFloat(this.form.amount.toString().replace(',', '.'));
                this.stammdatenService.postAccountingBookEntry(this.form).then(function () {
                    _this.initForm();
                    $('div.additional-field-dynamic.kassenbuch').fadeOut("slow").addClass("deactivated");
                });
            };
            KassenbuchController.prototype.putAccountingBookEntry = function (form) {
                if (form) {
                    $('div.additional-field-dynamic.kassenbuch').fadeOut("slow").addClass("deactivated");
                }
            };
            KassenbuchController = __decorate([
                QMC.Controller('QMC.Common', 'KassenbuchDirectiveController'),
                QMC.Inject('$scope', '$qui', "UserService", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], KassenbuchController);
            return KassenbuchController;
        }());
        var KassenbuchDirective = /** @class */ (function () {
            function KassenbuchDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Kassenbuch";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'KassenbuchDirectiveController';
                this.bindToController = true;
            }
            KassenbuchDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickKassenbuch', ["UserService", "StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], KassenbuchDirective);
            return KassenbuchDirective;
        }());
        Common.KassenbuchDirective = KassenbuchDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var ContactpersonController = /** @class */ (function () {
            function ContactpersonController(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.formState = 'new';
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    if (val.length > 1) {
                        for (var i = 0; i < val.length; i++) {
                            if (val[i].objType) {
                                if (val[i].objType === 140000) {
                                    clientsList.push(val[i].value);
                                }
                            }
                        }
                        _this.form.participants = clientsList;
                    }
                    else {
                        _this.form.participants = val;
                    }
                    _this.form.parentObjectId = _this.form.participants[_this.form.participants.length - 1];
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.client) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            ContactpersonController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140006]) {
                    this.new = cacheObject.permissions[140006].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            ContactpersonController.prototype.getData = function () {
                var _this = this;
                this.waitForClientListCache();
                this.stammdatenService.getContactPersonWvList().then(function (datawvList) {
                    _this.wvList = datawvList;
                    _this.loading.wv = false;
                });
            };
            ContactpersonController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList;
                    this.loading.client = false;
                }
            };
            ContactpersonController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    contactPersonTypeId: null,
                    salutationId: null,
                    titleId: null,
                    forename: null,
                    name: null,
                    birthday: new Date(),
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    comment: null,
                    isContactBan: false,
                    participants: []
                };
            };
            ContactpersonController.prototype.getClientList = function () {
                return this.clientList;
            };
            ContactpersonController.prototype.getContactPersonTypeList = function () {
                return this.wvList.contactPersonTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            };
            ContactpersonController.prototype.getSalutationList = function () {
                var _this = this;
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then(function (data) {
                        _this.wvList = data;
                        return _this.wvList.salutationWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.salutationWvList.map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
            };
            ContactpersonController.prototype.getTitleList = function () {
                var _this = this;
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then(function (data) {
                        _this.wvList = data;
                        return _this.wvList.titleWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.titleWvList.map(function (obj) { return ({
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    }); });
            };
            ContactpersonController.prototype.addContactperson = function (form) {
                this.stammdatenService.postContactPerson(this.form).then(function () {
                    $('div.additional-field-dynamic.kontaktperson').fadeOut("slow").addClass("deactivated");
                });
            };
            ContactpersonController.prototype.putContactperson = function (form) {
                if (form) {
                    $('div.additional-field-dynamic.kontaktperson').fadeOut("slow").addClass("deactivated");
                }
            };
            ContactpersonController = __decorate([
                QMC.Controller('QMC.Common', 'ContactpersonDirectiveController'),
                QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], ContactpersonController);
            return ContactpersonController;
        }());
        var ContactpersonDirective = /** @class */ (function () {
            function ContactpersonDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Contactperson";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'ContactpersonDirectiveController';
                this.bindToController = true;
            }
            ContactpersonDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickContactperson', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], ContactpersonDirective);
            return ContactpersonDirective;
        }());
        Common.ContactpersonDirective = ContactpersonDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var AufgabeDirectiveController = /** @class */ (function () {
            function AufgabeDirectiveController(scope, $qui, taskService, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.taskService = taskService;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.participants = [];
                this.formState = 'new';
                this.loading = {
                    employee: true,
                    personList: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var employeesList = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 120000) {
                                employeesList.push(val[i].value);
                            }
                        }
                    }
                    _this.form.participants = employeesList;
                    _this.form.participants.push($('#session').data().personId);
                });
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.employee && !_this.loading.personList) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            AufgabeDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[840501]) {
                    this.new = cacheObject.permissions[840501].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            AufgabeDirectiveController.prototype.getData = function () {
                var _this = this;
                this.waitForPersonListsCache();
                this.waitForEmployeeListCache();
                this.taskService.getTaskWv().then(function (dataTaskWv) {
                    _this.wv = dataTaskWv;
                    _this.loading.wv = false;
                });
            };
            AufgabeDirectiveController.prototype.waitForEmployeeListCache = function () {
                var _this = this;
                var cacheObject = JSON.parse(sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE));
                if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
                    setTimeout(function () { _this.waitForEmployeeListCache(); }, 250);
                }
                else {
                    this.participants = cacheObject.employeeList.concat(this.participants);
                    this.loading.employee = false;
                }
            };
            AufgabeDirectiveController.prototype.waitForPersonListsCache = function () {
                var _this = this;
                var cacheObject = JSON.parse(sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE));
                if (!cacheObject.personLists || cacheObject.personLists.loading) {
                    setTimeout(function () { _this.waitForPersonListsCache(); }, 250);
                }
                else {
                    this.participants = this.participants.concat(cacheObject.personLists);
                    this.loading.personList = false;
                }
            };
            AufgabeDirectiveController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    taskName: null,
                    categoryId: null,
                    priorityId: null,
                    executionTypeId: null,
                    dateToFinishTill: new Date(),
                    isAppointment: false,
                    participants: [],
                    taskDescription: null
                };
            };
            AufgabeDirectiveController.prototype.getParticipantsList = function () {
                return this.participants;
            };
            AufgabeDirectiveController.prototype.getCategoryList = function () {
                return this.wv.categoryWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            };
            AufgabeDirectiveController.prototype.getPriorityList = function () {
                return this.wv.priorityWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            };
            AufgabeDirectiveController.prototype.getExecutionTypeList = function () {
                return this.wv.executionTypeWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            };
            AufgabeDirectiveController.prototype.addAufgabe = function (form) {
                this.taskService.postTask(form).then(function () {
                    $('div.additional-field-dynamic.aufgabe').fadeOut("slow").addClass("deactivated");
                });
            };
            AufgabeDirectiveController.prototype.putAufgabe = function (form) {
                if (form) {
                    this.taskService.putTask(form.objectId, form).then(function () {
                        $('div.additional-field-dynamic.aufgabe').fadeOut("slow").addClass("deactivated");
                    });
                }
            };
            AufgabeDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'AufgabeDirectiveController'),
                QMC.Inject('$scope', '$qui', "AufgabenService", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], AufgabeDirectiveController);
            return AufgabeDirectiveController;
        }());
        var AufgabeDirective = /** @class */ (function () {
            function AufgabeDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Aufgabe";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'AufgabeDirectiveController';
                this.bindToController = true;
            }
            AufgabeDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickAufgabe', ["AufgabenService", "StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], AufgabeDirective);
            return AufgabeDirective;
        }());
        Common.AufgabeDirective = AufgabeDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var AppointmentDirectiveController = /** @class */ (function () {
            function AppointmentDirectiveController(scope, $qui, terminService, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.terminService = terminService;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.clientList = [];
                this.employeeList = [];
                this.formState = 'new';
                this.loading = {
                    client: true,
                    employee: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    var employeesList = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 120000) {
                                employeesList.push(val[i].value);
                            }
                            else {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    _this.form.participants = clientsList;
                    _this.form.selectedEmployeeIds = employeesList;
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.client && !_this.loading.employee) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            AppointmentDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[400000]) {
                    this.new = cacheObject.permissions[400000].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            AppointmentDirectiveController.prototype.getData = function () {
                this.waitForClientListCache();
                this.waitForEmployeeListCache();
            };
            AppointmentDirectiveController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList;
                    this.loading.client = false;
                }
            };
            AppointmentDirectiveController.prototype.waitForEmployeeListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
                    setTimeout(function () { _this.waitForEmployeeListCache(); }, 250);
                }
                else {
                    this.employeeList = cacheObject.employeeList;
                    this.loading.employee = false;
                }
            };
            AppointmentDirectiveController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    title: null,
                    participants: [],
                    selectedEmployeeIds: [],
                    participantIds: [],
                    dateTo: new Date(),
                    dateFrom: new Date(),
                    location: null,
                    description: null,
                    isPrivate: false,
                    isFinished: false,
                    isAllDay: false,
                    version: null
                };
            };
            AppointmentDirectiveController.prototype.getClientList = function () {
                return this.clientList;
            };
            AppointmentDirectiveController.prototype.getEmployeeList = function () {
                return this.employeeList;
            };
            AppointmentDirectiveController.prototype.addAppointment = function (form) {
                if (form.selectedEmployeeIds !== undefined)
                    form.participantIds = form.selectedEmployeeIds.concat(form.participants);
                else if (form.participants !== undefined)
                    form.participantIds = form.participants;
                this.terminService.postAppointment(form).then(function () {
                    $('div.additional-field-dynamic.termin').fadeOut("slow").addClass("deactivated");
                });
            };
            AppointmentDirectiveController.prototype.putAppointment = function (form) {
                if (form) {
                    if (form.selectedEmployeeIds !== undefined)
                        form.participantIds = form.selectedEmployeeIds.concat(form.participants);
                    else if (form.participants !== undefined)
                        form.participantIds = form.participants;
                    this.terminService.putAppointment(false, form.objectId, form.dateFrom, false, form).then(function () {
                        $('div.additional-field-dynamic.termin').fadeOut("slow").addClass("deactivated");
                    });
                }
            };
            AppointmentDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'AppointmentDirectiveController'),
                QMC.Inject('$scope', '$qui', "TerminService", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], AppointmentDirectiveController);
            return AppointmentDirectiveController;
        }());
        var AppointmentDirective = /** @class */ (function () {
            function AppointmentDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Appointment";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'AppointmentDirectiveController';
                this.bindToController = true;
            }
            AppointmentDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickAppointment', ["TerminService", "StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], AppointmentDirective);
            return AppointmentDirective;
        }());
        Common.AppointmentDirective = AppointmentDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var AbsenteeismDirectiveController = /** @class */ (function () {
            function AbsenteeismDirectiveController(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.wvList = [];
                this.clientList = [];
                this.formState = 'new';
                this.loading = {
                    employee: true,
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    _this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.client && !_this.loading.employee) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            AbsenteeismDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140033]) {
                    this.new = cacheObject.permissions[140033].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            AbsenteeismDirectiveController.prototype.getData = function () {
                var _this = this;
                this.waitForClientListCache();
                this.waitForEmployeeListCache();
                this.stammdatenService.getAbsenteeismWv().then(function (data) {
                    _this.wvList = _this.ui.select(data.absenteeismReasonWvList, { value: 'objectId', text: 'name' });
                    _this.loading.wv = false;
                });
            };
            AbsenteeismDirectiveController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            };
            AbsenteeismDirectiveController.prototype.waitForEmployeeListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
                    setTimeout(function () { _this.waitForEmployeeListCache(); }, 250);
                }
                else {
                    this.clientList = this.clientList.concat(cacheObject.employeeList);
                    this.loading.employee = false;
                }
            };
            AbsenteeismDirectiveController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    participants: [],
                    objectId: null,
                    dateTo: new Date(),
                    dateFrom: new Date(),
                    absenteeismReasonId: null,
                    parentObjectId: null,
                    comment: null
                };
            };
            AbsenteeismDirectiveController.prototype.getWvList = function () {
                return this.wvList;
            };
            AbsenteeismDirectiveController.prototype.getClientList = function () {
                return this.clientList;
            };
            AbsenteeismDirectiveController.prototype.addAbsenteeism = function (form) {
                for (var i = 0; i < form.participants.length; i++) {
                    var data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    this.stammdatenService.postAbsenteeism(data);
                }
                $('div.additional-field-dynamic.abwesenheit').fadeOut("slow").addClass("deactivated");
            };
            ;
            AbsenteeismDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'AbsenteeismDirectiveController'),
                QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], AbsenteeismDirectiveController);
            return AbsenteeismDirectiveController;
        }());
        var AbsenteeismDirective = /** @class */ (function () {
            function AbsenteeismDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Away";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'AbsenteeismDirectiveController';
                this.bindToController = true;
            }
            AbsenteeismDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickAway', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], AbsenteeismDirective);
            return AbsenteeismDirective;
        }());
        Common.AbsenteeismDirective = AbsenteeismDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var DiseaseDirectiveController = /** @class */ (function () {
            function DiseaseDirectiveController(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.formState = 'new';
                this.diseases = [];
                this.wvList = [];
                this.clientList = [];
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    _this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.client) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            DiseaseDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140002]) {
                    this.new = cacheObject.permissions[140002].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            DiseaseDirectiveController.prototype.getData = function () {
                var _this = this;
                this.waitForClientListCache();
                this.stammdatenService.getDiseaseWvList().then(function (data) {
                    _this.wvList = _this.ui.select(data.diseaseCodeSchemaWvList, { value: 'id', text: 'name' });
                    _this.loading.wv = false;
                    setTimeout(function () {
                        _this.events();
                    }, 500);
                });
            };
            DiseaseDirectiveController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList;
                    this.loading.client = false;
                }
            };
            DiseaseDirectiveController.prototype.events = function () {
                var vm = this;
                $('#liveDiseases .typeahead').typeahead({
                    source: function (query, process) {
                        vm.stammdatenService.getDiseasesBySearchText(vm.form.diseaseCodeSchemaId, query).then(function (data) {
                            vm.diseases = data.items;
                            process(data.items.map(function (obj) {
                                return obj.name;
                            }));
                        });
                    },
                    updater: function (item) {
                        /* Find the id to the selected text */
                        for (var i = 0; i < vm.diseases.length; i++) {
                            if (vm.diseases[i].name === item)
                                vm.form.diseaseId = vm.diseases[i].id;
                        }
                        return item;
                    }
                });
            };
            DiseaseDirectiveController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    comment: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    diseaseCodeSchemaId: QMC.Common.Constants.DEFAULT_DISEASE_CODE_SCHEMA,
                    diseaseId: null,
                    parentObjectId: null
                };
            };
            DiseaseDirectiveController.prototype.getDiseaseWvList = function () {
                return this.wvList;
            };
            DiseaseDirectiveController.prototype.getClientList = function () {
                return this.clientList;
            };
            DiseaseDirectiveController.prototype.addDisease = function (form) {
                for (var i = 0; i < form.participants.length; i++) {
                    var data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    this.stammdatenService.postDisease(data);
                }
                $('div.additional-field-dynamic.krankheit').fadeOut("slow").addClass("deactivated");
            };
            ;
            DiseaseDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'DiseaseDirectiveController'),
                QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], DiseaseDirectiveController);
            return DiseaseDirectiveController;
        }());
        var DiseaseDirective = /** @class */ (function () {
            function DiseaseDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Disease";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'DiseaseDirectiveController';
                this.bindToController = true;
            }
            DiseaseDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickSick', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], DiseaseDirective);
            return DiseaseDirective;
        }());
        Common.DiseaseDirective = DiseaseDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var DocVisitDirectiveController = /** @class */ (function () {
            function DocVisitDirectiveController(scope, $qui, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.formState = 'new';
                this.diseases = [];
                this.doctors = [];
                this.medOrgas = [];
                this.clientList = [];
                this.loading = {
                    client: true,
                    employee: false,
                    //employee: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    _this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.client && !_this.loading.employee) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            DocVisitDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140003]) {
                    this.new = cacheObject.permissions[140003].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            DocVisitDirectiveController.prototype.getData = function () {
                var _this = this;
                this.waitForClientListCache();
                //this.waitForEmployeeListCache();
                this.stammdatenService.getDoctorList().then(function (data) {
                    _this.doctors = _this.ui.select(data, { value: 'id', text: 'displayTitle', group: _this.lng.translate(20010508, 'Arzt') });
                    _this.stammdatenService.getMedicalOrganisationList().then(function (data) {
                        _this.medOrgas = _this.ui.select(data, { value: 'id', text: 'name', group: _this.lng.translate(20023005, 'Medizinische Organisation') });
                        _this.loading.wv = false;
                    });
                });
            };
            DocVisitDirectiveController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            };
            //private waitForEmployeeListCache() {
            //    const cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
            //    const cacheObject = JSON.parse(cache);
            //    if (!cacheObject.employeeList || cacheObject.employeeList.loading) {
            //        setTimeout(() => { this.waitForEmployeeListCache() }, 250);
            //    } else {
            //        this.clientList = this.clientList.concat(cacheObject.employeeList);
            //        this.loading.employee = false;
            //    }
            //}
            DocVisitDirectiveController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    time: new Date(),
                    participants: [],
                    doctorId: null,
                    diagnose: null,
                    discipline: null,
                    forename: null,
                    name: null,
                    parentObjectId: null
                };
            };
            DocVisitDirectiveController.prototype.getDoctors = function () {
                return this.doctors.concat(this.medOrgas);
            };
            DocVisitDirectiveController.prototype.getClientList = function () {
                return this.clientList;
            };
            DocVisitDirectiveController.prototype.addDocVisit = function (form) {
                for (var i = 0; i < form.participants.length; i++) {
                    var data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    data.treaterObjectType = this.getTreaterObjectType(form.treaterId);
                    this.stammdatenService.postDoctorsVisit(data).then(function () {
                    });
                }
                $('div.additional-field-dynamic.arzt').fadeOut("slow").addClass("deactivated");
            };
            ;
            DocVisitDirectiveController.prototype.getTreaterObjectType = function (treaterId) {
                if (this.doctors.some(function (x) { return x.value === treaterId; }))
                    return 110000;
                if (this.medOrgas.some(function (x) { return x.value === treaterId; }))
                    return 310000;
                return 0;
            };
            DocVisitDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'DocVisitDirectiveController'),
                QMC.Inject('$scope', '$qui', "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], DocVisitDirectiveController);
            return DocVisitDirectiveController;
        }());
        var DocvisitDirective = /** @class */ (function () {
            function DocvisitDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Docvisit";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'DocVisitDirectiveController';
                this.bindToController = true;
            }
            DocvisitDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickDoctor', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], DocvisitDirective);
            return DocvisitDirective;
        }());
        Common.DocvisitDirective = DocvisitDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        var VaccinationDirectiveController = /** @class */ (function () {
            function VaccinationDirectiveController(scope, $qui, $q, stammdatenService, clientService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.$q = $q;
                this.stammdatenService = stammdatenService;
                this.clientService = clientService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.ui = new Common.DetailUI();
                this.formState = 'new';
                this.diseases = [];
                this.wvList = [];
                this.clientList = [];
                this.doctors = [];
                this.loading = {
                    client: true,
                    wv: true
                };
                this.waitForPermissionCache();
                this.initForm();
                this.scope.$watch('vm.qmParticipants', function (val) {
                    if (!val)
                        val = [];
                    var clientsList = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].objType) {
                            if (val[i].objType === 140000) {
                                clientsList.push(val[i].value);
                            }
                        }
                        else {
                            clientsList.push(val[i]);
                        }
                    }
                    _this.form.participants = clientsList;
                }, true);
                this.scope.$watch('vm.loading', function () {
                    if (!_this.loading.wv && !_this.loading.client) {
                        _this.$qui.functionWaiter("createForm", _this);
                    }
                }, true);
            }
            VaccinationDirectiveController.prototype.waitForPermissionCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = cache && cache.length > 0 ? JSON.parse(cache) : {};
                if (cacheObject.permissions && cacheObject.permissions[140005]) {
                    this.new = cacheObject.permissions[140005].new;
                    if (this.new)
                        this.getData();
                }
                else {
                    setTimeout(function () { _this.waitForPermissionCache(); });
                    return;
                }
            };
            VaccinationDirectiveController.prototype.getData = function () {
                var _this = this;
                this.waitForClientListCache();
                this.stammdatenService.getVaccinationWv().then(function (data) {
                    _this.wvList = _this.ui.select(data.diseaseVaccinationWvList, { value: 'id', text: 'name' });
                    _this.stammdatenService.getDoctorList().then(function (data) {
                        _this.doctors = _this.ui.select(data, { value: 'id', text: 'displayTitle' });
                        _this.loading.wv = false;
                    });
                });
            };
            VaccinationDirectiveController.prototype.waitForClientListCache = function () {
                var _this = this;
                var cache = sessionStorage.getItem(Common.Constants.SMARTACTIONCACHE);
                var cacheObject = JSON.parse(cache);
                if (!cacheObject.clientList || cacheObject.clientList.loading) {
                    setTimeout(function () { _this.waitForClientListCache(); }, 250);
                }
                else {
                    this.clientList = cacheObject.clientList.concat(this.clientList);
                    this.loading.client = false;
                }
            };
            VaccinationDirectiveController.prototype.initForm = function () {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: null,
                    participants: [],
                    date: new Date(),
                    dateFollowupAppointment: null,
                    caption: null,
                    comment: null,
                    batchNumber: null,
                    diseaseId: null,
                    doctorId: null
                };
            };
            VaccinationDirectiveController.prototype.getDiseases = function () {
                return this.wvList;
            };
            VaccinationDirectiveController.prototype.getClientList = function () {
                return this.clientList;
            };
            VaccinationDirectiveController.prototype.getDoctors = function () {
                return this.doctors;
            };
            VaccinationDirectiveController.prototype.addVaccination = function (form) {
                for (var i = 0; i < form.participants.length; i++) {
                    var data = jQuery.extend(true, {}, form);
                    data.parentObjectId = form.participants[i];
                    this.stammdatenService.postVaccination(data);
                }
                $('div.additional-field-dynamic.impfung').fadeOut("slow").addClass("deactivated");
            };
            ;
            VaccinationDirectiveController = __decorate([
                QMC.Controller('QMC.Common', 'VaccinationDirectiveController'),
                QMC.Inject('$scope', '$qui', "$q", "StammdatenService", "KlientService", "QmcLanguageService", "QmcPermissionService")
            ], VaccinationDirectiveController);
            return VaccinationDirectiveController;
        }());
        var VaccinationDirective = /** @class */ (function () {
            function VaccinationDirective() {
                this.restrict = 'E';
                this.replace = true;
                this.templateUrl = "./Templates/Smart/Vaccination";
                this.scope = {
                    qmParticipants: '='
                };
                this.controllerAs = 'vm';
                this.controller = 'VaccinationDirectiveController';
                this.bindToController = true;
            }
            VaccinationDirective = __decorate([
                QMC.Directive('QMC.Common', 'qmFormQuickImmunization', ["StammdatenService", "QmcLanguageService", "QmcPermissionService"])
            ], VaccinationDirective);
            return VaccinationDirective;
        }());
        Common.VaccinationDirective = VaccinationDirective;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        var ContingentDirective = /** @class */ (function () {
            function ContingentDirective(flsService, userService, $qui) {
                var _this = this;
                this.flsService = flsService;
                this.userService = userService;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmOpen: '=',
                    qmCase: '=',
                    qmDate: '='
                };
                this.templateUrl = 'Templates/Contingent';
                this.link = function (scope, element, attrs) {
                    var _a, _b;
                    scope.id = 'qmContingent_' + ((_b = (_a = scope.qmCase) === null || _a === void 0 ? void 0 : _a.objectId) !== null && _b !== void 0 ? _b : Math.random().toString(36).substr(2, 9));
                    scope.dontShowIndirect = window.dontShowIndirectContingent;
                    if (scope.dontShowIndirect === undefined) {
                        _this.userService.getUserSettings(["FLS.CONTINGENT.DONTSHOWINDRECT",]).then(function (data) {
                            scope.dontShowIndirect = $.grep(data, function (e) { return e.key === "FLS.CONTINGENT.DONTSHOWINDRECT"; })[0].value.toLowerCase() === "true";
                            window.dontShowIndirectContingent = scope.dontShowIndirect;
                        });
                    }
                    scope.qmOpen = function () {
                        if (!scope.qmCase)
                            return;
                        scope.date = scope.qmDate ? angular.copy(scope.qmDate) : moment().startOf('day').toDate();
                        $('#' + scope.id).modal('show');
                        _this.$qui.scopeApply(scope);
                    };
                    scope.$watch('date', function (newVal, oldVal) {
                        if (JSON.stringify(newVal) === JSON.stringify(oldVal) || !newVal)
                            return;
                        scope.load = true;
                        _this.flsService.getContingent(scope.qmCase.objectId, scope.date).then(function (data) {
                            scope.contingent = data;
                        }).finally(function () {
                            scope.load = false;
                        });
                    });
                    scope.$watch('qmCase', function (newVal, oldVal) {
                        if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                            return;
                        scope.date = undefined;
                        scope.contingent = undefined;
                    });
                    scope.showTargetDetails = function (contingent) {
                        return !scope.dontShowIndirect && contingent.targetedAmounts.direct && contingent.targetedAmounts.indirect;
                    };
                };
            }
            ContingentDirective = __decorate([
                QMC.Directive('QMC.Directives', 'qmContingent', ['FachleistungService', 'UserService', '$qui'])
            ], ContingentDirective);
            return ContingentDirective;
        }());
        Directives.ContingentDirective = ContingentDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        var IncludeDirective = /** @class */ (function () {
            function IncludeDirective($qui, $timeout, identityService) {
                var _this = this;
                this.$qui = $qui;
                this.$timeout = $timeout;
                this.identityService = identityService;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmPath: '=',
                    qmId: '@',
                    qmHeaderName: '@',
                    qmParams: '='
                };
                this.templateUrl = 'Templates/Include';
                this.link = function (scope, element, attrs) {
                    var secret = '';
                    var frame = null;
                    var iFrame = null;
                    if (scope.qmId === (null || undefined))
                        scope.qmId = '_' + Math.random().toString(36).substring(2, 11);
                    if (scope.qmHeaderName === (null || undefined))
                        scope.qmHeaderName = 'header';
                    var ceBaseUrl = $('#session').data().ceUrl;
                    if (!ceBaseUrl || ceBaseUrl.length === 0) {
                        element.innerHtml = "<strong>No exchange client url supplied</strong>";
                        return;
                    }
                    _this.identityService.setSecretToken().then(function (data) {
                        console.warn('got token token', data);
                        secret = data;
                        createIFrame();
                    });
                    scope.$watch('qmPath', function () {
                        createIFrame();
                    });
                    _this.$timeout(function () {
                        frame = $('#' + scope.qmId);
                        createIFrame();
                    });
                    var createIFrame = function () {
                        scope.loading = true;
                        if (frame === null || scope.qmPath === '' || secret === '')
                            return;
                        frame.remove('#' + scope.qmId + '_frame');
                        iFrame = document.createElement('iframe');
                        var color = '';
                        var colors = window.bodyColorClasses.split(' ');
                        for (var i = 0; i < colors.length; i++) {
                            if (document.body.classList.contains(colors[i])) {
                                color = colors[i];
                                break;
                            }
                        }
                        iFrame.src = (scope.qmPath.startsWith('http') ? '' : ceBaseUrl) + scope.qmPath
                            + '?secret=' + secret
                            + '&color=' + color
                            + '&oldClientUrl=' + location.origin + location.pathname
                            + '&dbConnection=' + $('#session').data().dbConnection
                            + '&' + new URLSearchParams(scope.qmParams).toString();
                        iFrame.style = 'width: 100%; height: 100%; border:0px;';
                        iFrame.id = scope.qmId + '_frame';
                        iFrame.sandbox = 'allow-downloads allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation';
                        frame.append(iFrame);
                        resize();
                        document.getElementById(scope.qmId + '_frame').addEventListener('load', function (e) {
                            scope.loading = false;
                            _this.$qui.scopeApply(_this);
                        });
                    };
                    var resize = function () {
                        if (iFrame === null)
                            return;
                        var isMobile = $('body').hasClass('mobile');
                        iFrame.style.height = 0 + "px";
                        var headerHeight = document.getElementById(scope.qmHeaderName) ? $('#' + scope.qmHeaderName).height() : 0;
                        if (isMobile) {
                            iFrame.style.height = Math.floor(window.innerHeight - 60 - $('#version-footer').height()) + "px";
                        }
                        else {
                            iFrame.style.height = Math.floor($('#page-wrapper').height() - headerHeight - $('#version-footer').height()) - 65 + "px";
                        }
                    };
                    createIFrame();
                    window.onresize = function () { resize(); };
                };
            }
            IncludeDirective = __decorate([
                QMC.Directive('QMC.Directives', 'qmInclude', ['$qui', '$timeout', 'QmcIdentityService'])
            ], IncludeDirective);
            return IncludeDirective;
        }());
        Directives.IncludeDirective = IncludeDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        var MarkItemDirective = /** @class */ (function () {
            function MarkItemDirective(markItemService, userService) {
                var _this = this;
                this.markItemService = markItemService;
                this.userService = userService;
                this.scope = {
                    saveMarkItem: '@',
                    qmBtnCircle: '=',
                    qmParentObjectIds: '=?',
                    qmParentObjectId: '=?',
                    qmParentObjectType: '@',
                    markItems: '@',
                    selectedMarkItems: '='
                };
                this.restrict = 'EA';
                this.templateUrl = 'Templates/MarkItem';
                this.link = function (scope) {
                    //first try to get the selectedMarkItems, for not showing validation error
                    scope.loadElements = function () {
                        if (scope.qmParentObjectIds == undefined || scope.qmParentObjectIds == null || scope.qmParentObjectIds.length == 0) {
                            scope.qmParentObjectIds = [];
                            scope.qmParentObjectIds.push(scope.qmParentObjectId);
                        }
                        _this.markItemService.getMarkItems().then(function (data) {
                            scope.markItems = data;
                            _this.markItemService.getSelectedMarkItems(scope.qmParentObjectIds[0], scope.qmParentObjectType).then(function (data) {
                                scope.selectedMarkItems = data;
                                for (var i = 0; i < scope.markItems.length; i++) {
                                    scope.markItems[i].isSelected = false;
                                    for (var j = 0; j < scope.selectedMarkItems.length; j++) {
                                        if (scope.markItems[i].id === scope.selectedMarkItems[j].markItemId) {
                                            scope.markItems[i].isSelected = true;
                                            if (scope.enableReason) {
                                                scope.markItems[i].reason = scope.selectedMarkItems[j].reason;
                                            }
                                        }
                                    }
                                }
                            });
                        });
                    };
                    _this.userService.getUserSettings(['MARKIEREN.GRUND'], false).then(function (data) {
                        scope.enableReason = data[0].value.toLowerCase() === 'true';
                        scope.loadElements();
                    });
                    scope.initModal = function () {
                        scope.loadElements();
                    };
                    scope.saveSelectedMarkItems = function () {
                        scope.selectedMarkItems = [];
                        for (var j = 0; j < scope.qmParentObjectIds.length; j++) {
                            var data = {
                                parentObjectId: scope.qmParentObjectIds[j],
                                parentObjectType: parseInt(scope.qmParentObjectType),
                                markItems: [],
                                id: null,
                                objectId: null
                            };
                            for (var i = 0; i < scope.markItems.length; i++) {
                                if (scope.markItems[i].isSelected) {
                                    data.markItems.push({ key: scope.markItems[i].id, value: scope.enableReason && scope.markItems[i].reason && scope.markItems[i].reason.length > 0 ? scope.markItems[i].reason : '' });
                                    scope.selectedMarkItems.push({ key: scope.markItems[i].id, value: scope.enableReason && scope.markItems[i].reason && scope.markItems[i].reason.length > 0 ? scope.markItems[i].reason : '' });
                                }
                            }
                            _this.markItemService.putSelectedMarkItems(data);
                        }
                    };
                };
            }
            MarkItemDirective = __decorate([
                QMC.Directive('QMC.Directives', 'qmMarkItem', ['QmcMarkItemService', 'UserService'])
            ], MarkItemDirective);
            return MarkItemDirective;
        }());
        Directives.MarkItemDirective = MarkItemDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        var MaximizeModalButton = /** @class */ (function () {
            function MaximizeModalButton() {
                this.isMax = false;
            }
            MaximizeModalButton.prototype.toggle = function (buttonElement) {
                $(buttonElement).parents().find('.modal-dialog').toggleClass('modal-fullscreen');
                this.isMax = !this.isMax;
            };
            return MaximizeModalButton;
        }());
        angular.module('QMC.Directives').component('qmMaximizeModalButton', {
            controller: [MaximizeModalButton],
            controllerAs: 'vm',
            replace: true,
            template: '<span class="close hidden-xs" ng-click="vm.toggle($event.currentTarget)">' +
                '<i ng-if="!vm.isMax"  class="fa fa-expand" aria-hidden="true"> </i>' +
                '<i ng-if="vm.isMax" class="fa fa-compress" aria-hidden="true"> </i>' +
                '</span>'
        });
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        var PrivateContent = /** @class */ (function () {
            function PrivateContent(privateContentService, permissionService, $qui) {
                var _this = this;
                this.privateContentService = privateContentService;
                this.permissionService = permissionService;
                this.$qui = $qui;
                this.scope = {
                    savePrivateContent: '@',
                    qmReference: '=',
                    qmParent: '=',
                    qmObjectType: '=',
                    qmFloating: '=',
                    qmMuted: '='
                };
                this.restrict = 'EA';
                this.templateUrl = 'Templates/PrivateContent';
                this.link = function (scope) {
                    _this.getPermission(scope);
                    scope.newPC = true;
                    scope.sn = { comment: '' };
                    scope.init = false;
                    scope.openModal = function () {
                        scope.loading = true;
                        $("#privateContentModal" + scope.qmParent).modal("show");
                        _this.privateContentService.getPrivateContent(scope.qmParent, scope.qmReference).then(function (data) {
                            if (data !== null) {
                                scope.newPC = false;
                                scope.sn.comment = data.comment;
                            }
                            else {
                                scope.newPC = true;
                                scope.sn.comment = '';
                            }
                            scope.loading = false;
                            if (!scope.init) {
                                scope.init = true;
                            }
                        });
                    };
                    scope.save = function () {
                        document.getElementById("pcSaveBtn").focus();
                        scope.loading = true;
                        if (scope.newPC) {
                            _this.privateContentService.postPrivateContent({
                                referenceObjectId: scope.qmReference,
                                parentObjectId: scope.qmParent,
                                parentObjectType: scope.qmObjectType,
                                comment: scope.sn.comment,
                                id: null,
                                objectId: null
                            }).then(function (response) {
                                $("#privateContentModal" + scope.qmParent).modal("hide");
                            }).finally(function () {
                                scope.loading = false;
                            });
                        }
                        // recycle an existing pc
                        else {
                            _this.privateContentService.putPrivateContent(scope.qmParent, scope.qmReference, {
                                comment: scope.sn.comment,
                                id: null,
                                objectId: null
                            }).then(function (response) {
                                $("#privateContentModal" + scope.qmParent).modal("hide");
                            }).finally(function () {
                                scope.loading = false;
                            });
                        }
                    };
                };
            }
            PrivateContent.prototype.getPermission = function (scope) {
                var _this = this;
                var storagePermission = sessionStorage.getItem("privateContentPermission");
                if (storagePermission && storagePermission !== '') {
                    var data = JSON.parse(storagePermission);
                    if (Date.now() - this.$qui.createDateFromString(data.timeStamp) < 5 * 60 * 1000) { // only if permission is max 5 minutes old
                        scope.delete = data.delete && data.moduleAccess;
                        scope.new = data.new && data.moduleAccess;
                        scope.modify = data.modify && data.moduleAccess;
                        scope.view = data.view && data.moduleAccess;
                    }
                    else {
                        //getPermission();
                        this.$qui.cachePrivateContentPermission(this.permissionService);
                        setTimeout(function () { _this.getPermission(scope); }, 500);
                    }
                }
                else {
                    //getPermission();
                    this.$qui.cachePrivateContentPermission(this.permissionService);
                    setTimeout(function () { _this.getPermission(scope); }, 500);
                }
            };
            ;
            PrivateContent = __decorate([
                QMC.Directive('QMC.Directives', 'qmPrivateContent', ['QmcPrivateContentService', 'QmcPermissionService', '$qui'])
            ], PrivateContent);
            return PrivateContent;
        }());
        Directives.PrivateContent = PrivateContent;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Directives;
    (function (Directives) {
        var SurveyDirective = /** @class */ (function () {
            function SurveyDirective(userService) {
                var _this = this;
                this.userService = userService;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {};
                this.templateUrl = 'Templates/Survey';
                this.link = function (scope) {
                    _this.userService.getSurvey().then(function (data) {
                        scope.survey = data;
                        if (data) {
                            setTimeout(function () { return $('#surveyModal').modal('show'); }, 5000); //delay show of modal to prevent automatic close on app init
                        }
                    });
                    scope.closeSurvey = function (dismissSurvey, performed) {
                        if (performed === void 0) { performed = false; }
                        if (dismissSurvey)
                            _this.userService.dismissSurvey(scope.survey.surveyId, performed);
                        $('#surveyModal').modal('hide');
                    };
                    scope.participateInSurvey = function () {
                        scope.closeSurvey(true, true);
                        window.open(scope.survey.link, '_blank').focus();
                    };
                };
            }
            SurveyDirective = __decorate([
                QMC.Directive('QMC.Directives', 'qmSurvey', ['UserService'])
            ], SurveyDirective);
            return SurveyDirective;
        }());
        Directives.SurveyDirective = SurveyDirective;
    })(Directives = QMC.Directives || (QMC.Directives = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var UdfContainer = /** @class */ (function () {
            function UdfContainer() {
                this.show = false;
            }
            UdfContainer.prototype.allDataValid = function () {
                var _a, _b, _c;
                return (((_a = this.data) === null || _a === void 0 ? void 0 : _a.definitionId) && this.data.definitionId !== QMC.Common.Constants.GUID_EMPTY && ((_b = this.data) === null || _b === void 0 ? void 0 : _b.definitionObjectType) &&
                    this.data.referenceId && this.data.referenceId !== QMC.Common.Constants.GUID_EMPTY && ((_c = this.data) === null || _c === void 0 ? void 0 : _c.referenceObjectType) &&
                    this.data.type >= 0 && this.data.type <= 5);
            };
            return UdfContainer;
        }());
        angular.module('QMC.Udf').component('qmUdfContainer', {
            templateUrl: 'UserDefinedFields/Container',
            controller: [UdfContainer],
            controllerAs: 'vm',
            bindings: {
                data: '=',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var FormDirective = /** @class */ (function () {
            function FormDirective(scope, $qui, udfService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.rows = [];
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.wvDsData = {};
                this.timeValues = {};
                this.formWatcher = [];
                this.isTouched = false;
                this.touchWatcher = [];
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF-Form: reference, defintion or udf not set!', _this.reference, _this.definition, _this.udf);
                        return;
                    }
                    _this.init();
                    _this.events();
                    _this.reset = function () { _this.createRowsFromUdf(); };
                };
                this.$onDestroy = function () {
                    _this.clearFormWatcher();
                };
            }
            FormDirective.prototype.init = function () {
                this.createRowsFromUdf();
                this.loadWvAndDataSourcesFromUdf();
            };
            FormDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.udf', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.init();
                }, true);
                this.isTouched = false;
                this.touchWatcher.forEach(function (watcher) { return watcher(); });
                this.touchWatcher = [];
                for (var i = 0; i < this.udf.fields.length; i++) {
                    this.touchWatcher.push(this.scope.$watch("vm.udf.fields[" + i + "].values", function (newVal, oldVal) {
                        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
                            _this.isTouched = true;
                    }, true));
                }
            };
            FormDirective.prototype.createRowsFromUdf = function () {
                var _this = this;
                var _a, _b, _c, _d;
                this.isTouched = false;
                this.rows = [];
                (_a = this.udf) === null || _a === void 0 ? void 0 : _a.fields.sort(function (x, y) { return x.column - y.column; }).forEach(function (field) {
                    //convert dates
                    if ((field.fieldType === 10 || field.fieldType === 12) && field.values.length)
                        field.values[0] = _this.$qui.createDateFromString(field.values[0]);
                    var row = _this.rows.find(function (x) { return x.row === field.row; });
                    if (!row) {
                        row = { row: field.row, fields: [field] };
                        _this.rows.push(row);
                    }
                    else {
                        row.fields.push(field);
                    }
                });
                this.rows = this.rows.sort(function (a, b) { return a.row - b.row; });
                var maxColumns = Math.max.apply(Math, (_d = (_c = (_b = this.udf) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.map(function (x) { return x.column; })) !== null && _d !== void 0 ? _d : [0]);
                // per row fillup missing columns with blanks
                this.rows.forEach(function (row) {
                    var _loop_2 = function (i) {
                        if (!row.fields.find(function (x) { return x.column == i; }))
                            row.fields.push({
                                values: [],
                                wvId: QMC.Common.Constants.GUID_EMPTY,
                                fieldType: -1,
                                caption: '',
                                isRequired: false,
                                row: row.row,
                                column: i,
                                id: null,
                                objectId: null
                            });
                    };
                    for (var i = 0; i <= maxColumns; i++) {
                        _loop_2(i);
                    }
                    row.fields = row.fields.sort(function (a, b) { return a.column - b.column; });
                });
                this.clearFormWatcher();
                var _loop_1 = function (i) {
                    var field = this_1.udf.fields[i];
                    if (field.values && [40, 50, 60, 70].includes(field.fieldType)) { // ensure format of values for wvs and dss
                        field.values = field.values.map(function (x) { return (x === null || x === void 0 ? void 0 : x.toLocaleLowerCase) ? x.toLocaleLowerCase() : x; });
                    }
                    if (this_1.udf.fields[i].fieldType !== 12)
                        return "continue";
                    this_1.timeValues[field.objectId] = angular.copy(field.values[0]);
                    this_1.formWatcher.push(this_1.scope.$watch("vm.timeValues['" + field.objectId + "']", function (newVal, oldVal) {
                        _this.handleDateTimeWatch(field, newVal, oldVal);
                    }));
                    this_1.formWatcher.push(this_1.scope.$watch("vm.udf.fields[" + i + "].values[0]", function (newVal, oldVal) {
                        _this.handleDateTimeWatch(field, newVal, oldVal);
                    }));
                };
                var this_1 = this;
                //workaround for datetime: store time in seperate object, indexed by field id. Watch said objects property and actual value to keep both in sync
                for (var i = 0; i < this.udf.fields.length; i++) {
                    _loop_1(i);
                }
            };
            FormDirective.prototype.handleDateTimeWatch = function (field, newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                    return;
                if (!newVal) {
                    field.values = [];
                    return;
                }
                field.values[0] = this.$qui.addTimeToDate(field.values[0], this.timeValues[field.objectId]);
            };
            FormDirective.prototype.loadWvAndDataSourcesFromUdf = function () {
                var _this = this;
                this.udf.fields.forEach(function (field) {
                    if (!field.wvId || _this.wvDsData[field.wvId])
                        return;
                    _this.wvDsData[field.wvId] = [];
                    if (field.fieldType === 40 || field.fieldType === 60)
                        _this.udfService.getWv(field.wvId).then(function (data) { return _this.wvDsData[field.wvId] = data.map(function (x) { return ({ text: x.name, value: x.objectId }); }); });
                    if (field.fieldType === 50 || field.fieldType === 70)
                        _this.udfService.getDs(field.wvId).then(function (data) { return _this.wvDsData[field.wvId] = data.map(function (x) { return ({ text: x.caption, value: x.objectId }); }); });
                });
            };
            FormDirective.prototype.clearFormWatcher = function () {
                this.formWatcher.forEach(function (x) { return x(); });
                this.formWatcher = [];
            };
            return FormDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfForm', {
            templateUrl: 'UserDefinedFields/Form',
            controller: ['$scope', '$qui', 'QmcUdfService', FormDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                disabled: '=?',
                isValid: '=?',
                udf: '=',
                reset: '=?',
                isTouched: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var MediaDirective = /** @class */ (function () {
            function MediaDirective($qui, scope, udfService, mediaService, lng, stammdatenService) {
                var _this = this;
                this.$qui = $qui;
                this.scope = scope;
                this.udfService = udfService;
                this.mediaService = mediaService;
                this.lng = lng;
                this.stammdatenService = stammdatenService;
                this.files = [];
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.promptOptions = {
                    title: '',
                    yesNo: true,
                    icon: "qm-icon-garbage_can",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                    itemText: ''
                };
                this.$postLink = function () {
                    _this.loadMedia();
                    _this.events();
                };
            }
            MediaDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.field', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.loadMedia();
                }, true);
                this.scope.$watch('vm.newForm.file', function (newVal, oldVal) {
                    var _a;
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    var file = _this.newForm.file[_this.newForm.file.length - 1];
                    if (!file)
                        return;
                    _this.newForm.caption = file.name.substring(0, (_a = file.name.lastIndexOf('.')) !== null && _a !== void 0 ? _a : file.name.length);
                }, true);
            };
            MediaDirective.prototype.loadMedia = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var mediaId;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!!this.field.values.length) return [3 /*break*/, 2];
                                this.loading = true;
                                return [4 /*yield*/, this.createMedia()];
                            case 1:
                                mediaId = _a.sent();
                                if (mediaId) {
                                    this.field.values.push(mediaId);
                                    this.error = undefined;
                                }
                                else {
                                    this.error = 'Media could not be initialized';
                                    return [2 /*return*/];
                                }
                                _a.label = 2;
                            case 2:
                                this.loading = true;
                                this.udfService.getUserDefinedFieldMedia(this.field.values[0])
                                    .then(function (data) {
                                    _this.files = data;
                                    _this.files.forEach(function (file) {
                                        //load thumbnails for fotos
                                        if (file.mediaType === 1) {
                                            _this.mediaService.getMediaThumbnail(file.objectId, file.mediaType).then(function (data) {
                                                file.thumbnail = data.base64.length ? 'data:' + data.mimeType + ';base64,' + data.base64 : '';
                                            });
                                        }
                                    });
                                })
                                    .catch(function () { return _this.files = []; })
                                    .finally(function () { return _this.loading = false; });
                                return [2 /*return*/];
                        }
                    });
                });
            };
            MediaDirective.prototype.createMedia = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this.stammdatenService.postNewDocument({
                                    isMainDataSet: 0,
                                    itemOrder: 0,
                                    objectType: _this.definition.objectType,
                                    parentObjectId: QMC.Common.Constants.GUID_EMPTY,
                                    parentObjectType: _this.definition.objectType,
                                    date: moment().startOf('day').toDate(),
                                    title: _this.field.caption,
                                    subtitle: _this.lng.translate(20036008, "über Flexfelder verbunden"),
                                    isPrivate: false,
                                    documentTypeId: _this.field.fieldType === 80 ? 'e95b9228-1626-4eb3-a54c-b2b6ec7524f2' : 'd5b77c29-bd93-46f9-b1ec-322caf68292d',
                                    mediaType: _this.field.fieldType === 80 ? 1 : 2,
                                    mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                                    subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                                    comment: ''
                                }).then(function (data) {
                                    var mediaId = data[0].value.createdObjectId;
                                    return resolve(mediaId);
                                }).catch(function () {
                                    return reject(new Error('Could not create media'));
                                });
                            })];
                    });
                });
            };
            MediaDirective.prototype.getIcon = function (file) {
                var _a, _b, _c;
                var extension = (_c = (_b = (_a = file === null || file === void 0 ? void 0 : file.fileName) === null || _a === void 0 ? void 0 : _a.substring(file.fileName.lastIndexOf('.') + 1)) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
                switch (extension) {
                    case 'png':
                    case 'jpg':
                    case 'jpeg':
                    case 'svg':
                    case 'bmp':
                    case 'gif':
                        return 'image-o';
                    case 'mov':
                    case 'webm':
                    case 'mpeg':
                    case 'mkv':
                    case 'mp4':
                        return 'video-o';
                    case 'zip':
                    case '7z':
                    case 'pkg':
                    case 'dmg':
                    case 'tar':
                    case 'gz':
                        return 'archive-o';
                    case 'pdf':
                        return 'pdf-o';
                    case 'doc':
                    case 'docx':
                        return 'word-o';
                    case 'ppt':
                    case 'pptx':
                        return 'powerpoint-o';
                    case 'text':
                    case 'txt':
                        return 'text-o';
                    case 'xls':
                    case 'xlsx':
                        return 'excel-o';
                    default: return 'o';
                }
            };
            MediaDirective.prototype.getFileExtension = function (file) {
                var _a, _b, _c;
                return (_c = (_b = (_a = file === null || file === void 0 ? void 0 : file.fileName) === null || _a === void 0 ? void 0 : _a.substring(file.fileName.lastIndexOf('.') + 1)) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
            };
            MediaDirective.prototype.getAcceptedFileTypes = function () {
                if (this.field.fieldType === 80)
                    return 'image/*';
                return '.doc,.docx,.xls,.xlsx,.pdf,.txt';
            };
            MediaDirective.prototype.openFile = function (file) {
                var _this = this;
                this.selectedFile = file;
                $("#previewModal" + this.id).modal('show');
                this.loadingPreview = true;
                this.mediaService.getMediaFile(file.objectId, file.mediaType)
                    .then(function (data) { return _this.selectedFile.base64 = data.base64; })
                    .catch(function () { return _this.selectedFile.base64 = ''; })
                    .finally(function () { return _this.loadingPreview = false; });
            };
            MediaDirective.prototype.deleteFile = function (file) {
                var _this = this;
                this.promptOptions = __assign(__assign({}, this.promptOptions), { title: this.field.caption, itemText: file.fileName });
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.loadingPreview = true;
                        _this.loading = true;
                        _this.mediaService.deleteMediaAttachementDirect(file.objectId)
                            .then(function () { return $("#previewModal" + _this.id).modal('hide'); })
                            .finally(function () {
                            _this.loadingPreview = false;
                            _this.loadMedia();
                        });
                    }
                }, "#prompt" + this.id);
            };
            MediaDirective.prototype.openNewFile = function () {
                this.newForm = {
                    caption: '',
                    file: []
                };
                $("#newModal" + this.id).modal('show');
            };
            MediaDirective.prototype.uploadFile = function () {
                var _this = this;
                var file = this.newForm.file[this.newForm.file.length - 1];
                if (!file)
                    return;
                this.loadingNew = true;
                this.mediaService.postMediaAttachement({
                    documentId: this.field.values[0],
                    base64String: file.base64,
                    date: new Date(),
                    fileName: file.name,
                    caption: this.newForm.caption,
                    mediaType: this.field.fieldType === 80 ? 1 : 2 // if we have image type udf, set type 1 (foto), else type 2 (dokument)
                })
                    .then(function () { return $("#newModal" + _this.id).modal('hide'); })
                    .finally(function () {
                    _this.loadMedia();
                    _this.loadingNew = false;
                });
            };
            return MediaDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfMedia', {
            templateUrl: 'UserDefinedFields/Media',
            controller: ['$qui', '$scope', 'QmcUdfService', 'QmcMediaService', 'QmcLanguageService', 'StammdatenService', MediaDirective],
            controllerAs: 'vm',
            bindings: {
                field: '=',
                qmDisabled: '=?',
                definition: '='
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var SaveButtonDirective = /** @class */ (function () {
            function SaveButtonDirective($qui, $scope) {
                var _this = this;
                this.$qui = $qui;
                this.$scope = $scope;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.$postLink = function () {
                    $(document).scroll(function () {
                        _this.checkViewport();
                    });
                    setInterval(function () {
                        _this.checkViewport();
                    }, 1000);
                };
            }
            SaveButtonDirective.prototype.checkViewport = function () {
                var element = document.getElementById(this.id);
                if (!element)
                    return;
                var rect = document.getElementById(this.id).getBoundingClientRect();
                if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
                    $("#" + this.id + "_float").fadeOut();
                }
                else {
                    $("#" + this.id + "_float").fadeIn();
                }
                this.$qui.scopeApply(this.$scope);
            };
            return SaveButtonDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfSaveButton', {
            controller: ['$qui', '$scope', SaveButtonDirective],
            controllerAs: 'vm',
            bindings: {
                disabled: '=',
                hide: '=',
                callback: '='
            },
            templateUrl: 'UserDefinedFields/Save_Button'
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var StandardDirective = /** @class */ (function () {
            function StandardDirective($qui, scope, udfService, permissionService) {
                var _this = this;
                this.$qui = $qui;
                this.scope = scope;
                this.udfService = udfService;
                this.permissionService = permissionService;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.loading = true;
                    _this.loadPermissions();
                    _this.init();
                    _this.events();
                    _this.save = function (showNotification) {
                        if (showNotification === void 0) { showNotification = true; }
                        // nothing to save, yield
                        if (!_this.udf.fields.length || !_this.isTouched || !_this.isValid)
                            return Promise.resolve(true);
                        var saveObject = {
                            values: {},
                            udfId: _this.udf.udfId
                        };
                        _this.udf.fields.forEach(function (field) {
                            saveObject.values[field.objectId] = field.values;
                        });
                        _this.loading = true;
                        return _this.udfService.updateUserDefinedField(_this.reference.objectType, _this.reference.id, _this.definition.objectType, _this.definition.id, saveObject, _this.timeframe).then(function () {
                            if (showNotification)
                                _this.$qui.notify(_this.$qui.successNote);
                            _this.isTouched = false;
                            return true;
                        }).catch(function (e) {
                            console.error('Error saving udf', e);
                            return false;
                        }).finally(function () {
                            _this.init();
                        });
                    };
                };
            }
            StandardDirective.prototype.init = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, this.timeframe).then(function (data) {
                    _this.udf = data[0];
                }).finally(function () {
                    _this.loading = false;
                    setTimeout(function () { return _this.isTouched = false; });
                });
            };
            StandardDirective.prototype.events = function () {
                var _this = this;
                var initCheckFunc = function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.init();
                };
                this.scope.$watch('vm.reference', function (newVal, oldVal) { return initCheckFunc(newVal, oldVal); }, true);
                this.scope.$watch('vm.definition', function (newVal, oldVal) { return initCheckFunc(newVal, oldVal); }, true);
                this.scope.$watch('vm.timeframe', function (newVal, oldVal) { return initCheckFunc(newVal, oldVal); });
                this.scope.$watch('vm.definition.objectType', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.loadPermissions();
                });
                this.scope.$watch('vm.permissionObjectType', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.loadPermissions();
                });
            };
            StandardDirective.prototype.loadPermissions = function () {
                var _this = this;
                var _a;
                this.permissionService.getPermissionsByObjectTypes([(_a = this.permissionObjectType) !== null && _a !== void 0 ? _a : this.definition.objectType]).then(function (data) {
                    _this.permissions = data[0];
                }).catch(function () { return _this.permissions = { view: false, modify: false, new: false, delete: false }; });
            };
            return StandardDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfStandard', {
            templateUrl: 'UserDefinedFields/Standard',
            controller: ['$qui', '$scope', 'QmcUdfService', 'QmcPermissionService', StandardDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                timeframe: '=?',
                permissionObjectType: '=?',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var SingletimeDirective = /** @class */ (function () {
            function SingletimeDirective(scope, $qui, udfService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.formState = 'new';
                this.definitionValues = [];
                this.promptOptions = {
                    title: this.lng.translate(20036006, 'Einzelzeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.ui = new Udf.UdfUi(this.lng);
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.loading = true;
                    _this.getDefinition();
                    _this.permissionService.getPermissionsByObjectTypes([_this.definition.objectType]).then(function (data) {
                        _this.permissions = data[0];
                        _this.events();
                        _this.init();
                    }).catch(function (e) {
                        console.error('Error loading udf permission', e);
                        _this.loading = false;
                    });
                };
            }
            SingletimeDirective.prototype.init = function () {
                this.getUdfData();
            };
            SingletimeDirective.prototype.addSingletime = function () {
                this.form = {
                    //fields: angular.copy(this.definitionValues.filter(x => ![80,81,82].includes(x.fieldType))), // media is not support on creation at the moment
                    fields: angular.copy(this.definitionValues),
                    id: null,
                    objectId: null,
                    udfId: null,
                    dateFrom: new Date()
                };
                this.formState = 'new';
                this.openFormModal();
            };
            SingletimeDirective.prototype.openSingletime = function (udf) {
                this.form = angular.copy(udf);
                this.formState = 'edit';
                this.openFormModal();
            };
            SingletimeDirective.prototype.openFormModal = function () {
                $("#singletime-form-modal" + this.id).modal('show');
                this.$qui.functionWaiter("initForm", this);
            };
            SingletimeDirective.prototype.createSingletime = function () {
                var _this = this;
                this.loading = true;
                this.udfService.createSingletime(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, { dateFrom: this.form.dateFrom, dateTo: this.form.dateTo }).then(function (data) {
                    _this.form.udfId = data.createdObjectId;
                    _this.updateSingletime();
                }).catch(function (e) {
                    console.error('Error creating singletime', e);
                    _this.loading = false;
                    _this.init();
                });
            };
            SingletimeDirective.prototype.updateSingletime = function () {
                var _this = this;
                var saveObject = {
                    values: {},
                    udfId: this.form.udfId,
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo
                };
                this.form.fields.forEach(function (field) {
                    saveObject.values[field.objectId] = field.values;
                });
                this.loading = true;
                this.udfService.updateUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, saveObject).then(function () {
                    _this.$qui.notify(_this.$qui.successNote);
                }).catch(function (e) {
                    console.error('Error saving udf', e);
                }).finally(function () {
                    _this.init();
                    $("#singletime-form-modal" + _this.id).modal('hide');
                });
            };
            SingletimeDirective.prototype.deleteSingletime = function (udf) {
                var _this = this;
                this.promptOptions.itemText = this.createDateString(udf.dateFrom, udf.dateTo);
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    _this.loading = true;
                    _this.udfService.deleteSingletime(_this.reference.objectType, _this.reference.id, _this.definition.objectType, _this.definition.id, udf.udfId).finally(function () { return _this.init(); });
                }, "#udf-singletime-delete-prompt-" + this.id);
            };
            SingletimeDirective.prototype.isValidDate = function (date) {
                return moment(date).isValid();
            };
            SingletimeDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.defintion', function (newVal, oldVal) {
                    if (newVal !== oldVal)
                        _this.getDefinition();
                }, true);
            };
            SingletimeDirective.prototype.getDefinition = function () {
                var _this = this;
                this.udfService.getUserDefinedFieldDefintion(this.definition.objectType, this.definition.id).then(function (data) {
                    _this.definitionValues = data;
                }).catch(function () { return _this.definitionValues = []; });
            };
            SingletimeDirective.prototype.getUdfData = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, null, false).then(function (data) {
                    data.forEach(function (x) {
                        if (x.dateFrom)
                            x.dateFrom = _this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = _this.$qui.createDateFromString(x.dateTo);
                    });
                    _this.udfs = data.sort(function (a, b) { var _a, _b, _c, _d; return (_d = (_b = (_a = b.dateFrom) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0 - ((_c = a.dateFrom) === null || _c === void 0 ? void 0 : _c.getTime())) !== null && _d !== void 0 ? _d : 0; });
                }).finally(function () {
                    _this.loading = false;
                });
            };
            SingletimeDirective.prototype.createDateString = function (dateFrom, dateTo) {
                return this.ui.createDateString(dateFrom, dateTo);
            };
            return SingletimeDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfSingletime', {
            templateUrl: 'UserDefinedFields/Singletime',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', 'QmcPermissionService', SingletimeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var TabDirective = /** @class */ (function () {
            function TabDirective(scope, $qui, udfService, lng, $timeout) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.$timeout = $timeout;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.saveFunctions = {};
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.tabs = [];
                this.touched = [];
                this.valid = [];
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.events();
                    _this.init();
                    _this.saveAll = function (showNotification) {
                        if (showNotification === void 0) { showNotification = true; }
                        var promises = [];
                        for (var key in _this.saveFunctions) {
                            promises.push(_this.saveFunctions[key](false));
                        }
                        ;
                        return new Promise(function (resolve, reject) {
                            Promise.all(promises).then(function (saveResults) {
                                if (saveResults.some(function (x) { return !x; }))
                                    _this.$qui.notify({
                                        message: _this.lng.translate(20002062, "Es konnten nicht alle Einträge gespeichert werden!"),
                                        title: _this.lng.translate(20002015, "Fehler"),
                                        icon: "qm-icon-delete",
                                        status: "warning",
                                        timer: 3500
                                    });
                                else if (showNotification)
                                    _this.$qui.notify(_this.$qui.successNote);
                                resolve();
                            }).catch(reject);
                        });
                    };
                    _this.scope.$watch('vm.touched', function () { _this.isTouched = _this.touched.reduce(function (prev, curr) { return prev || curr; }, false); }, true);
                    _this.scope.$watch('vm.valid', function () { _this.isValid = _this.valid.reduce(function (prev, curr) { return prev && curr; }, true); }, true);
                };
            }
            TabDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.definition.objectType', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    if (!newVal)
                        _this.tabs = [];
                    else
                        _this.init();
                });
            };
            TabDirective.prototype.init = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getTabs(this.definition.objectType).then(function (data) {
                    _this.tabs = data;
                    if (_this.tabs.length) {
                        _this.$timeout(function () { return _this.$qui.waitForEl("#udf-tab-0-button" + _this.id, function () { document.getElementById("udf-tab-0-button" + _this.id).click(); }); });
                    }
                }).catch(function (e) {
                    console.error('Error getting tabs', e);
                    _this.tabs = [];
                }).finally(function () { return _this.loading = false; });
            };
            return TabDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfTab', {
            templateUrl: 'UserDefinedFields/Tab',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', '$timeout', TabDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                timeframe: '=?',
                permissionObjectType: '=?',
                saveAll: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var TabSingletimeDirective = /** @class */ (function () {
            function TabSingletimeDirective(scope, $qui, udfService, lng, permissionService, $timeout) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.ui = new Udf.UdfUi(this.lng);
                this.timeframeForm = {
                    state: 'new',
                    validation: {
                        isLoading: false,
                        warnings: [],
                        errors: []
                    }
                };
                this.promptOptions = {
                    title: this.lng.translate(20036006, 'Einzelzeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.permissionService.getPermissionsByObjectTypes([_this.definition.objectType]).then(function (data) {
                        _this.permissions = data[0];
                        _this.events();
                        _this.init();
                    }).catch(function (e) {
                        console.error('Error loading udf permission', e);
                        _this.loading = false;
                    });
                };
            }
            TabSingletimeDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.timeframeForm.form', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.timeframeForm.validation = {
                        isLoading: true,
                        warnings: [],
                        errors: []
                    };
                    _this.udfService.valiadateTimeframe(_this.definition.objectType, _this.timeframeForm.form).then(function (data) {
                        _this.timeframeForm.validation.errors = data.errors;
                        _this.timeframeForm.validation.warnings = data.warnings;
                    }).catch(function (e) {
                        console.error('Error validating udf-timeframe', e);
                        _this.timeframeForm.validation.errors = [_this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                    }).finally(function () { return _this.timeframeForm.validation.isLoading = false; });
                }, true);
            };
            TabSingletimeDirective.prototype.init = function () {
                this.getUdfData();
            };
            TabSingletimeDirective.prototype.getUdfData = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, null, false).then(function (data) {
                    data.forEach(function (x) {
                        if (x.dateFrom)
                            x.dateFrom = _this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = _this.$qui.createDateFromString(x.dateTo);
                    });
                    _this.udfs = data;
                }).finally(function () {
                    _this.loading = false;
                });
            };
            TabSingletimeDirective.prototype.addSingletime = function () {
                this.timeframeForm.form = {
                    id: null,
                    objectId: null,
                    dateFrom: new Date(),
                    referenceId: this.reference.id
                };
                this.timeframeForm.state = 'new';
                $("#tabTimeframeModal-" + this.id).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            };
            TabSingletimeDirective.prototype.createTimeframe = function () {
                var _this = this;
                this.loading = true;
                this.udfService.createTabSingletime(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, { dateFrom: this.timeframeForm.form.dateFrom, dateTo: this.timeframeForm.form.dateTo }).then(function () {
                    _this.getUdfData();
                    _this.$qui.notify(_this.$qui.successNote);
                }).catch(function (e) {
                    console.error('Error creating singletime', e);
                    _this.loading = false;
                    _this.init();
                });
            };
            TabSingletimeDirective.prototype.deleteSingletime = function (udf) {
                var _this = this;
                this.promptOptions.itemText = this.createDateString(udf.dateFrom, udf.dateTo);
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    _this.loading = true;
                    _this.udfService.deleteTabSingletime(_this.reference.objectType, _this.reference.id, _this.definition.objectType, _this.definition.id, udf.timeFrameId).finally(function () { return _this.init(); });
                    $("#tab-singletime-form-modal-" + _this.id).modal('hide');
                }, "#udf-tab-singletime-delete-prompt-" + this.id);
            };
            TabSingletimeDirective.prototype.openSingletime = function (udf) {
                var _this = this;
                $("#tab-singletime-form-modal-" + this.id).modal('show');
                this.selectedUdf = undefined;
                this.$timeout(function () {
                    _this.selectedUdf = udf;
                });
                this.timeframeForm.form = {
                    dateFrom: udf.dateFrom,
                    dateTo: udf.dateTo,
                    referenceId: this.reference.id,
                    id: null,
                    objectId: null
                };
            };
            TabSingletimeDirective.prototype.createDateString = function (dateFrom, dateTo) {
                return this.ui.createDateString(dateFrom, dateTo);
            };
            TabSingletimeDirective.prototype.save = function (showNotification) {
                if (showNotification === void 0) { showNotification = true; }
                this.loading = true;
                this.saveTabs(showNotification);
                $("#tab-singletime-form-modal-" + this.id).modal('hide');
                this.init();
            };
            return TabSingletimeDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfTabSingletime', {
            templateUrl: 'UserDefinedFields/Tab_Singletime',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', 'QmcPermissionService', '$timeout', TabSingletimeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                save: '=',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var TabTimeframeDirective = /** @class */ (function () {
            function TabTimeframeDirective(scope, $qui, udfService, lng) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.timeframes = [];
                this.timeframesMap = [];
                this.timeframeForm = { state: 'new' };
                this.promptOptions = {
                    title: this.lng.translate(20036003, 'Zeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.timeframeValidation = {
                    isLoading: false,
                    errors: [],
                    warnings: []
                };
                this.ui = new Udf.UdfUi(this.lng);
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.loading = true;
                    _this.events();
                    _this.init();
                };
            }
            TabTimeframeDirective.prototype.init = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getTimeframes(this.definition.objectType, this.reference.id).then(function (data) {
                    var _a;
                    // sort timeframes by date and crete an appropriate object for the select
                    data.forEach(function (x) {
                        x.dateFrom = _this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = _this.$qui.createDateFromString(x.dateTo);
                    });
                    _this.timeframes = data;
                    _this.timeframesMap = data.sort(function (a, b) { return b.dateFrom.getTime() - a.dateFrom.getTime(); }).map(function (x) { return ({ text: _this.ui.createDateString(x.dateFrom, x.dateTo), value: x.objectId }); });
                    //if current timeframeId is not in the list of timeframes, select the first (most recent) one
                    if (!_this.timeframesMap.some(function (x) { return x.value === _this.timeframeId; }))
                        _this.timeframeIdSelect = (_a = _this.timeframesMap[0]) === null || _a === void 0 ? void 0 : _a.value;
                }).finally(function () {
                    _this.loading = false;
                });
            };
            TabTimeframeDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.timeframeIdSelect', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    var action = function () {
                        _this.timeframeId = newVal;
                    };
                    if (!oldVal || !_this.isTouched || !_this.hideSaveButton)
                        action();
                    else if (!_this.isValid) {
                        _this.promptOptions.itemText = '';
                        _this.promptOptions.text = _this.lng.translate(20002063, "Die eingegebenen Daten sind nicht valide und können nicht gespeichert werden. Möchten Sie die Eingaben anpassen?");
                        QMC.Common.Utilities.confirm(_this.promptOptions, function (data) {
                            if (!data)
                                action();
                            else
                                _this.timeframeIdSelect = oldVal;
                            $("#udf-tab-timeframe-prompt-" + _this.id).modal('hide');
                        }, "#udf-tab-timeframe-prompt-" + _this.id, true);
                    }
                    else {
                        _this.promptOptions.itemText = '';
                        _this.promptOptions.text = _this.lng.translate(20002064, "Es gibt nicht gespeicherte Änderungen. Möchten Sie diese vor dem Zeitraumwechsel speichern?");
                        QMC.Common.Utilities.confirm(_this.promptOptions, function (data) {
                            if (data) {
                                _this.save().then(action);
                            }
                            else {
                                action();
                            }
                        }, "#udf-tab-timeframe-prompt-" + _this.id);
                    }
                });
                this.scope.$watch('vm.timeframeForm.form', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.timeframeValidation = {
                        isLoading: true,
                        warnings: [],
                        errors: []
                    };
                    _this.udfService.valiadateTimeframe(_this.definition.objectType, _this.timeframeForm.form).then(function (data) {
                        _this.timeframeValidation.errors = data.errors;
                        _this.timeframeValidation.warnings = data.warnings;
                    }).catch(function (e) {
                        console.error('Error validating udf-timeframe', e);
                        _this.timeframeValidation.errors = [_this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                    }).finally(function () { return _this.timeframeValidation.isLoading = false; });
                }, true);
            };
            TabTimeframeDirective.prototype.addTimeframe = function () {
                this.timeframeForm.form = {
                    id: null,
                    objectId: null,
                    dateFrom: new Date(),
                    referenceId: this.reference.id
                };
                this.timeframeForm.state = 'new';
                $("#timeframeModal_" + this.id).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            };
            TabTimeframeDirective.prototype.openTimeframe = function (id) {
                this.timeframeForm.form = this.timeframes.find(function (x) { return x.objectId === id; });
                this.timeframeForm.state = 'edit';
                $("#timeframeModal_" + this.id).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            };
            TabTimeframeDirective.prototype.deleteTimeframe = function (id) {
                var _this = this;
                var item = this.timeframesMap.find(function (x) { return x.value === id; });
                if (!item)
                    return;
                this.promptOptions.itemText = item.text;
                this.promptOptions.text = this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?");
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    _this.loading = true;
                    _this.udfService.deleteTimeframe(_this.definition.objectType, id, _this.reference.id).catch(function (e) {
                        console.error('Error deleting timeframe', e);
                    }).finally(function () {
                        _this.init();
                    });
                }, "#udf-tab-timeframe-prompt-" + this.id);
            };
            TabTimeframeDirective.prototype.createTimeframe = function (form) {
                var _this = this;
                this.udfService.createTimeframe(this.definition.objectType, form).then(function (data) { return _this.timeframeIdSelect = data.createdObjectId; }).then(function () {
                    _this.$qui.notify(_this.$qui.successNote);
                }).finally(function () {
                    _this.init();
                });
            };
            TabTimeframeDirective.prototype.updateTimeframe = function (form) {
                var _this = this;
                this.udfService.updateTimeframe(this.definition.objectType, form.objectId, form).then(function () {
                    // workarround to update select components display
                    var tempId = _this.timeframeId;
                    _this.timeframeId = undefined;
                    _this.$qui.scopeApply(_this.scope);
                    _this.$qui.notify(_this.$qui.successNote);
                    setTimeout(function () { return _this.timeframeId = tempId; }, 250);
                }).finally(function () {
                    _this.init();
                });
            };
            return TabTimeframeDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfTabTimeframe', {
            templateUrl: 'UserDefinedFields/Tab_Timeframe',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', TabTimeframeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var TimeframeDirective = /** @class */ (function () {
            function TimeframeDirective(scope, $qui, udfService, lng, permissionService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.udfService = udfService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.id = '_' + Math.random().toString(36).substring(2, 11);
                this.permissions = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.timeframes = [];
                this.timeframesMap = [];
                this.timeframeForm = { state: 'new' };
                this.promptOptions = {
                    title: this.lng.translate(20036003, 'Zeitraum'),
                    yesNo: true,
                    icon: "qm-icon-form",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.timeframeValidation = {
                    isLoading: false,
                    errors: [],
                    warnings: []
                };
                this.ui = new Udf.UdfUi(this.lng);
                this.$postLink = function () {
                    if (!_this.reference || !_this.definition) {
                        console.warn('UDF: reference or defintion not set!', _this.reference, _this.definition);
                        return;
                    }
                    _this.loading = true;
                    _this.permissionService.getPermissionsByObjectTypes([_this.definition.objectType]).then(function (data) {
                        _this.permissions = data[0];
                        _this.events();
                        _this.init();
                        _this.save = function (showNotification, timeframeId) {
                            if (showNotification === void 0) { showNotification = true; }
                            if (!_this.udf)
                                return;
                            var saveObject = {
                                udfId: _this.udf.udfId,
                                dateFrom: _this.udf.dateFrom,
                                dateTo: _this.udf.dateTo,
                                values: {}
                            };
                            _this.udf.fields.forEach(function (field) {
                                saveObject.values[field.objectId] = field.values;
                            });
                            _this.loading = true;
                            return _this.udfService.updateUserDefinedField(_this.reference.objectType, _this.reference.id, _this.definition.objectType, _this.definition.id, saveObject, timeframeId !== null && timeframeId !== void 0 ? timeframeId : _this.timeframeId).then(function () {
                                if (showNotification)
                                    _this.$qui.notify(_this.$qui.successNote);
                                return true;
                            }).catch(function (e) {
                                console.error('Error saving udf', e);
                                return false;
                            }).finally(function () {
                                _this.getUdfData();
                            });
                        };
                    }).catch(function (e) {
                        console.error('Error loading udf', e);
                        _this.loading = false;
                    });
                };
            }
            TimeframeDirective.prototype.init = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getTimeframes(this.definition.objectType).then(function (data) {
                    var _a;
                    // sort timeframes by date and crete an appropriate object for the select
                    data.forEach(function (x) {
                        x.dateFrom = _this.$qui.createDateFromString(x.dateFrom);
                        if (x.dateTo)
                            x.dateTo = _this.$qui.createDateFromString(x.dateTo);
                    });
                    _this.timeframes = data;
                    _this.timeframesMap = data.sort(function (a, b) { return b.dateFrom.getTime() - a.dateFrom.getTime(); }).map(function (x) { return ({ text: _this.ui.createDateString(x.dateFrom, x.dateTo), value: x.objectId }); });
                    //if current timeframeId is not in the list of timeframes, select the first (most recent) one
                    if (!_this.timeframesMap.some(function (x) { return x.value === _this.timeframeId; }))
                        _this.timeframeId = (_a = _this.timeframesMap[0]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!_this.timeframeId || _this.timeframeId === QMC.Common.Constants.GUID_EMPTY)
                        _this.isValid = true;
                }).finally(function () {
                    _this.loading = false;
                });
                this.$qui.functionWaiter("ui.createForm", this);
            };
            TimeframeDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.timeframeId', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    var action = function () {
                        if (_this.timeframeId)
                            _this.getUdfData();
                        else
                            _this.udf = undefined;
                    };
                    if (!oldVal || !_this.isTouched || !_this.hideSaveButton)
                        action();
                    else if (!_this.isValid) {
                        _this.promptOptions.itemText = '';
                        _this.promptOptions.text = _this.lng.translate(20002063, "Die eingegebenen Daten sind nicht valide und können nicht gespeichert werden. Möchten Sie die Eingaben anpassen?");
                        QMC.Common.Utilities.confirm(_this.promptOptions, function (data) {
                            if (!data)
                                action();
                            else
                                _this.timeframeId = oldVal;
                            $("#udf-timeframe-prompt-" + _this.id).modal('hide');
                        }, "#udf-timeframe-prompt-" + _this.id, true);
                    }
                    else {
                        _this.promptOptions.itemText = '';
                        _this.promptOptions.text = _this.lng.translate(20002064, "Es gibt nicht gespeicherte Änderungen. Möchten Sie diese vor dem Zeitraumwechsel speichern?");
                        QMC.Common.Utilities.confirm(_this.promptOptions, function (data) {
                            if (data) {
                                _this.save(true, oldVal).then(action);
                            }
                            else {
                                action();
                            }
                        }, "#udf-timeframe-prompt-" + _this.id);
                    }
                });
                this.scope.$watch('vm.timeframeForm.form', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.timeframeValidation = {
                        isLoading: true,
                        warnings: [],
                        errors: []
                    };
                    _this.udfService.valiadateTimeframe(_this.definition.objectType, _this.timeframeForm.form).then(function (data) {
                        _this.timeframeValidation.errors = data.errors;
                        _this.timeframeValidation.warnings = data.warnings;
                    }).catch(function (e) {
                        console.error('Error validating udf-timeframe', e);
                        _this.timeframeValidation.errors = [_this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                    }).finally(function () { return _this.timeframeValidation.isLoading = false; });
                }, true);
            };
            TimeframeDirective.prototype.getUdfData = function () {
                var _this = this;
                this.loading = true;
                this.udfService.getUserDefinedField(this.reference.objectType, this.reference.id, this.definition.objectType, this.definition.id, this.timeframeId).then(function (data) {
                    _this.udf = data[0];
                }).finally(function () {
                    _this.loading = false;
                });
            };
            TimeframeDirective.prototype.addTimeframe = function () {
                this.timeframeForm.form = {
                    id: null,
                    objectId: null,
                    dateFrom: new Date()
                };
                this.timeframeForm.state = 'new';
                $("#timeframeModal_" + this.id).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            };
            TimeframeDirective.prototype.openTimeframe = function (id) {
                this.timeframeForm.form = this.timeframes.find(function (x) { return x.objectId === id; });
                this.timeframeForm.state = 'edit';
                $("#timeframeModal_" + this.id).modal('show');
                this.$qui.functionWaiter("ui.createForm", this);
            };
            TimeframeDirective.prototype.deleteTimeframe = function (id) {
                var _this = this;
                var item = this.timeframesMap.find(function (x) { return x.value === id; });
                if (!item)
                    return;
                this.promptOptions.itemText = item.text;
                this.promptOptions.text = this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?");
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    _this.loading = true;
                    _this.udfService.deleteTimeframe(_this.definition.objectType, id).catch(function (e) {
                        console.error('Error deleting timeframe', e);
                    }).finally(function () {
                        _this.init();
                    });
                }, "#udf-timeframe-prompt-" + this.id);
            };
            TimeframeDirective.prototype.createTimeframe = function (form) {
                var _this = this;
                this.udfService.createTimeframe(this.definition.objectType, form).then(function (data) { return _this.timeframeId = data.createdObjectId; }).then(function () {
                    _this.$qui.notify(_this.$qui.successNote);
                }).finally(function () {
                    _this.init();
                });
            };
            TimeframeDirective.prototype.updateTimeframe = function (form) {
                var _this = this;
                this.udfService.updateTimeframe(this.definition.objectType, form.objectId, form).then(function () {
                    // workarround to update select components display
                    var tempId = _this.timeframeId;
                    _this.timeframeId = undefined;
                    _this.$qui.notify(_this.$qui.successNote);
                    setTimeout(function () { return _this.timeframeId = tempId; }, 250);
                }).finally(function () {
                    _this.init();
                });
            };
            return TimeframeDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfTimeframe', {
            templateUrl: 'UserDefinedFields/Timeframe',
            controller: ['$scope', '$qui', 'QmcUdfService', 'QmcLanguageService', 'QmcPermissionService', TimeframeDirective],
            controllerAs: 'vm',
            bindings: {
                reference: '=',
                definition: '=',
                save: '=?',
                hideSaveButton: '=?',
                isTouched: '=?',
                isValid: '=?',
                disabled: '=?'
            }
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var ValueDisplayDirective = /** @class */ (function () {
            function ValueDisplayDirective(scope, $qui, lng, udfService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.lng = lng;
                this.udfService = udfService;
                this.value = '';
                this.wv = [];
                this.$postLink = function () {
                    _this.scope.$watch('vm.field.wvId', function () {
                        if (_this.field.fieldType === 40 || _this.field.fieldType === 60) { //wv
                            _this.udfService.getWv(_this.field.wvId).then(function (data) {
                                return _this.wv = data.map(function (x) { return ({ text: x.name, value: x.id }); });
                            }).catch(function () { return _this.wv = []; }).finally(function () { return _this.value = _this.getValueString(); });
                        }
                        if (_this.field.fieldType === 50 || _this.field.fieldType === 70) { //ds
                            _this.udfService.getDs(_this.field.wvId).then(function (data) {
                                return _this.wv = data.map(function (x) { return ({ text: x.caption, value: x.id }); });
                            }).catch(function () { return _this.wv = []; }).finally(function () { return _this.value = _this.getValueString(); });
                        }
                    });
                    _this.scope.$watch('vm.field.values', function (newVal, oldVal) {
                        if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                            return;
                        _this.getValue();
                    }, true);
                    _this.getValue();
                };
            }
            ValueDisplayDirective.prototype.getValue = function () {
                var _this = this;
                this.value = this.getValueString();
                // for media display the names of the files
                if ([80, 81, 82].includes(this.field.fieldType)) {
                    this.value = '';
                    if (this.field.values[0]) {
                        this.udfService.getUserDefinedFieldMedia(this.field.values[0]).then(function (data) {
                            _this.value = data.map(function (x) { return x.caption; }).join(', ');
                        });
                    }
                }
            };
            ValueDisplayDirective.prototype.getValueString = function () {
                var _this = this;
                var result = '';
                switch (this.field.fieldType) {
                    case 1: // decimal
                        result = this.$qui.qmcRounding(this.field.values[0]);
                        break;
                    case 2: // bool
                        result = this.field.values[0] ? '✔' : '';
                        break;
                    case 10: // date
                        result = this.field.values[0] ? moment(this.field.values[0]).format('DD.MM.YYYY') : '';
                        break;
                    case 12: // datetime
                        result = this.field.values[0] ? moment(this.field.values[0]).format('DD.MM.YYYY HH:mm') : '';
                        break;
                    case 15: // headline
                    case 16: // seperator
                        break;
                    case 40: // WV
                    case 60: // WV mutli
                    case 50: // DS
                    case 70: // DS multi
                        var captions_1 = [];
                        this.field.values.forEach(function (id) { var _a, _b; return captions_1.push((_b = (_a = _this.wv.find(function (x) { return x.value === id; })) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : ''); });
                        result = captions_1.join('; ');
                        break;
                    default:
                        result = this.field.values[0];
                        break;
                }
                return result;
            };
            return ValueDisplayDirective;
        }());
        angular.module('QMC.Udf').component('qmUdfValue', {
            controller: ['$scope', '$qui', 'QmcLanguageService', 'QmcUdfService', ValueDisplayDirective],
            controllerAs: 'vm',
            bindings: {
                field: '=',
            },
            template: '<span class="udf-inline-flex">\
			<strong>{{vm.field.caption}}</strong>\
			<span class="pull-right" style="word-break: break-word; max-height: 5em; text-align: right; overflow: hidden">{{vm.value}}</span>\
		</span>',
        });
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var UserDefinedFieldContainerType;
        (function (UserDefinedFieldContainerType) {
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Unsupported"] = -1] = "Unsupported";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Standard"] = 0] = "Standard";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Timeframe"] = 1] = "Timeframe";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["SingleTimeframe"] = 2] = "SingleTimeframe";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["Tab"] = 3] = "Tab";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["TabWithTimeFrame"] = 4] = "TabWithTimeFrame";
            UserDefinedFieldContainerType[UserDefinedFieldContainerType["TabWithSingleTimeframe"] = 5] = "TabWithSingleTimeframe";
        })(UserDefinedFieldContainerType || (UserDefinedFieldContainerType = {}));
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        var QmcUdfService = /** @class */ (function (_super) {
            __extends(QmcUdfService, _super);
            function QmcUdfService() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.cache = {
                    wv: {},
                    wvTimestamp: {},
                    ds: {},
                    dsTimestamp: {},
                    container: {},
                    containerTimestamp: {}
                };
                _this.modulePath = '/UserDefinedFields';
                return _this;
            }
            ///////////////// BASE /////////////////
            QmcUdfService.prototype.timestampExceedsThreshold = function (date, threshold) {
                var now = new Date();
                threshold = threshold !== null && threshold !== void 0 ? threshold : 5 * 60 * 1000; // 5min
                return (now.getTime() - date.getTime()) > threshold;
            };
            QmcUdfService.prototype.getWv = function (id) {
                var _this = this;
                var cache = this.cache.wv[id];
                if (cache) {
                    var deferred_1 = this.$q.defer();
                    if (cache === 'loading') {
                        setTimeout(function () { return deferred_1.resolve(_this.getWv(id)); }, 100);
                        return deferred_1.promise;
                    }
                    else if (!this.timestampExceedsThreshold(this.cache.wvTimestamp[id])) {
                        deferred_1.resolve(cache);
                        return deferred_1.promise;
                    }
                }
                this.cache.wv[id] = 'loading';
                return _super.prototype.get.call(this, "/WV/" + id, {}, function (data) {
                    data.forEach(function (x) {
                        x.id = x.id.toLocaleLowerCase();
                        x.objectId = x.objectId.toLocaleLowerCase();
                    });
                    _this.cache.wv[id] = data;
                    _this.cache.wvTimestamp[id] = new Date();
                    return data;
                });
            };
            QmcUdfService.prototype.getDs = function (id) {
                var _this = this;
                var cache = this.cache.ds[id];
                if (cache) {
                    var deferred_2 = this.$q.defer();
                    if (cache === 'loading') {
                        setTimeout(function () { return deferred_2.resolve(_this.getDs(id)); }, 100);
                        return deferred_2.promise;
                    }
                    else if (!this.timestampExceedsThreshold(this.cache.dsTimestamp[id])) {
                        deferred_2.resolve(cache);
                        return deferred_2.promise;
                    }
                }
                this.cache.ds[id] = 'loading';
                return _super.prototype.get.call(this, "/DataSource/" + id, {}, function (data) {
                    data.forEach(function (x) {
                        x.id = x.id.toLocaleLowerCase();
                        x.objectId = x.objectId.toLocaleLowerCase();
                    });
                    _this.cache.ds[id] = data;
                    _this.cache.dsTimestamp[id] = new Date();
                    return data;
                });
            };
            ///////////////// Standard /////////////////
            QmcUdfService.prototype.getUserDefinedFieldDefintion = function (definitionObjectType, definitionId) {
                return _super.prototype.get.call(this, "/" + this.modulePath + "/" + definitionObjectType + "/" + definitionId, {}, function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.getUserDefinedFields = function (referenceObjectType) {
                var _this = this;
                var cache = this.cache.container[referenceObjectType];
                if (cache) {
                    var deferred_3 = this.$q.defer();
                    if (cache === 'loading') {
                        setTimeout(function () { return deferred_3.resolve(_this.getUserDefinedFields(referenceObjectType)); }, 100);
                        return deferred_3.promise;
                    }
                    // threshold is 1min
                    else if (!this.timestampExceedsThreshold(this.cache.containerTimestamp[referenceObjectType], 60000)) {
                        deferred_3.resolve(cache);
                        return deferred_3.promise;
                    }
                }
                this.cache.container[referenceObjectType] = 'loading';
                return _super.prototype.get.call(this, "/" + this.modulePath + "/" + referenceObjectType, {}, function (data) {
                    _this.cache.container[referenceObjectType] = data;
                    _this.cache.containerTimestamp[referenceObjectType] = new Date();
                    return data;
                });
            };
            QmcUdfService.prototype.getUserDefinedField = function (referenceObjectType, referenceId, definitionObjectType, definitionId, timeframe, createDefaults) {
                return _super.prototype.get.call(this, "/" + this.modulePath + "/" + referenceObjectType + "/" + referenceId + "/" + definitionObjectType + "/" + definitionId, { timeframe: timeframe, createDefaults: createDefaults }, function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.updateUserDefinedField = function (referenceObjectType, referenceId, definitionObjectType, definitionId, data, timeframe) {
                return _super.prototype.put.call(this, "/" + this.modulePath + "/" + referenceObjectType + "/" + referenceId + "/" + definitionObjectType + "/" + definitionId + "?" + (timeframe ? 'timeframe=' + timeframe : ''), data).then(function (data) {
                    return data;
                });
            };
            ///////////////// TIMEFRAME /////////////////
            QmcUdfService.prototype.getTimeframes = function (definitionObjectType, referenceId) {
                return _super.prototype.get.call(this, "/" + this.modulePath + "/Timeframe/" + definitionObjectType, { referenceId: referenceId }, function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.createTimeframe = function (definitionObjectType, data) {
                return _super.prototype.post.call(this, "/" + this.modulePath + "/Timeframe/" + definitionObjectType, data).then(function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.updateTimeframe = function (definitionObjectType, timeframeId, data) {
                return _super.prototype.put.call(this, "/" + this.modulePath + "/Timeframe/" + definitionObjectType + "/" + timeframeId, data).then(function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.deleteTimeframe = function (definitionObjectType, timeframeId, referenceId) {
                return _super.prototype.delete.call(this, "/" + this.modulePath + "/Timeframe/" + definitionObjectType + "/" + timeframeId + "?referenceId=" + referenceId).then(function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.valiadateTimeframe = function (definitionObjectType, data) {
                return _super.prototype.post.call(this, "/" + this.modulePath + "/Timeframe/Validation/" + definitionObjectType, data).then(function (data) {
                    return data;
                });
            };
            ///////////////// SINGLETIME /////////////////
            QmcUdfService.prototype.createSingletime = function (referenceObjectType, referenceId, definitionObjectType, definitionId, data) {
                return _super.prototype.post.call(this, "/" + this.modulePath + "/Singletime/" + referenceObjectType + "/" + referenceId + "/" + definitionObjectType + "/" + definitionId, data).then(function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.deleteSingletime = function (referenceObjectType, referenceId, definitionObjectType, definitionId, singletimeId) {
                return _super.prototype.delete.call(this, "/" + this.modulePath + "/Singletime/" + referenceObjectType + "/" + referenceId + "/" + definitionObjectType + "/" + definitionId + "/" + singletimeId).then(function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.createTabSingletime = function (referenceObjectType, referenceId, definitionObjectType, definitionId, data) {
                return _super.prototype.post.call(this, "/" + this.modulePath + "/Singletime/Tabs/" + referenceObjectType + "/" + referenceId + "/" + definitionObjectType + "/" + definitionId, data).then(function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.deleteTabSingletime = function (referenceObjectType, referenceId, definitionObjectType, definitionId, singletimeId) {
                return _super.prototype.delete.call(this, "/" + this.modulePath + "/Singletime/Tabs/" + referenceObjectType + "/" + referenceId + "/" + definitionObjectType + "/" + definitionId + "/" + singletimeId).then(function (data) {
                    return data;
                });
            };
            ///////////////// Tabs /////////////////
            QmcUdfService.prototype.getTabs = function (definitionObjectType) {
                return _super.prototype.get.call(this, "/" + this.modulePath + "/Tabs/" + definitionObjectType, {}, function (data) {
                    return data;
                });
            };
            ///////////////// Media /////////////////
            QmcUdfService.prototype.getUserDefinedFieldMedia = function (mediaId) {
                return _super.prototype.get.call(this, "/" + this.modulePath + "/Media/" + mediaId, {}, function (data) {
                    return data;
                });
            };
            QmcUdfService.prototype.postUserDefinedFieldMedia = function (data) {
                return _super.prototype.post.call(this, "/" + this.modulePath + "/Media", data).then(function (data) { return data; });
            };
            QmcUdfService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Udf', 'QmcUdfService')
            ], QmcUdfService);
            return QmcUdfService;
        }(QMC.Common.BaseService));
        Udf.QmcUdfService = QmcUdfService;
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Udf;
    (function (Udf) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        var UdfUi = /** @class */ (function (_super) {
            __extends(UdfUi, _super);
            function UdfUi(lng) {
                var _this = _super.call(this) || this;
                _this.lng = lng;
                /**
                * Client detail info form
                * @memberOf UserInterface
                */
                _this.timeframeForm = {
                    form: [{
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            required: true,
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: false
                            }
                        }],
                    actions: {
                        put: "updateTimeframe",
                        post: "createTimeframe"
                    }
                };
                return _this;
            }
            UdfUi.prototype.createDateString = function (dateFrom, dateTo) {
                var format = 'DD.MM.YYYY';
                if (dateFrom && dateTo)
                    return moment(dateFrom).format(format) + ' - ' + moment(dateTo).format(format);
                else if (dateFrom && !dateTo)
                    return this.lng.translate(20000124, 'Ab') + ' ' + moment(dateFrom).format(format);
                else if (!dateFrom && dateTo)
                    return this.lng.translate(20000125, 'Bis') + ' ' + moment(dateTo).format(format);
                else
                    return this.lng.translate(20000324, 'Unbestimmt');
            };
            return UdfUi;
        }(QMC.Common.UserInterface));
        Udf.UdfUi = UdfUi;
    })(Udf = QMC.Udf || (QMC.Udf = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Common;
    (function (Common) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        var DocumentDetailUI = /** @class */ (function (_super) {
            __extends(DocumentDetailUI, _super);
            function DocumentDetailUI() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
        * Client detail document table
        * @memberOf UserInterface
        */
                _this.attachedFilesTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Dateiname": {
                            "label": "fileName",
                            "dType": "string",
                            "lngTag": "21006017"
                        },
                        "Dateigröße": {
                            "label": "fileSize",
                            "dType": "string",
                            "lngTag": "21006018"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload"
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "allowPreview"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteFile"
                            }, {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-document_attachment"
                        },
                        "text": {
                            "label": "fileName",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "date",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload"
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "view"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            },
                            {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }
                        ]
                    },
                    "data": null,
                };
                return _this;
            }
            return DocumentDetailUI;
        }(Common.UserInterface));
        Common.DocumentDetailUI = DocumentDetailUI;
    })(Common = QMC.Common || (QMC.Common = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        var DocumentFolderStructureDirective = /** @class */ (function () {
            function DocumentFolderStructureDirective($qui, lng, permissionService, stammdatenService, userService, $state, $timeout) {
                var _this = this;
                this.$qui = $qui;
                this.lng = lng;
                this.permissionService = permissionService;
                this.stammdatenService = stammdatenService;
                this.userService = userService;
                this.$state = $state;
                this.$timeout = $timeout;
                this.restrict = 'E';
                this.templateUrl = './Documents/DocumentFolderStructure';
                this.replace = true;
                this.scope = {
                    qmParent: '=',
                    qmObjectType: '=',
                    qmParentObjectType: '=',
                    qmCreate: '=',
                    qmPersonMode: '=?'
                };
                this.link = function (scope) {
                    scope.vm = scope;
                    scope.id = Math.random().toString(36).substring(2, 11);
                    scope.idDeletePrompt = 'promptDeleteDocumentDirective_' + scope.id;
                    scope.showFolderStructure = true;
                    scope.loading = {
                        folder: false,
                        permission: false
                    };
                    scope.wv = {
                        documentTypeWvList: [],
                        mainCategoryWvList: [],
                        subCategoryWvList: []
                    };
                    scope.fileObject = {
                        id: null,
                        objectId: null,
                        base64String: null,
                        date: null,
                        documentId: null,
                        fileName: null,
                    };
                    scope.ui = new QMC.Common.DocumentDetailUI();
                    scope.firstLoad = true;
                    scope.directiveCreated = false;
                    scope.fileChoser = {
                        files: []
                    };
                    scope.$watch('qmParent', function (newVal, oldVal) {
                        if (newVal === oldVal && scope.directiveCreated)
                            return;
                        scope.directiveCreated = false;
                        scope.qmCreate();
                    });
                    scope.$watch('qmObjectType', function (newVal, oldVal) {
                        if (newVal === oldVal || !newVal)
                            return;
                        scope.directiveCreated = false;
                        scope.qmCreate();
                    });
                    scope.qmCreate = function () {
                        var createdFor = {
                            objectType: scope.qmObjectType,
                            parent: scope.qmParent
                        };
                        if (!scope.qmObjectType || JSON.stringify(scope.createdFor) === JSON.stringify(createdFor))
                            return;
                        scope.createdFor = createdFor;
                        scope.initForm();
                        scope.loading.permission = true;
                        _this.permissionService.getPermissionsByObjectTypes([scope.qmObjectType, 920002, 905002, 905004]).then(function (data) {
                            var _a, _b;
                            //920002 - Web Dokumente herunterladen
                            //905002 - Dokumentenverwaltung - Ordner
                            scope.moduleAccess = ((_a = data[0]) === null || _a === void 0 ? void 0 : _a.moduleAccess) && ((_b = data[0]) === null || _b === void 0 ? void 0 : _b.view);
                            scope.new = data[0].new && data[2].new;
                            scope.modify = data[0].modify && data[2].modify;
                            scope.delete = data[0].delete && data[2].delete;
                            scope.print = data[0].print;
                            scope.webAllowDownload = data[1].openFile;
                            scope.newFolder = scope.new;
                            scope.showMappings = data[3].view;
                            scope.foldersTreeList = [];
                            scope.foldersTreeListHierarchyEdit = [];
                            scope.lastFolderSelected = undefined;
                            scope.loading.folder = false;
                            scope.ui.attachedFilesTable.data = [];
                            _this.$qui.functionWaiter("ui.createTable", scope);
                            if (scope.qmParent === null || scope.qmParent === undefined) {
                                return;
                            }
                            _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                                scope.shouldLoadTableData = ltd;
                                if (scope.shouldLoadTableData) {
                                    scope.getData();
                                }
                            });
                            scope.$watch('form.mainCategoryId', function (newVal, oldVal) {
                                if (newVal != oldVal) {
                                    scope.getSubCategoryList();
                                }
                            }, true);
                            scope.selectedFolderHierarchyId = QMC.Common.Constants.GUID_EMPTY;
                            scope.selectedFolderId = QMC.Common.Constants.GUID_EMPTY;
                            scope.hierachyTitle = _this.lng.translate(21006021, "Kein übergeordneter Ordner");
                            $('#edit-form-document-' + scope.qmParent + scope.id).on('hidden.bs.modal', function () {
                                scope.hierachyTitle = _this.lng.translate(21006021, "Kein übergeordneter Ordner");
                            });
                            scope.$watch('fileChoser.files', function () {
                                if (scope.fileChoser.files && scope.fileChoser.files.length > 0) {
                                    scope.fileObject.fileName = scope.fileChoser.files[0].name;
                                    scope.fileObject.base64String = scope.fileChoser.files[0].base64;
                                    scope.postFileToFolder(scope.selectedFolderId);
                                    scope.fileChoser.files = [];
                                }
                            }, true);
                            scope.loading.permission = false;
                            _this.$qui.scopeApply(scope);
                            if (scope.showMappings) {
                                _this.stammdatenService.getDocumentMappingForObjecttype(scope.qmObjectType).then(function (data) {
                                    scope.mappings = data;
                                });
                            }
                        });
                        scope.directiveCreated = true;
                    };
                    //setValidationBack - in some cases (like for Tasks) the directive (with its Dialogs and so on) is included in another Dialog/Form that has to validate if the form.$invalid is false before
                    //allowing the user to save. since the folder structure form has also its own internal validation, the main dialog/form finds that the folder structure form is not valid and set $invalid to true also for it
                    //the user is not allowed to save so this trick is "pausing" the folder structure form validation on creating the directive and resets the validation back when the user wants to create or edit a folder
                    scope.initForm = function (setValidationBack) {
                        if (setValidationBack === void 0) { setValidationBack = false; }
                        scope.formStateDocuDirective = "new";
                        scope.documentListItem = {
                            id: scope.qmParent,
                            objectId: scope.qmParent,
                            version: null,
                            date: null,
                            title: null,
                            subTitle: null,
                            isPrivate: false,
                            mainCategory: null,
                            parentObjectType: scope.qmParentObjectType,
                            objectType: scope.qmObjectType
                        };
                        scope.document = {
                            id: scope.qmParent,
                            objectId: scope.qmParent,
                            version: null,
                            title: null,
                            subTitle: null,
                            comment: "",
                            isPrivate: false,
                            documentTypeId: null,
                            attachedDocuments: [],
                            parentObjectType: scope.qmParentObjectType,
                            objectType: scope.qmObjectType
                        };
                        scope.form = {
                            id: scope.qmParent,
                            parentObjectId: null,
                            fkParentHierarchy: QMC.Common.Constants.GUID_EMPTY,
                            documentTypeId: setValidationBack ? null : QMC.Common.Constants.GUID_EMPTY,
                            mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                            subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                            objectId: null,
                            version: null,
                            title: setValidationBack ? null : "You should never see me!",
                            subTitle: null,
                            comment: null,
                            isPrivate: false,
                            attachedDocuments: null,
                            parentObjectType: scope.qmParentObjectType,
                            objectType: scope.qmObjectType
                        };
                        scope.selectedFolderHierarchyId = QMC.Common.Constants.GUID_EMPTY;
                        _this.$qui.scopeApply(scope);
                    };
                    /************** UI HELPER *************/
                    scope.getData = function (noFolderCreation) {
                        if (noFolderCreation === void 0) { noFolderCreation = false; }
                        scope.backupForm = null;
                        scope.loading.folder = true;
                        _this.stammdatenService.getDocumentList(scope.qmParent).then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var caption;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!(!noFolderCreation && scope.moduleAccess && !scope.qmPersonMode && !(data === null || data === void 0 ? void 0 : data.length) && !scope.addingFolder)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.userService.getUserSettings(['DOKUMENTE.TREE.NameForAutoCreatedFolder'], false)];
                                    case 1:
                                        caption = (_b = (_a = (_c.sent())[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : this.lng.translate(20013157, 'Allgemein');
                                        scope.form = {
                                            id: scope.qmParent,
                                            parentObjectId: null,
                                            fkParentHierarchy: QMC.Common.Constants.GUID_EMPTY,
                                            mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                                            subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                                            objectId: null,
                                            version: null,
                                            title: caption,
                                            subTitle: null,
                                            comment: null,
                                            isPrivate: false,
                                            attachedDocuments: null,
                                            parentObjectType: scope.qmParentObjectType,
                                            objectType: scope.qmObjectType
                                        };
                                        scope.addDocFolder(false);
                                        _c.label = 2;
                                    case 2:
                                        scope.foldersTreeList = data;
                                        scope.foldersTreeListHierarchyEdit = angular.copy(data);
                                        if (!scope.lastFolderSelected) {
                                            scope.changeFolder(data[0]);
                                        }
                                        else {
                                            scope.changeFolder(scope.lastFolderSelected);
                                        }
                                        // decide wether or not folder structure should be visible
                                        scope.showFolderStructure = (data.length > 1 || scope.qmPersonMode);
                                        scope.loading.folder = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    };
                    scope.getSubCategoryList = function () {
                        var data = [];
                        if (scope.wv.subCategoryWvList) {
                            for (var _i = 0, _a = scope.wv.subCategoryWvList; _i < _a.length; _i++) {
                                var element = _a[_i];
                                if ((element.parentWvId === scope.form.mainCategoryId) && !(/^\s*$/).test(element.name)) {
                                    data.push(element);
                                }
                            }
                            scope.subCategoryWvList = data.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                            if (data.length === 0) {
                                scope.form.subCategoryId = QMC.Common.Constants.GUID_EMPTY;
                            }
                        }
                    };
                    scope.openMappingsModal = function () {
                        $("#mappingsModal" + scope.id).modal('show');
                    };
                    /************** Folder Functions *************/
                    scope.changeFolder = function (data) {
                        if (!data) {
                            scope.newFolder = scope.new;
                            return;
                        }
                        ;
                        $('#' + scope.selectedFolderId).removeClass('active-folder');
                        scope.selectedFolderId = data.id;
                        scope.lastFolderSelected = data;
                        scope.getFolder(data);
                        var toggler = document.getElementsByClassName("qm-subfolders");
                        if (scope.firstLoad) {
                            scope.getDocumentUserConfig();
                        }
                        else {
                            for (var _i = 0, _a = Array.from(toggler); _i < _a.length; _i++) {
                                var element = _a[_i];
                                if (element.id === data.id) {
                                    element.parentElement.querySelector(".nested").classList.toggle("active");
                                    element.parentElement.querySelector(".foldername").classList.toggle("foldername-down");
                                }
                            }
                        }
                        scope.firstLoad = false;
                        $('#' + scope.selectedFolderId).addClass('active-folder');
                    };
                    scope.getEditFolderHierarchy = function () {
                        scope.formStateDocuDirective = "edit";
                        if (!scope.form.parentObjectId && scope.backupForm) {
                            scope.selectedFolderHierarchyId = scope.backupForm.fkParentHierarchy;
                            scope.form = scope.backupForm;
                        }
                        else {
                            scope.form.fkParentHierarchy = scope.selectedFolderHierarchyId;
                        }
                        scope.foldersTreeListHierarchyEdit = angular.copy(scope.foldersTreeList);
                        scope.hideUnderFolders();
                        scope.getSelectedHierarchyName();
                        if (scope.selectedFolderHierarchyId != QMC.Common.Constants.GUID_EMPTY) {
                            scope.hierachyTitle = _this.lng.translate(21006019, "Untergeordnet von") + ": " + scope.hierachyTitle;
                        }
                        else {
                            scope.hierachyTitle = _this.lng.translate(21006021, "Kein übergeordneter Ordner");
                        }
                        document.getElementById('untergeordnetVon' + scope.id).setAttribute("collapse", "close");
                    };
                    scope.hideUnderFolders = function (hierarchyFolder) {
                        if (hierarchyFolder === void 0) { hierarchyFolder = null; }
                        if (!hierarchyFolder) {
                            for (var i = scope.foldersTreeListHierarchyEdit.length - 1; i >= 0; i--) {
                                if (scope.foldersTreeListHierarchyEdit[i].id === scope.form.id) {
                                    if (scope.foldersTreeListHierarchyEdit[i].children != null) {
                                        scope.foldersTreeListHierarchyEdit[i].children.splice(0, scope.foldersTreeListHierarchyEdit[i].children.length);
                                    }
                                }
                                else if (scope.foldersTreeListHierarchyEdit[i].children != null) {
                                    scope.hideUnderFolders(scope.foldersTreeListHierarchyEdit[i].children);
                                }
                            }
                        }
                        else {
                            for (var i = hierarchyFolder.length - 1; i >= 0; i--) {
                                if (hierarchyFolder[i].id === scope.form.id) {
                                    if (hierarchyFolder[i].children != null) {
                                        hierarchyFolder[i].children.splice(0, hierarchyFolder[i].children.length);
                                    }
                                }
                                else if (hierarchyFolder[i].children != null) {
                                    scope.hideUnderFolders(hierarchyFolder[i].children);
                                }
                            }
                        }
                    };
                    scope.getSelectedHierarchyName = function (hierarchyFolder) {
                        if (hierarchyFolder === void 0) { hierarchyFolder = null; }
                        if (hierarchyFolder === null) {
                            var folders = scope.foldersTreeListHierarchyEdit.filter(function (x) { return x.objectId === scope.form.fkParentHierarchy; });
                            if (folders.length > 0) {
                                scope.hierachyTitle = folders[0].title;
                            }
                            else {
                                for (var i = scope.foldersTreeListHierarchyEdit.length - 1; i >= 0; i--) {
                                    var folders_1 = scope.foldersTreeListHierarchyEdit[i].children.filter(function (x) { return x.objectId === scope.form.fkParentHierarchy; });
                                    if (folders_1.length > 0) {
                                        scope.hierachyTitle = folders_1[0].title;
                                        break;
                                    }
                                    else if (scope.foldersTreeListHierarchyEdit[i].children != null) {
                                        scope.getSelectedHierarchyName(scope.foldersTreeListHierarchyEdit[i].children);
                                    }
                                }
                            }
                        }
                        else {
                            for (var i = hierarchyFolder.length - 1; i >= 0; i--) {
                                var folders = hierarchyFolder[i].children.filter(function (x) { return x.objectId === scope.form.fkParentHierarchy; });
                                if (folders.length > 0) {
                                    scope.hierachyTitle = folders[0].title;
                                    break;
                                }
                                else if (hierarchyFolder[i].children != null) {
                                    scope.getSelectedHierarchyName(hierarchyFolder[i].children);
                                }
                            }
                        }
                    };
                    scope.selectFolderHierarchy = function (data) {
                        if (data.id != scope.selectedFolderId || scope.formStateDocuDirective === "new") {
                            $('#' + scope.selectedFolderHierarchyId).removeClass('active-folder');
                            if (scope.selectedFolderHierarchyId === data.id) {
                                scope.selectedFolderHierarchyId = QMC.Common.Constants.GUID_EMPTY;
                                scope.form.fkParentHierarchy = scope.selectedFolderHierarchyId;
                            }
                            else {
                                scope.selectedFolderHierarchyId = data.id;
                                scope.form.fkParentHierarchy = scope.selectedFolderHierarchyId;
                            }
                            scope.getSelectedHierarchyName();
                            if (scope.selectedFolderHierarchyId != QMC.Common.Constants.GUID_EMPTY) {
                                scope.hierachyTitle = _this.lng.translate(21006019, "Untergeordnet von") + ": " + scope.hierachyTitle;
                            }
                            else {
                                scope.hierachyTitle = _this.lng.translate(21006021, "Kein übergeordneter Ordner");
                            }
                            $('#' + scope.selectedFolderHierarchyId).addClass('active-folder');
                        }
                    };
                    scope.saveDocFolderChanges = function () {
                        if (scope.formStateDocuDirective === "edit") {
                            scope.putDocFolder();
                        }
                        else {
                            scope.addDocFolder();
                        }
                    };
                    /************** Service Functions *************/
                    scope.addDocFolder = function (showNotification) {
                        if (showNotification === void 0) { showNotification = true; }
                        scope.addingFolder = true;
                        scope.form.parentObjectId = scope.qmParent;
                        scope.form.isPrivate = true;
                        scope.form.date = new Date();
                        _this.stammdatenService.postNewDocument(scope.form).then(function (dataDocFolder) {
                            scope.formStateDocuDirective = "new";
                            if (showNotification)
                                _this.$qui.notify(_this.$qui.successNote);
                        }).finally(function () { return _this.$timeout(function () {
                            scope.getData(true);
                            scope.addingFolder = false;
                        }); });
                    };
                    scope.putDocFolder = function () {
                        scope.form.parentObjectId = scope.qmParent;
                        _this.stammdatenService.editDocument(scope.qmParent, scope.form.objectId, scope.form).then(function (e) {
                            _this.$qui.notify(_this.$qui.successNote);
                            scope.getData(true);
                        });
                    };
                    scope.deleteDocFolder = function () {
                        scope.promptOptions = {
                            title: _this.lng.translate(21006026, "Ordner löschen"),
                            yesNo: true,
                            icon: "qm-icon-history2",
                            text: _this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                            itemText: scope.form.title
                        };
                        var containerId = scope.form.id;
                        QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                            if (data)
                                setTimeout(_this.stammdatenService.deleteDocument(scope.qmParent, containerId).then(function () {
                                    scope.lastFolderSelected = null;
                                    _this.$qui.notify(_this.$qui.deleteNote);
                                    $('#edit-form-document-' + scope.qmParent + scope.id).modal('hide');
                                    scope.getData(true);
                                }), 300);
                        }, "#" + scope.idDeletePrompt);
                    };
                    scope.getWv = function () {
                        scope.wv = {
                            documentTypeWvList: [],
                            mainCategoryWvList: [],
                            subCategoryWvList: []
                        };
                        _this.stammdatenService.getDocumentWV().then(function (data) {
                            scope.wv = data;
                            scope.documentTypeWvList = scope.wv.documentTypeWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                            scope.mainCategoryWvList = scope.wv.mainCategoryWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        });
                    };
                    scope.getWv();
                    scope.getDocumentUserConfig = function () {
                        _this.stammdatenService.getDocumentsUserConfig().then(function (data) {
                            scope.documentUserConfig = data;
                            if (!scope.documentUserConfig.folderStructureIsCollapsable) {
                                var toggler = document.getElementsByClassName("qm-subfolders");
                                for (var _i = 0, _a = Array.from(toggler); _i < _a.length; _i++) {
                                    var element = _a[_i];
                                    if (element.parentElement.querySelector(".nested"))
                                        element.parentElement.querySelector(".nested").classList.toggle("active");
                                    if (element.parentElement.querySelector(".foldername"))
                                        element.parentElement.querySelector(".foldername").classList.toggle("foldername-down");
                                }
                                _this.$qui.scopeApply(scope);
                            }
                        });
                    };
                    scope.postFileToFolder = function (docuId) {
                        $('#uploadingScreen' + scope.id).modal('show');
                        scope.fileObject.documentId = docuId;
                        scope.fileObject.date = new Date();
                        scope.fileObject.objectType = scope.qmObjectType;
                        _this.stammdatenService.addFileToDocument(scope.fileObject).then(function () {
                            _this.$qui.notify(_this.$qui.successNote, _this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                            $('#uploadingScreen' + scope.id).modal('hide');
                            scope.getData(true);
                        });
                    };
                    scope.getFolder = function (dataFolder) {
                        var containerId = dataFolder.id;
                        var folderIsTemplate = dataFolder.fkTemplate !== QMC.Common.Constants.GUID_EMPTY;
                        _this.stammdatenService.getDocument(scope.qmParent, containerId).then(function (dataDocument) {
                            _this.permissionService.getMediaPermissions(scope.qmObjectType, QMC.Common.Constants.WV_DOCUMENT_RUBRIC, dataDocument.mainCategoryId).then(function (dataPermFolder) {
                                scope.newFolder = dataPermFolder[0].new && scope.new;
                                scope.modifyFolder = dataPermFolder[0].modify && !folderIsTemplate && scope.moduleAccess && scope.modify;
                                scope.deleteFolder = dataPermFolder[0].delete && scope.delete && dataDocument.attachedDocuments.length === 0 && !_this.hasChildren(dataDocument, scope.foldersTreeList);
                                scope.newFile = dataPermFolder[0].new;
                                scope.deleteFile = dataPermFolder[0].delete;
                                scope.allowPreview = dataPermFolder[0].openFile;
                                scope.allowDownload = dataPermFolder[0].openFile && scope.webAllowDownload;
                                scope.printFile = dataPermFolder[0].print;
                                scope.form = angular.copy(dataDocument);
                                scope.backupForm = angular.copy(dataDocument);
                                if (dataFolder.fkParentHierarchy != null) {
                                    scope.selectedFolderHierarchyId = dataFolder.fkParentHierarchy;
                                }
                                else {
                                    scope.selectedFolderHierarchyId = dataFolder.id;
                                }
                                if (scope.form) {
                                    scope.form.fkParentHierarchy = scope.selectedFolderId;
                                    scope.backupForm.fkParentHierarchy = scope.selectedFolderHierarchyId;
                                }
                                scope.hierachyTitle = _this.lng.translate(21006021, "Kein übergeordneter Ordner");
                                if (dataPermFolder[0].view) {
                                    scope.documentType = _this.getWvName(dataDocument.documentTypeId, scope.wv);
                                    scope.mainCategory = _this.getWvName(dataDocument.mainCategoryId, scope.wv);
                                    scope.subCategory = _this.getWvName(dataDocument.subCategoryId, scope.wv);
                                    for (var _i = 0, _a = dataDocument.attachedDocuments; _i < _a.length; _i++) {
                                        var element = _a[_i];
                                        element.fileSize = _this.fileSizeConvert(element.fileSize);
                                    }
                                    dataDocument.attachedDocuments.forEach(function (x) { return x.stateLink = _this.createStateLink(x, scope.qmParent); });
                                    scope.ui.attachedFilesTable.data = dataDocument.attachedDocuments;
                                    _this.$qui.functionWaiter("ui.createTable", scope);
                                }
                            });
                        }).catch(function () {
                            scope.initForm();
                            scope.newFolder = scope.new;
                            scope.modifyFolder = false;
                            scope.ui.attachedFilesTable.data = [];
                            _this.$qui.functionWaiter("ui.createTable", scope);
                        });
                    };
                    /************** File handling *************/
                    scope.previewDocument = function (dataFile) {
                        scope.downloadFile(dataFile, true);
                    };
                    scope.downloadFile = function (dataFile, prev) {
                        if (prev === void 0) { prev = false; }
                        scope.fileInfos = undefined;
                        $('#downloadingScreen' + scope.id).modal('show');
                        _this.stammdatenService.downloadAttachment(scope.selectedFolderId, dataFile.objectId).then(function (data) {
                            $('#downloadingScreen' + scope.id).modal('hide');
                            try {
                                var filename = "datei";
                                for (var _i = 0, _a = scope.form.attachedDocuments; _i < _a.length; _i++) {
                                    var document_1 = _a[_i];
                                    if (document_1.objectId === data.objectId) {
                                        filename = document_1.fileName;
                                    }
                                }
                                // get filename suffix and contenttype
                                var temp = filename.split('.');
                                var ext = temp[temp.length - 1];
                                scope.fileInfos = {
                                    base64: data.base64,
                                    fileType: ext,
                                    fileName: filename
                                };
                                _this.$qui.scopeApply(scope);
                                if (prev)
                                    $('#previewModal' + scope.id).modal('show');
                                else {
                                    var blob = _this.$qui.base64ToBlob(scope.fileInfos.base64, _this.$qui.extToMime(scope.fileInfos.fileType));
                                    _this.$qui.downloadBlob(scope.fileInfos.fileName, blob);
                                }
                            }
                            catch (e) {
                                console.log("downloadDocument Fehler: ", e);
                                _this.$qui.notify({
                                    message: e,
                                    title: 'Download Error',
                                    icon: 'qm-icon-error',
                                    status: 'warning',
                                    timer: 10000
                                });
                            }
                        });
                    };
                    scope.deleteFileFromFolder = function (dataFile) {
                        //a small change for a new pull request
                        $('#loadingScreen' + scope.id).modal('toggle');
                        $('.modal-backdrop').remove();
                        scope.promptOptions = {
                            title: _this.lng.translate(21006027, "Datei löschen"),
                            yesNo: true,
                            icon: "qm-icon-history2",
                            text: _this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                            itemText: dataFile.fileName
                        };
                        if (!dataFile.referenceId || dataFile.referenceId === QMC.Common.Constants.GUID_EMPTY) {
                            scope.promptOptions.text += "\r\n" + _this.lng.translate(21006031, 'Alle ggf. verlinktem Dokumente werden hierbei ebenfalls gelöscht.');
                        }
                        QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                            if (data) {
                                setTimeout(function () {
                                    $('.modal-backdrop').remove();
                                    _this.stammdatenService.deleteFile(scope.selectedFolderId, dataFile.objectId).then(function (data) {
                                        _this.$qui.notify(_this.$qui.deleteNote);
                                        scope.getData(true);
                                    });
                                }, 300);
                            }
                        }, "#" + scope.idDeletePrompt);
                    };
                    scope.openReference = function (data) {
                        if (!data.stateLink)
                            return;
                        _this.$state.go(data.stateLink.state, { id: data.stateLink.parentId, dataId: data.stateLink.referenceId });
                    };
                    scope.$on('$destroy', function () {
                        // remove all modals
                        $('#previewModal' + scope.id).remove();
                        $('#uploadingScreen' + scope.id).remove();
                        $('#downloadingScreen' + scope.id).remove();
                        $('#untergeordnetVon' + scope.id).remove();
                        $('#edit-form-document-' + scope.qmParent + scope.id).remove();
                        $('promptDeleteDocumentDirective_' + scope.id).remove();
                    });
                    scope.getSubFolderDocumentCount = function (folder) {
                        var _a;
                        var getChildren = function (members) {
                            var children = [];
                            var flattenMembers = members.map(function (m) {
                                var _a;
                                if ((_a = m.children) === null || _a === void 0 ? void 0 : _a.length) {
                                    children = __spreadArrays(children, m.children);
                                }
                                return m;
                            });
                            return flattenMembers.concat(children.length ? getChildren(children) : children);
                        };
                        var allFolders = __spreadArrays([folder], getChildren((_a = folder.children) !== null && _a !== void 0 ? _a : []));
                        return allFolders.reduce(function (prev, current) { return (prev + current.documentCount); }, 0);
                    };
                };
            }
            DocumentFolderStructureDirective.prototype.createStateLink = function (data, parentId) {
                if (!data.referenceObjectType || !data.referenceId)
                    return undefined;
                var state = '';
                switch (data.referenceObjectType) {
                    case 120002:
                        state = 'employee.address';
                        break;
                    case 120004:
                        state = 'employee.communication';
                        break;
                    case 120012:
                        state = 'employee.contactperson';
                        break;
                    case 120020:
                        state = 'employee.checklist';
                        break;
                    case 120046:
                        state = 'employee.vaccination';
                        break;
                    case 140002:
                        state = 'detail.disease';
                        break;
                    case 140003:
                        state = 'detail.doctorsvisit';
                        break;
                    case 140005:
                        state = 'detail.vaccination';
                        break;
                    case 140006:
                        state = 'detail.contactperson';
                        break;
                    case 140021:
                        state = 'detail.address';
                        break;
                    case 140023:
                        state = 'detail.communication';
                        break;
                    case 140027:
                        state = 'detail.legal';
                        break;
                    case 140057:
                        state = 'detail.checklist';
                        break;
                    case 140068:
                        state = 'detail.education';
                        break;
                    default: return undefined;
                }
                return {
                    state: state,
                    parentId: parentId,
                    referenceId: data.referenceId
                };
            };
            DocumentFolderStructureDirective.prototype.hasChildren = function (folder, foldersTreeList) {
                for (var _i = 0, foldersTreeList_1 = foldersTreeList; _i < foldersTreeList_1.length; _i++) {
                    var element = foldersTreeList_1[_i];
                    if (element.id === folder.id) {
                        return element.children.length > 0;
                    }
                }
                return false;
            };
            DocumentFolderStructureDirective.prototype.fileSizeConvert = function (sizeInBytes) {
                if (sizeInBytes === 0) {
                    return '0 Bytes';
                }
                ;
                var kbUnit = 1024;
                var usedSizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                var i = Math.floor(Math.log(sizeInBytes) / Math.log(kbUnit));
                return parseFloat((sizeInBytes / Math.pow(kbUnit, i)).toFixed(2)) + ' ' + usedSizes[i];
            };
            DocumentFolderStructureDirective.prototype.getWvName = function (id, wv) {
                var wvObjNames = ['documentTypeWvList', 'mainCategoryWvList', 'subCategoryWvList'];
                for (var _i = 0, wvObjNames_1 = wvObjNames; _i < wvObjNames_1.length; _i++) {
                    var wvName = wvObjNames_1[_i];
                    for (var _a = 0, _b = wv[wvName]; _a < _b.length; _a++) {
                        var element = _b[_a];
                        if (element.id !== null) {
                            if (id === element.id)
                                return element.name;
                        }
                    }
                }
                return "";
            };
            DocumentFolderStructureDirective = __decorate([
                QMC.Directive('QMC.Documents', 'qmDocumentFolderStructure', ['$qui', 'QmcLanguageService', 'QmcPermissionService', 'StammdatenService', 'UserService', '$state', '$timeout'])
            ], DocumentFolderStructureDirective);
            return DocumentFolderStructureDirective;
        }());
        Documents.DocumentFolderStructureDirective = DocumentFolderStructureDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        var DocumentViewerDirective = /** @class */ (function () {
            function DocumentViewerDirective($qui, permissionService) {
                var _this = this;
                this.$qui = $qui;
                this.permissionService = permissionService;
                this.restrict = 'E';
                this.templateUrl = './Documents/DocumentViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmFileType: '=',
                    qmReportFileId: '='
                };
                this.link = function (scope) {
                    scope.allowDownload = false;
                    _this.permissionService.getPermissionsByObjectType(920002).then(function (data) {
                        scope.allowDownload = data[0].openFile;
                        scope.allowPrint = data[0].print;
                    });
                    scope.prepareViewing = false;
                    scope.$watch('qmData', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.$watch('qmFileName', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.$watch('qmFileType', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.downloadBase64 = function () {
                        var temp = scope.qmFileName.split('.');
                        var ext = scope.qmFileType;
                        if (temp.length > 1)
                            ext = temp[temp.length - 1];
                        var contentType = _this.$qui.extToMime(ext);
                        _this.$qui.notify(_this.$qui.downloadNote);
                        var blob = _this.$qui.base64ToBlob(scope.qmData, contentType);
                        _this.$qui.downloadBlob(scope.qmFileName, blob);
                    };
                };
            }
            DocumentViewerDirective.prototype.handleFile = function (scope) {
                scope.prepareViewing = true;
                scope.error = undefined;
                if (scope.qmData && scope.qmFileName && scope.qmFileType)
                    scope.prepareViewing = false;
                else
                    scope.error = 'Keine Vorschau möglich';
            };
            DocumentViewerDirective = __decorate([
                QMC.Directive('QMC.Documents', 'qmDocumentViewer', ['$qui', 'QmcPermissionService'])
            ], DocumentViewerDirective);
            return DocumentViewerDirective;
        }());
        Documents.DocumentViewerDirective = DocumentViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        var PdfViewerDirective = /** @class */ (function () {
            function PdfViewerDirective($qui) {
                var _this = this;
                this.$qui = $qui;
                this.restrict = 'E';
                this.templateUrl = './Documents/PdfViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmScale: '@',
                    qmPage: '@',
                    qmCallback: '&',
                    qmCallbackButton: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = function (scope) {
                    scope.qmScale = 1.5;
                    scope.qmPage = 1;
                    scope.qmId = "_" + Math.random().toString(36).substr(2, 9);
                    scope.$watch("qmData", function (newVal, oldVal) {
                        //if (newVal === oldVal) return;
                        if (!scope.qmData) {
                            scope.qmPdf = undefined;
                            return;
                        }
                        var pdfPath = URL.createObjectURL(this.$qui.base64ToBlob(scope.qmData, 'application/pdf'));
                        console.log("pdf path", scope);
                        if (pdfPath !== (null || undefined))
                            scope.openPdf(pdfPath);
                    }.bind(_this));
                    scope.openPdf = function (pdfPath) {
                        var pdfjsLib = window['pdfjs-dist/build/pdf'];
                        pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(new Blob([window['pdfjs-dist/build/pdf.worker'], 'application/javascript']));
                        var loadingTask = pdfjsLib.getDocument(pdfPath);
                        loadingTask.promise.then(function (_pdf) {
                            console.log('PDF loaded', _pdf);
                            scope.qmPdf = _pdf;
                            scope.renderPdfPage(1);
                        }).catch(function (e) {
                            scope.qmPdf = "error";
                            console.log('PDF error', e);
                        });
                    };
                    scope.renderPdfPage = function (num) {
                        scope.qmPage = num;
                        // Using promise to fetch the page
                        scope.qmPdf.getPage(num).then(function (page) {
                            var viewport = page.getViewport({ scale: scope.qmScale });
                            var cParent = document.getElementById('pdfCanvas' + scope.qmId).parentElement;
                            cParent.removeChild(document.getElementById('pdfCanvas' + scope.qmId));
                            var newCanvas = document.createElement('canvas');
                            newCanvas.id = 'pdfCanvas' + scope.qmId;
                            cParent.appendChild(newCanvas);
                            var height = isNaN(window.innerHeight) ? document.body.clientHeight : window.innerHeight - 150;
                            newCanvas.height = viewport.height;
                            newCanvas.width = viewport.width;
                            document.getElementById('canvasContainer').setAttribute("style", "height:" + height + "px; overflow-y:scroll;");
                            // Render PDF page into canvas context
                            var renderContext = {
                                canvasContext: newCanvas.getContext('2d'),
                                viewport: viewport
                            };
                            var renderTask = page.render(renderContext);
                            // Wait for rendering to finish
                            renderTask.promise.then(function () {
                                $qui.scopeApply(scope);
                            });
                        });
                    };
                    scope.downloadPdfFile = function () {
                        scope.qmPdf.getData().then(function (result) {
                            console.log("pdf.data", result);
                            var blob = new Blob([result], { type: "application/pdf" });
                            var link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = scope.qmFileName.endsWith('.pdf') ? scope.qmFileName : scope.qmFileName + '.pdf';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        });
                    };
                    scope.print = function () {
                        scope.qmPdf.getData().then(function (result) {
                            var blob = new Blob([result], { type: "application/pdf" });
                            var iframe = document.createElement('iframe');
                            document.body.appendChild(iframe);
                            iframe.style.display = 'none';
                            iframe.onload = function () {
                                setTimeout(function () {
                                    iframe.focus();
                                    iframe.contentWindow.print();
                                    iframe.addEventListener('close', function () { iframe.remove(); });
                                }, 1);
                            };
                            iframe.src = window.URL.createObjectURL(blob);
                        });
                    };
                };
            }
            PdfViewerDirective = __decorate([
                QMC.Directive('QMC.Documents', 'qmPdfViewer', ['$qui'])
            ], PdfViewerDirective);
            return PdfViewerDirective;
        }());
        Documents.PdfViewerDirective = PdfViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        var SpreadViewerDirective = /** @class */ (function () {
            function SpreadViewerDirective($qui, reportingService) {
                var _this = this;
                this.$qui = $qui;
                this.reportingService = reportingService;
                this.restrict = 'EA';
                this.templateUrl = './Documents/SpreadViewer';
                this.replace = true;
                this.scope = {
                    qmSpread: '=',
                    qmSpreadName: '=',
                    qmSpreadId: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = function (scope) {
                    scope.$on('$destroy', function () {
                        $('#spreadDownloadNameModal').remove();
                    });
                    var elementId = 'spreadsheetViewer';
                    var reportingService = _this.reportingService;
                    var $qui = _this.$qui;
                    scope.loading = true;
                    scope.chkbx = {
                        editable: true
                    };
                    var location = window.location.href.substring(0, window.location.href.indexOf('#'));
                    if (!location.endsWith('/'))
                        location = location + '/';
                    var igScripts = [
                        location + 'igniteui/js/infragistics.core.js',
                        location + 'igniteui/js/infragistics.lob.js',
                        location + 'igniteui/js/infragistics.excel-bundled.js',
                        location + 'igniteui/js/infragistics.spreadsheet-bundled.js'
                    ];
                    // Detect if library loaded
                    function isLoadedScript(lib) {
                        return document.querySelectorAll('[src="' + lib + '"]').length > 0;
                    }
                    // Load library
                    function loadScript(lib) {
                        console.log('loading Script', lib);
                        var script = document.createElement('script');
                        script.async = false;
                        script.setAttribute('src', lib);
                        document.getElementsByTagName('body')[0].prepend(script);
                        return script;
                    }
                    for (var i = 0; i < igScripts.length; i++) {
                        if (!isLoadedScript(igScripts[i])) {
                            loadScript(igScripts[i]);
                        }
                    }
                    function openSpreadFile() {
                        scope.errortext = undefined;
                        $.ig.excel.Workbook.load(scope.qmSpread, function (workbook) {
                            if ($("#" + elementId).igSpreadsheet !== undefined && workbook !== null) {
                                //load specific workbook
                                $("#" + elementId).igSpreadsheet("option", "workbook", workbook);
                            }
                            $qui.scopeApply(scope);
                        }, function (error) {
                            console.error("IG:", error, scope.qmSpread);
                            scope.errortext = error + ' ';
                            $("#" + elementId).igSpreadsheet("destroy");
                            $qui.scopeApply(scope);
                        });
                    }
                    function allScriptsLoaded() {
                        for (var i = 0; i < igScripts.length; i++) {
                            if (!isLoadedScript(igScripts[i]) || typeof $("#" + elementId).igSpreadsheet !== 'function' || !$.ig) {
                                return false;
                            }
                        }
                        return true;
                    }
                    function initSpreadsheet() {
                        if (!allScriptsLoaded()) {
                            setTimeout(function () {
                                initSpreadsheet();
                            }, 250);
                            return;
                        }
                        $("#" + elementId).igSpreadsheet({
                            height: window.innerHeight - 100 + "",
                            width: "100%",
                            language: "de",
                            isFormulaBarVisible: scope.chkbx.editable,
                            editModeEntering: function (e, args) {
                                return scope.chkbx.editable;
                            }
                        });
                        $('.ui-igspreadsheet-formulabartextareasplitter').click(function (event) {
                            event.preventDefault();
                        });
                        scope.loading = false;
                        scope.$watch("chkbx.editable", function (oldVal, newVal) {
                            if (oldVal === newVal)
                                return;
                            $("#" + elementId).igSpreadsheet("option", "isFormulaBarVisible", scope.chkbx.editable);
                        });
                        if (scope.qmSpread && scope.qmSpread.length > 0)
                            openSpreadFile();
                        $qui.scopeApply(scope);
                    }
                    window.onresize = function () { initSpreadsheet(); };
                    function handleFileChange() {
                        if (!allScriptsLoaded()) {
                            setTimeout(function () { initSpreadsheet(); }, 250);
                            return;
                        }
                        setTimeout(function () {
                            initSpreadsheet();
                            openSpreadFile();
                        }, 50);
                    }
                    scope.$watch("qmSpread", function () {
                        if (scope.qmSpread === undefined)
                            return;
                        if (scope.qmSpread === null)
                            return;
                        handleFileChange();
                    });
                    scope.$watch("qmSpreadName", function () {
                        if (scope.qmSpreadName.includes('.')) {
                            if (scope.originalName === undefined) {
                                scope.originalName = scope.originalName === scope.qmSpreadName ? scope.originalName : scope.qmSpreadName;
                                scope.originalSuffix = scope.originalName.split('.')[scope.originalName.split('.').length - 1];
                                scope.qmSpreadName = scope.originalName.substring(0, scope.originalName.lastIndexOf('.'));
                            }
                        }
                        $qui.scopeApply(scope);
                    }, true);
                    scope.removeInvalidChars = function (fileName) {
                        var fileNameNoWhiteSpace = fileName.replace(/[\s]/g, "_");
                        return fileNameNoWhiteSpace.replace(/[\/\?\#\[\]\@\!\$\&\§\'\(\)\*\+\,\;\:\=]/g, "-"); //vgl: https://stackoverflow.com/questions/2366260/whats-valid-and-whats-not-in-a-uri-query
                    };
                    function downloadFile(data, suffix) {
                        var name = scope.qmSpreadName;
                        if (suffix && !name.endsWith(suffix)) {
                            name += suffix;
                        }
                        if (window.navigator.userAgent.indexOf("MSIE") > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                            window.navigator.msSaveOrOpenBlob(data, name);
                        }
                        else {
                            var blobUrl_1 = URL.createObjectURL(data);
                            var a_1 = document.createElement('a');
                            a_1.style = "display: none";
                            document.body.append(a_1);
                            a_1.href = blobUrl_1;
                            a_1.download = name;
                            a_1.target = '_blank';
                            a_1.click();
                            setTimeout(function () {
                                window.URL.revokeObjectURL(blobUrl_1);
                                document.body.removeChild(a_1);
                            }, 4E4);
                        }
                    }
                    ;
                    scope.downloadPdfFile = function () {
                        $('#genericLoadingModal').modal('show');
                        reportingService.getFinishedSpreadServerJobAsPdf(scope.qmSpreadId, scope.qmSpreadName).then(function (data) {
                            downloadFile($qui.base64ToBlob(data.base64, 'application/pdf'), '.pdf');
                            $('#genericLoadingModal').modal('hide');
                        }).catch(function (e) {
                            $('#genericLoadingModal').modal('hide');
                            console.error(e);
                        });
                    };
                    scope.downloadSpreadFile = function () {
                        // make sure to change cell before saving since the component needs a cellchange to flush the current content into its datamodell
                        var cell = $("#" + elementId).igSpreadsheet("option", "activeCell");
                        cell = cell === 'A1' ? 'A2' : 'A1';
                        $("#" + elementId).igSpreadsheet("option", "activeCell", cell);
                        $("#" + elementId).igSpreadsheet('option', 'workbook')
                            .save({ type: 'blob' }, function (data) {
                            downloadFile(data, scope.originalSuffix ? '.' + scope.originalSuffix : '.xlsx');
                        }, function (error) {
                            console.warn('Fehler beim Download: : ' + error); //testweise
                        });
                    };
                    scope.downloadOriginalSpreadFile = function () {
                        var _a;
                        console.log(scope.qmSpreadName, scope.originalSuffix);
                        var name = scope.removeInvalidChars(scope.qmSpreadName);
                        if (scope.originalSuffix)
                            name += '.' + scope.originalSuffix;
                        else {
                            name += '.xlsx';
                        }
                        var blob = _this.$qui.base64ToBlob(scope.qmSpread, _this.$qui.extToMime((_a = scope.originalSuffix) !== null && _a !== void 0 ? _a : 'xlsx'));
                        _this.$qui.downloadBlob(name, blob);
                    };
                    scope.print = function () {
                        var area = document.getElementsByClassName('ui-igspreadsheet-formulabar')[0].nextSibling.cloneNode(true);
                        // dont show tab item area
                        area.childNodes.forEach(function (x) {
                            var cl = x.classList;
                            if (cl.contains('ui-igspreadsheet-tabitemarea')) {
                                x.remove();
                            }
                        });
                        var iframe = document.createElement('iframe');
                        document.body.appendChild(iframe);
                        iframe.style.display = 'none';
                        iframe.onload = function () {
                            setTimeout(function () {
                                iframe.contentDocument.title = scope.qmSpreadName;
                                var style = iframe.contentWindow.document.createElement('style');
                                style.type = 'text/css';
                                style.innerText = '@page {size: auto; margin: 0;}/* div {border: 1px solid lightgrey;}*/';
                                iframe.contentWindow.document.head.appendChild(style);
                                iframe.contentWindow.document.body.appendChild(area);
                                iframe.focus();
                                iframe.contentWindow.print();
                                iframe.addEventListener('close', function () { iframe.remove(); });
                            }, 1);
                        };
                        iframe.src = '';
                    };
                };
            }
            SpreadViewerDirective = __decorate([
                QMC.Directive('QMC.Documents', 'qmSpreadViewer', ['$qui', 'ReportingService'])
            ], SpreadViewerDirective);
            return SpreadViewerDirective;
        }());
        Documents.SpreadViewerDirective = SpreadViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        var ImageViewerDirective = /** @class */ (function () {
            function ImageViewerDirective($qui) {
                var _this = this;
                this.$qui = $qui;
                this.restrict = 'E';
                this.templateUrl = './Documents/ImageViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmFileType: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = function (scope) {
                    scope.prepareViewing = false;
                    scope.$watch('qmData', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.$watch('qmFileName', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.$watch('qmFileType', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.downloadBase64 = function () {
                        var contentType = scope.getMimeType();
                        _this.$qui.notify(_this.$qui.downloadNote);
                        var blob = _this.$qui.base64ToBlob(scope.qmData, contentType);
                        _this.$qui.downloadBlob(scope.qmFileName, blob);
                    };
                    scope.getMimeType = function () {
                        var mime = _this.$qui.extToMime(scope.qmFileType);
                        if (!mime || mime.length === 0) {
                            var temp = scope.qmFileName.split('.');
                            if (temp.length < 2) {
                                scope.error = true;
                            }
                            var ext = temp[temp.length - 1];
                            mime = _this.$qui.extToMime(ext);
                        }
                        return mime;
                    };
                    _this.handleFile(scope);
                    scope.print = function () {
                        var win = window.open('', '');
                        win.document.write([
                            '<html>',
                            '   <head>',
                            '   </head>',
                            '   <body onload="window.print()" onafterprint="window.close()">',
                            '       <img src="' + scope.src + '"/>',
                            '   </body>',
                            '</html>'
                        ].join(''));
                        win.document.close();
                    };
                };
            }
            ImageViewerDirective.prototype.handleFile = function (scope) {
                scope.error = false;
                if (scope.qmData && scope.qmFileName) {
                    scope.src = "data:" + scope.getMimeType() + ";base64," + scope.qmData;
                }
                else {
                    scope.error = true;
                }
            };
            ImageViewerDirective = __decorate([
                QMC.Directive('QMC.Documents', 'qmImageViewer', ['$qui'])
            ], ImageViewerDirective);
            return ImageViewerDirective;
        }());
        Documents.ImageViewerDirective = ImageViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Documents;
    (function (Documents) {
        var TextViewerDirective = /** @class */ (function () {
            function TextViewerDirective($qui, $sce, mediaService, lngService) {
                var _this = this;
                this.$qui = $qui;
                this.$sce = $sce;
                this.mediaService = mediaService;
                this.lngService = lngService;
                this.restrict = 'E';
                this.templateUrl = './Documents/TextViewer';
                this.replace = true;
                this.scope = {
                    qmData: '=',
                    qmFileName: '=',
                    qmFileType: '=',
                    qmDisableDownload: '=',
                    qmDisablePrint: '='
                };
                this.link = function (scope) {
                    scope.callbackButton = {
                        label: _this.lngService.translate(21006014, 'Herunterladen'),
                        icon: 'fa fa-download'
                    };
                    scope.prepareViewing = false;
                    scope.$watch('qmData', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.$watch('qmFileName', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.$watch('qmFileType', function (newVal, oldVal) {
                        if (newVal !== oldVal)
                            _this.handleFile(scope);
                    });
                    scope.downloadBase64 = function () {
                        var contentType = scope.getMimeType();
                        _this.$qui.notify(_this.$qui.downloadNote);
                        var blob = _this.$qui.base64ToBlob(scope.qmData, contentType);
                        _this.$qui.downloadBlob(scope.qmFileName, blob);
                    };
                    scope.getMimeType = function () {
                        var mime = _this.$qui.extToMime(scope.qmFileType);
                        if (!mime || mime.length === 0) {
                            var temp = scope.qmFileName.split('.');
                            if (temp.length < 2) {
                                scope.error = true;
                            }
                            var ext = temp[temp.length - 1];
                            mime = _this.$qui.extToMime(ext);
                        }
                        return mime;
                    };
                    _this.handleFile(scope);
                    scope.print = function () {
                        var win = window.open('', '');
                        win.document.write([
                            '<html>',
                            '   <head>',
                            '   </head>',
                            '   <body onload="window.print()" onafterprint="window.close()">',
                            '       ' + document.getElementById('textViewerPrintArea').innerHTML +
                                '   </body>',
                            '</html>'
                        ].join(''));
                        win.document.close();
                    };
                };
            }
            TextViewerDirective.prototype.handleFile = function (scope) {
                scope.error = false;
                scope.loading = false;
                scope.html = undefined;
                scope.pdf = undefined;
                if (scope.qmData && scope.qmFileName) {
                    // directly supported files could be shown directly (ach was *facepalm*)
                    if (['txt', 'text', 'html'].includes(scope.qmFileType)) {
                        scope.html = this.$sce.trustAsHtml(atob(scope.qmData));
                    }
                    // others get translated by api to html
                    else {
                        scope.loading = true;
                        this.mediaService.convertToPdf(scope.qmData, scope.qmFileType).then(function (data) {
                            scope.pdf = data;
                            scope.loading = false;
                        });
                    }
                }
                else {
                    scope.error = true;
                }
            };
            TextViewerDirective = __decorate([
                QMC.Directive('QMC.Documents', 'qmTextViewer', ['$qui', '$sce', 'QmcMediaService', 'QmcLanguageService'])
            ], TextViewerDirective);
            return TextViewerDirective;
        }());
        Documents.TextViewerDirective = TextViewerDirective;
    })(Documents = QMC.Documents || (QMC.Documents = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../maps/qmc.common.js.map
